export const trTranslations: Record<string, string> = {
  'nav.dashboard': 'Gösterge Paneli',
  'nav.projects': 'Projeler',
  'nav.eduflow': 'EduFlow',
  'nav.audiobooks': 'Sesli Kitaplar',
  'nav.audio_studio': 'Ses Stüdyosu',
  'nav.store': 'Mağaza',
  'nav.analytics': 'Analitik',
  'nav.users': 'Kullanıcılar',
  'nav.settings': 'Ayarlar',
  'nav.profile': 'Profil',
  'profile.institution': 'Kurum',
  'profile.institutionHint': 'Sizin LyrraOne hesap is linked to bu kurum. Bu bağlantı is managed tarafından sizin yönetici.',
  'profile.institutionUnknownName': 'Kurum (ad mevcut değil)',
  'nav.notifications': 'Bildirimler',
  'nav.help': 'Yardım',
  'nav.community': 'Topluluk',
  'nav.library': 'Kütüphane',
  'nav.certificates': 'Sertifikalar',
  'nav.institution': 'Kurum',
  'nav.groups': 'Gruplar',
  'nav.learners': 'Öğrenciler',
  'nav.myLearning': 'Öğrenmem',
  'nav.reports': 'Raporlar',
  'nav.qualiopi': 'Qualiopi',
  'nav.training_plan': 'Eğitim Planı',
  'nav.catalog': 'Katalog',
  'nav.competencies': 'Yetkinlikler',
  'nav.budget': 'Bütçe',
  'nav.campaigns': 'Kampanyalar',
  'nav.codir': 'CODIR',
  'nav.home': 'Ana Sayfa',
  'nav.producerAssignments': 'Üretim görevleri',
  'nav.videos': 'Videolar',
  'nav.sounds': 'Sesler',
  'nav.images': 'Görseller',
  'pages.images.title': 'Görseller',
  'pages.images.pasteHint': 'Veya ekran görüntüsü yapıştırın (Ctrl+V / Cmd+V)',
  'pages.images.emptyHint': 'Sürükle ve bırak, tıkla to içe aktar, veya paste bir screenshot (Ctrl+V / Cmd+V).',
  'pages.images.viewLarge': 'Tam boyutta görüntüle',
  'pages.images.lightboxTitle': 'Görsel önizleme',
  'pages.images.lightboxClose': 'Kapat',
  'pages.images.lightboxBackdropClose': 'Önizlemeyi kapat',
  'pages.images.lightboxPrev': 'Önceki görsel',
  'pages.images.lightboxNext': 'Sonraki görsel',
  'nav.documents': 'Belgeler',
  'nav.podcasts': 'Podcastler',
  'nav.webinars': 'Web Seminerleri',
  'nav.webinarsEnterprise': 'Web seminerleri (kuruluş)',
  'webinar.room.capacityFull': 'Bu room has reached its maximum capacity ({{max}} people connected at bir kez). Lütfen dene tekrar sonra.',
  'webinar.room.participants': 'Katılımcılar',
  'webinar.room.chat': 'Sohbet',
  'webinar.room.speechTab': 'Konuşma',
  'webinar.room.speechPanelHint': 'Text captured from presenters’ microphones (browser speech recognition). The ad shown is the person currently speaking.',
  'webinar.room.speechEmpty': 'Ne zaman bir presenter speaks ile the microphone on, onların words appear burada ile onların ad. Punctuation follows the browser’s transcript.',
  'webinar.room.speechUnknownSpeaker': 'Sunucu',
  'webinar.room.speechPresenterActive': 'Sizin voice is transcribed tarafından the browser ve gönderildi to katılımcılar (Speech sekme).',
  'webinar.room.speechUnsupportedBrowser': 'Otomatik presenter captions are değil mevcut in bu browser (dene Chrome veya Edge).',
  'webinar.room.sidePanelTabs': 'Katılımcılar, presenter speech, anket, ve sohbet',
  'webinar.room.you': 'siz',
  'webinar.room.showParticipantsPanel': 'Göster katılımcılar panel',
  'webinar.room.hideParticipantsPanel': 'Paneli daralt',
  'webinar.room.leave': 'Ayrıl room',
  'webinar.room.contentFocusExpand': 'Içerik fills the stage',
  'webinar.room.contentFocusCollapse': 'Göster backdrop ve presenters',
  'webinar.room.contentFocusAriaExpand': 'Genişlet paylaşıldı kurs, yüklendi belge veya screen paylaş dolu genişlik olmadan stage backdrop veya presenter cameras',
  'webinar.room.liveDocumentLabel': 'Yükle (PDF veya PowerPoint)',
  'webinar.room.liveDocumentUploadChoice': 'Seç bir dosya to display',
  'webinar.room.liveDocumentUploading': 'Yükleniyor…',
  'webinar.room.liveDocumentUploadError': 'Could değil yükle the dosya. Kontrol et the format (PDF veya PowerPoint) ve boyut (max 40 MB).',
  'webinar.room.liveDocumentClose': 'Kaldır belge',
  'webinar.room.liveDocumentBehindScreen': 'The belge stays mevcut — durdur screen paylaşılıyor to göster it tekrar.',
  'webinar.room.waitingSharedContentExtended': 'Bekleniyor için the presenter to paylaş bir catalog kurs, bir dosya (PDF veya PowerPoint), veya onların screen.',
  'webinar.room.liveDocumentOfficeHint': 'Eğer önizleme fails (plain HTTP locally veya oversized dosya), kullan the bağlantı üstünde.',
  'webinar.room.liveDocumentOpenOrDownload': 'birç veya indir the dosya',
  'webinar.room.liveDocumentNoInlinePreview': 'Bu dosya cannot be embedded automatically. birç it in bir yeni sekme.',
  'webinar.room.liveDocumentOpenTab': 'Aç',
  'webinar.room.pollTab': 'Anket',
  'webinar.room.poll.regionTitle': 'Web semineri anketi',
  'webinar.room.poll.presenterHint': 'Ekle bir soru ve 2–8 cevaplar. Everyone sees the anket burada; sadece hosts see live sonuçlar.',
  'webinar.room.poll.questionLabel': 'Soru',
  'webinar.room.poll.questionPlaceholder': 'E.g. Hangi konu should we cover sonraki?',
  'webinar.room.poll.optionsLabel': 'Cevap choices',
  'webinar.room.poll.optionNumber': 'Cevap',
  'webinar.room.poll.choiceLabel': 'Choice',
  'webinar.room.poll.addOption': 'Ekle bir cevap',
  'webinar.room.poll.removeLastOption': 'Kaldır son',
  'webinar.room.poll.launch': 'Başlangıç anket',
  'webinar.room.poll.waitingParticipant': 'Hayır aktif anket yet. The host can başlangıç one.',
  'webinar.room.poll.voteHint': 'One vote kaydedildi per person: you can değiştir sizin cevap tarafından picking another seçenek.',
  'webinar.room.poll.yourVote': 'sizin seç',
  'webinar.room.poll.resultsHeading': 'Sonuçlar (hosts)',
  'webinar.room.poll.noVotesYet': 'Hayır votes yet.',
  'webinar.room.poll.totalVotes': 'Toplam oy: {{n}}',
  'webinar.room.poll.closePoll': 'Anketi kapat',
  'webinar.room.contentFocusAriaCollapse': 'Geri yükle stage backdrop ve presenter sütun',
  'webinar.room.exitDirectTitle': 'Ayrıl bu web semineri?',
  'webinar.room.exitDirectMessage': 'You birçıldı bu room from bir direct bağlantı (değil from the gösterge paneli). You can kapat bu sekme. Eğer the browser bloklar kapatılıyor, you will be redirected to sizin ana sayfa area.',
  'webinar.room.exitDirectConfirm': 'Sekmeyi kapat',
  'webinar.room.publicGateTitle': 'Web semineri signup',
  'webinar.room.publicGateHint': 'The organizer etkin genel signup: gir sizin e-posta, choose bir şifre (min. 8 characters) ve tamamla the requested fields.',
  'webinar.room.publicGateEmail': 'E-posta',
  'webinar.room.publicGateLogin': 'Giriş',
  'webinar.room.publicGatePassword': 'Şifre',
  'webinar.room.publicGatePasswordHintParticipant': 'Ilk visit: registration. Sonraki visits: aynı e-posta ve şifre. Minimum 8 characters.',
  'webinar.room.publicGateSubmit': 'Odaya gir',
  'webinar.room.publicGateSubmitting': 'Doğrulanıyor…',
  'webinar.room.publicGateDenied': 'Yanlış e-posta veya şifre.',
  'webinar.room.socketGateDenied': 'Could değil join the live room: genel signup oturum missing veya süresi doldu. Reload the sayfa ve sign in tekrar ile the aynı e-posta ve şifre.',
  'nav.parcours': 'Öğrenme Yolları',
  'nav.eduflowList': 'Kurslar',
  'nav.section.pilotage': 'Genel Bakış',
  'nav.section.creation': 'Oluştur',
  'nav.section.medias': 'Medya',
  'nav.section.aide': 'Yardım',
  'sidebar.brandTagline': 'Eğitim',
  'sidebar.logoInstitutionAlt': 'Kuruluş logosu',
  'sidebar.expand': 'Menüyü genişlet',
  'sidebar.collapse': 'Menüyü daralt',
  'sidebar.expandAria': 'Kenar çubuğunu genişlet',
  'sidebar.collapseAria': 'Kenar çubuğunu daralt',
  'dashboard.kindPodcast': 'Podcast',
  'pages.learners.title': 'Öğrenciler',
  'pages.learners.description': 'Öğrencilerinizin ilerlemesini takip edin',
  'pages.learners.enrolledFormations': 'Kayıtlı kurslar',
  'pages.learners.notStarted': 'Başlanmadı',
  'pages.learners.startedOn': '{{date}} tarihinde başladı',
  'pages.learners.detailedTraces': 'Detaylı aktivite · {{flowTitle}}',
  'pages.learners.statsEvents': 'Olaylar: {{count}}',
  'pages.learners.statsResponses': 'Yanıtlar: {{count}}',
  'pages.learners.statsBlockSessions': 'Blok oturumları: {{count}}',
  'pages.learners.timePerBlock': 'Blok başına süre',
  'pages.learners.lastEvents': 'Son olaylar',
  'pages.learners.blockSessionInProgress': '(devam ediyor)',
  'pages.learners.blockTimeOnBlock': '(bu blokta {{duration}})',
  'pages.learners.trackingEvent.unknown': 'Olay',
  'pages.learners.trackingEvent.training_enter': 'Kursa girdi',
  'pages.learners.trackingEvent.training_exit': 'Kurstan ayrıldı veya kapattı',
  'pages.learners.trackingEvent.training_completed': 'Kursu tamamladı',
  'pages.learners.trackingEvent.block_enter': 'Bir bloğa girdi',
  'pages.learners.trackingEvent.block_exit': 'Bir bloktan ayrıldı',
  'pages.learners.trackingEvent.response_submitted': 'Bir yanıt gönderdi',
  'pages.learners.trackingEvent.progress_sync': 'İlerleme senkronize edildi',
  'pages.learners.refresh': 'Yenile',
  'pages.learners.exportCsv': 'CSV olarak dışa aktar',
  'pages.learners.statTotal': 'Toplam öğrenci',
  'pages.learners.statInProgress': 'Devam ediyor',
  'pages.learners.statCompleted': 'Tamamlandı',
  'pages.learners.statAvgProgress': 'Ort. ilerleme',
  'pages.learners.searchPlaceholder': 'Ad veya e-posta ile ara…',
  'pages.learners.filterAllFlows': 'Tüm kurslar',
  'pages.learners.sortRecent': 'En yeni',
  'pages.learners.sortName': 'Ad A-Z',
  'pages.learners.sortProgress': 'İlerleme',
  'pages.learners.colLearner': 'Öğrenci',
  'pages.learners.colFormations': 'Kurslar',
  'pages.learners.colProgress': 'İlerleme',
  'pages.learners.colCompleted': 'Tamamlandı',
  'pages.learners.colTime': 'Süre',
  'pages.learners.colLastAccess': 'Son erişim',
  'pages.learners.colActions': 'Eylemler',
  'pages.learners.openProgressDashboard': 'İlerleme gösterge paneli',
  'pages.learners.dashboardTitle': 'Öğrenci ilerlemesi',
  'pages.learners.dashboardBack': 'Listeye dön',
  'pages.learners.dashboardInvalidId': 'Geçersiz öğrenci kimliği',
  'pages.learners.dashboardNotFound': 'Öğrenci bulunamadı veya erişim reddedildi',
  'pages.learners.dashboardOverviewHint': 'Birleştirilmiş görünüm: Bu katılımcının kayıtlı olduğu EduFlow kursları ile aynı e-posta adresine sahip Lyrra hesabına atanmış öğrenme yolları ve podcastler.',
  'pages.learners.tabOverview': 'Genel Bakış',
  'pages.learners.tabFormations': 'Kurslar',
  'pages.learners.tabParcours': 'Yollar',
  'pages.learners.tabPodcasts': 'Podcastler',
  'pages.learners.sectionFormations': 'Kurslar',
  'pages.learners.sectionParcours': 'Öğrenme Yolları',
  'pages.learners.sectionPodcasts': 'Podcastler',
  'pages.learners.emptyParcours': 'Bu e-posta ile bir Lyrra kullanıcısına atanmış öğrenme yolu yok.',
  'pages.learners.emptyPodcasts': 'Bu e-posta ile bir Lyrra kullanıcısına atanmış podcast yok.',
  'pages.learners.linkedAccountHint': 'Yollar ve podcastler, bu katılımcıyla aynı e-postaya sahip bir Lyrra kullanıcısı olduğunda gösterilir.',
  'pages.learners.kpiEduflows': 'Kurslar',
  'pages.learners.kpiAvgProgress': 'Ort. ilerleme',
  'pages.learners.kpiPaths': 'Yollar',
  'pages.learners.kpiPodcasts': 'Podcastler',
  'pages.learners.kpiCompletedFormations': '{{count}} tamamlandı',
  'pages.learners.pathProgressLabel': '{{completed}} / {{total}} aktivite',
  'pages.learners.pathAssignedOn': '{{date}} tarihinde eklendi',
  'pages.learners.podcastCompleted': 'Tamamlandı',
  'pages.learners.podcastInProgress': 'Devam ediyor',
  'pages.learners.pathStatusPublished': 'Yayınlandı',
  'pages.learners.pathStatusDraft': 'Taslak',
  'pages.learners.openInDesigner': 'Tasarımcıda aç',
  'pages.learners.openParcoursEditor': 'Yolu aç',
  'pages.learners.viewPodcasts': 'Podcastleri görüntüle',
  'pages.learners.loading': 'Öğrenciler yükleniyor…',
  'pages.learners.loadError': 'Öğrenciler yüklenemedi',
  'pages.learners.retry': 'Tekrar Dene',
  'pages.learners.emptyFiltered': 'Öğrenci bulunamadı',
  'pages.learners.emptyFilteredHint': 'Arama veya filtreleri değiştirmeyi deneyin',
  'pages.learners.emptyNone': 'Henüz kayıtlı öğrenci yok',
  'pages.learners.emptyNoneHint': 'Öğrenciler yayınlanmış kurslarınıza kaydolduklarında burada görünecekler',
  'pages.learners.pagination': 'Sayfa {{page}} / {{totalPages}} · {{total}} öğrenci',
  'pages.learners.prev': 'Önceki',
  'pages.learners.next': 'İleri',
  'pages.learners.csvLastName': 'Soyad',
  'pages.learners.csvFirstName': 'Ad',
  'pages.learners.csvEmail': 'E-posta',
  'pages.learners.csvFormations': 'Kurslar',
  'pages.learners.csvAvgProgress': 'Ortalama ilerleme',
  'pages.learners.csvTotalTime': 'Toplam süre',
  'pages.learners.csvLastActivity': 'Son aktivite',
  'eduflowList.status.draft': 'Taslak',
  'eduflowList.status.published': 'Yayınlandı',
  'eduflowList.status.archived': 'Arşivlendi',
  'eduflowList.badge.enterpriseShell': 'Kurumsal istek',
  'eduflowList.badge.enterpriseLinked': 'Enterprise',
  'eduflowList.badge.toProduce': 'Üretilecek',
  'eduflow.list.blocksCount': '{{count}} blok',
  'eduflow.list.noContent': 'İçerik yok',
  'eduflow.list.minutesShort': '{{count}} min',
  'eduflow.list.tooltip.openMissions': 'Görevlerimi aç',
  'eduflow.list.tooltip.edit': 'Düzenle',
  'eduflow.list.shellHint': 'Kuruluşunuz tarafından tanımlanmış — kursu « Görevlerim » bölümünden oluşturun.',
  'breadcrumb.label': 'İçerik Haritası',
  'breadcrumb.home': 'Ana Sayfa',
  'breadcrumb.dashboard': 'Gösterge Paneli',
  'breadcrumb.projects': 'Projeler',
  'breadcrumb.eduflow': 'Kurslar',
  'breadcrumb.learners': 'Öğrenciler',
  'breadcrumb.analytics': 'Analitik',
  'breadcrumb.videos': 'Videolar',
  'breadcrumb.sounds': 'Sesler',
  'breadcrumb.images': 'Görseller',
  'breadcrumb.documents': 'Belgeler',
  'breadcrumb.store': 'Mağaza',
  'breadcrumb.help': 'Yardım',
  'breadcrumb.admin': 'Yönetim',
  'breadcrumb.settings': 'Ayarlar',
  'breadcrumb.profile': 'Profil',
  'breadcrumb.groups': 'Gruplar',
  'breadcrumb.branding': 'Marka Kimliği',
  'breadcrumb.landingPage': 'Açılış sayfası',
  'breadcrumb.webhooks': 'Web Kancaları',
  'breadcrumb.campaigns': 'Kampanyalar',
  'breadcrumb.competencies': 'Yetkinlikler',
  'breadcrumb.compliance': 'Uyumluluk',
  'breadcrumb.reports': 'Raporlar',
  'breadcrumb.budget': 'Bütçe',
  'breadcrumb.catalog': 'Katalog',
  'breadcrumb.integrations': 'Entegrasyonlar',
  'breadcrumb.requests': 'İstekler',
  'breadcrumb.team': 'Ekip',
  'breadcrumb.reviews': 'Değerlendirmeler',
  'breadcrumb.training': 'Eğitim',
  'breadcrumb.skills': 'Beceriler',
  'breadcrumb.certificates': 'Sertifikalar',
  'breadcrumb.new': 'Yeni',
  'breadcrumb.edit': 'Düzenle',
  'breadcrumb.podcasts': 'Podcastler',
  'breadcrumb.episodes': 'Bölümler',
  'breadcrumb.parcours': 'Öğrenme Yolları',
  'breadcrumb.producerAssignments': 'Üretim görevleri',
  'header.toggleMenu': 'Menüyü aç/kapat',
  'header.search': 'Ara…',
  'header.toggleTheme': 'Toggle birçık veya koyu tema',
  'header.profile': 'Profil',
  'header.settings': 'Ayarlar',
  'header.backToInstitutionAdmin': 'Kurum administration',
  'header.openTrainerWorkspace': 'Eğitmen workspace & oluştur içerik',
  'header.logout': 'Çıkış Yap',
  'footer.madeWith': 'Yapıldı ile',
  'footer.forEducation': 'için education',
  'footer.legal': 'Yasal bağlantılar',
  'footer.terms': 'Şartlar',
  'footer.privacy': 'Gizlilik',
  'footer.accessibility': 'Erişilebilirlik',
  'btn.save': 'Kaydet',
  'btn.cancel': 'İptal',
  'btn.delete': 'Sil',
  'btn.edit': 'Düzenle',
  'btn.create': 'Oluştur',
  'btn.add': 'Ekle',
  'btn.close': 'Kapat',
  'btn.confirm': 'Onayla',
  'btn.back': 'Geri',
  'btn.next': 'İleri',
  'btn.previous': 'Önceki',
  'btn.submit': 'Gönder',
  'btn.search': 'Ara',
  'btn.filter': 'Filtrele',
  'btn.export': 'Dışa Aktar',
  'btn.import': 'İçe Aktar',
  'btn.download': 'İndir',
  'btn.upload': 'Yükle',
  'btn.refresh': 'Yenile',
  'btn.retry': 'Tekrar Dene',
  'btn.view': 'Görüntüle',
  'btn.details': 'Detaylar',
  'btn.publish': 'Yayınla',
  'btn.unpublish': 'Yayından Kaldır',
  'btn.duplicate': 'Çoğalt',
  'btn.archive': 'Arşivle',
  'btn.restore': 'Geri Yükle',
  'btn.send': 'Gönder',
  'btn.apply': 'Uygula',
  'btn.reset': 'Sıfırla',
  'btn.select_all': 'Tümünü seç',
  'btn.deselect_all': 'Seçimi kaldır',
  'btn.load_more': 'Load daha fazla',
  'btn.show_more': 'Göster daha fazla',
  'btn.show_less': 'Göster daha az',
  'btn.copy': 'Kopyala',
  'btn.share': 'Paylaş',
  'btn.preview': 'Önizleme',
  'btn.continue': 'Devam Et',
  'btn.skip': 'Atla',
  'form.email': 'Geçerli bir e-posta adresi girin',
  'form.password': 'Şifre',
  'form.password_confirm': 'Onayla şifre',
  'form.first_name': 'Ilk ad',
  'form.last_name': 'Son ad',
  'form.name': 'Ad',
  'form.phone': 'Telefon',
  'form.address': 'Adres',
  'form.city': 'Şehir',
  'form.zip': 'Zip code',
  'form.country': 'Ülke',
  'form.title': 'Başlık',
  'form.description': 'Açıklama',
  'form.category': 'Kategori',
  'form.tags': 'Etiketler',
  'form.status': 'Durum',
  'form.role': 'Rol',
  'form.language': 'Dil',
  'form.date': 'Tarih',
  'form.start_date': 'Başlangıç tarih',
  'form.end_date': 'Son tarih',
  'form.duration': 'Süre',
  'form.price': 'Price',
  'form.avatar': 'Profil picture',
  'form.required': 'Bu alan zorunludur',
  'form.optional': 'İsteğe bağlı',
  'form.select_placeholder': 'Seç...',
  'form.search_placeholder': 'Ara...',
  'form.no_results': 'Sonuç yok',
  'form.file_drop': 'Sürükle ve bırak bir dosya burada veya tıkla to göz at',
  'form.max_size': 'Maximum boyut: {{boyut}}',
  'form.institution': 'Kurum',
  'form.department': 'Bölüm',
  'form.group': 'Grup',
  'form.level': 'Seviye',
  'form.notes': 'Notlar',
  'form.url': 'URL',
  'form.content': 'İçerik',
  'form.thumbnail': 'Thumbnail',
  'error.required': 'Bu field is zorunlu',
  'error.email_invalid': 'Geçersiz e-posta address',
  'error.password_min': 'Şifre gerekir be at least {{min}} characters',
  'error.password_match': 'Passwords do değil match',
  'error.min_length': 'Minimum {{min}} characters',
  'error.max_length': 'Maximum {{max}} characters',
  'error.min_value': 'Minimum value is {{min}}',
  'error.max_value': 'Maximum value is {{max}}',
  'error.invalid_url': 'Geçersiz URL',
  'error.file_too_large': 'Dosya is çok büyük',
  'error.file_type': 'Unsupported dosya tür',
  'error.generic': 'Bir hata occurred',
  'error.network': 'Network connection hata',
  'error.unauthorized': 'Yetkisiz erişim',
  'error.forbidden': 'Erişim reddedildi',
  'error.not_found': 'Kaynak değil bulundu',
  'error.server': 'Internal server hata',
  'error.conflict': 'Bu kaynak zaten exists',
  'error.rate_limit': 'Çok birçok istekler, lütfen bekle',
  'auth.login': 'Giriş Yap',
  'auth.logout': 'Çıkış Yap',
  'auth.register': 'Kayıt Ol',
  'auth.forgot_password': 'Forgot şifre?',
  'auth.reset_password': 'Sıfırla şifre',
  'auth.otp_title': 'Login ile code',
  'auth.otp_sent': 'bir doğrulama code has been gönderildi to {{e-posta}}',
  'auth.otp_placeholder': 'Gir the 6-digit code',
  'auth.google_login': 'Devam et ile Google',
  'auth.remember_me': 'Remember me',
  'auth.no_account': 'Hayır hesap yet?',
  'auth.has_account': 'Zaten have bir hesap?',
  'auth.welcome_back': 'Hoş geldiniz geri, {{ad}}!',
  'auth.login_success': 'Login başarılı',
  'auth.register_success': 'Hesap oluşturuldu başarıyla',
  'auth.logout_success': 'Logout başarılı',
  'role.teacher': 'Öğretmen',
  'role.institution': 'Kurum',
  'role.admin': 'Yönetici',
  'role.drh': 'HR Director',
  'role.rh': 'HR Yönetici',
  'role.manager': 'Yönetici',
  'role.collaborator': 'İşbirlikçi',
  'role.learner': 'Öğrenci',
  'dashboard.title': 'Gösterge Paneli',
  'dashboard.welcome': 'Hoş geldiniz, {{name}}!',
  'dashboard.subtitle': 'Genel bakış of sizin aktivite',
  'dashboard.welcomeSub': 'Projelerinizde neler olduğunu görün.',
  'dashboard.projects': 'Projeler',
  'dashboard.eduflows': 'Eğitim yollar',
  'dashboard.publishedFlows': 'Yayınlandı yollar',
  'dashboard.certificatesIssued': 'Sertifikalar issued',
  'dashboard.activityEmpty': 'Hayır son aktivite on sizin yollar veya podcastler.',
  'dashboard.loadError': 'Could değil load gösterge paneli veri.',
  'dashboard.learners': 'Öğrenciler',
  'dashboard.revenue': 'Revenue',
  'dashboard.newProject': 'Yeni proje',
  'dashboard.newEduFlow': 'Yeni eğitim yol',
  'dashboard.uploadMedia': 'Yükle medya',
  'dashboard.viewDocs': 'Dokümantasyon',
  'dashboard.recentProjects': 'Son projeler',
  'dashboard.noRecentProjects': 'Hayır son projeler',
  'dashboard.activity': 'Aktivite',
  'dashboard.searchProjects': 'Ara projeler...',
  'dashboard.noProjects': 'Hayır projeler yet',
  'dashboard.createFirst': 'Oluştur sizin ilk proje to al başladı',
  'dashboard.createProject': 'Oluştur proje',
  'dashboard.projectTitle': 'Proje başlık',
  'dashboard.recentActivity': 'Son aktivite',
  'project.status.draft': 'Taslak',
  'project.status.published': 'Yayınlandı',
  'project.status.archived': 'Arşivlendi',
  'dashboard.roleSpecific': 'Sizin space is personalized according to sizin rol.',
  'dashboard.calendar.mon': 'Pzt',
  'dashboard.calendar.wed': 'Çar',
  'dashboard.calendar.fri': 'Cum',
  'dashboard.calendar.less': 'Daha az',
  'dashboard.calendar.more': 'Daha fazla',
  'dashboard.calendar.tooltip': '{{count}} activit(ies) on {{tarih}}',
  'dashboard.mock.updated2h': '2h önce',
  'dashboard.mock.updated5h': '5h önce',
  'dashboard.mock.updatedYesterday': 'Dün',
  'dashboard.home': 'Ana Sayfa',
  'dashboard.analytics': 'Analitik',
  'dashboard.settings': 'Ayarlar',
  'dashboard.analyticsComingSoon': 'Analytics geliyor soon',
  'dashboard.settingsComingSoon': 'Ayarlar geliyor soon',
  'pages.analytics.title': 'Analitik',
  'pages.analytics.description': 'Dashboards ve istatistikler',
  'pages.analytics.subtitle': 'Filtrele veri, sürükle to reorder charts, ve resize widgets to match nasıl you çalış.',
  'pages.analytics.filters.period': 'Period',
  'pages.analytics.filters.flow': 'Kurs',
  'pages.analytics.filters.allFlows': 'Tümü kurslar',
  'pages.analytics.period.7d': 'Son 7 gün',
  'pages.analytics.period.30d': 'Son 30 gün',
  'pages.analytics.period.90d': 'Son 90 gün',
  'pages.analytics.period.365d': 'Son 12 months',
  'pages.analytics.addChart': 'Ekle grafik',
  'pages.analytics.resetLayout': 'Sıfırla layout',
  'pages.analytics.dragHint': 'Sürükle to reorder',
  'pages.analytics.size.sm': 'S',
  'pages.analytics.size.md': 'M',
  'pages.analytics.size.lg': 'L',
  'pages.analytics.removeChart': 'Kaldır bu grafik',
  'pages.analytics.kind.completion_line': 'Tamamlanma üzerinde time',
  'pages.analytics.kind.learners_bar': 'Öğrenciler tarafından modül',
  'pages.analytics.kind.status_pie': 'Durum distribution',
  'pages.analytics.kind.engagement_area': 'Engagement time',
  'pages.analytics.series.completion': 'Tamamlanma rate (%)',
  'pages.analytics.series.learners': 'Öğrenciler',
  'pages.analytics.series.hours': 'Saat',
  'pages.analytics.status.completed': 'Tamamlandı',
  'pages.analytics.status.in_progress': 'Devam ediyor',
  'pages.analytics.status.dropped': 'Dropped',
  'pages.analytics.status.not_started': 'Başlanmadı',
  'pages.analytics.loadError': 'Could değil load analytics veri.',
  'pages.analytics.retry': 'Tekrar Dene',
  'pages.analytics.axis.bucket': 'P. {{n}}',
  'pages.analytics.mock.wd0': 'Pzt',
  'pages.analytics.mock.wd1': 'Sal',
  'pages.analytics.mock.wd2': 'Çar',
  'pages.analytics.mock.wd3': 'Per',
  'pages.analytics.mock.wd4': 'Cum',
  'pages.analytics.mock.wd5': 'Cmt',
  'pages.analytics.mock.wd6': 'Paz',
  'pages.analytics.emptyCharts': 'Ekle at least one grafik to see sizin veri.',
  'pages.analytics.comingSoonDesc': 'See eğitim stats, tamamlanma rates, öğrenci engagement, ve overall performans.',
  'pages.help.title': 'Yardım orta',
  'pages.help.description': 'Dokümantasyon ve destek',
  'pages.help.hubIntro': 'Topics covering nasıl to kullan Lyrra — you will soon be able to bağlantı her kart to sizin docs, tutorials, veya destek tickets.',
  'pages.help.searchPlaceholder': 'Ara topics…',
  'pages.help.noResults': 'Hayır sonuçlar için bu ara.',
  'pages.help.configHint': 'Sample içerik: wire up sizin URLs, articles, veya knowledge base ne zaman you are ready.',
  'pages.help.comingSoonDesc': 'Erişim dokümantasyon, tutorials, ve technical destek to al the en çok out of the platform.',
  'pages.help.modal.steps': 'In practice',
  'pages.help.modal.tips': 'Tips',
  'pages.help.modal.related': 'See ayrıca',
  'pages.help.openArticle': 'birç article',
  'pages.help.onboardingFlowMissing': 'Eğitim değil bulundu',
  'pages.help.onboardingFlowMissingDesc': 'Çalıştır backend seeds (db:seed:onboarding-eduflow, db:seed:onboarding-navigation-eduflow, db:seed:onboarding-profil-eduflow, db:seed:onboarding-roller-eduflow, db:seed:onboarding-blok-types-eduflow, db:seed:onboarding-designer-genel bakış-eduflow, db:seed:onboarding-branches-eduflow, db:seed:onboarding-doğrulama-eduflow, db:seed:onboarding-objectives-eduflow, db:seed:onboarding-ai-designer-eduflow, db:seed:onboarding-publication-durum-eduflow, db:seed:onboarding-publication-bağlantılar-eduflow, db:seed:onboarding-catalog-visibility-eduflow, db:seed:onboarding-enrollments-eduflow, db:seed:onboarding-gruplar-cohorts-eduflow, db:seed:onboarding-ilerleme-eduflow, db:seed:onboarding-sertifikalar-eduflow, ve db:seed:onboarding-medya-library-eduflow) veya ayarla VITE_ONBOARDING_DASHBOARD_FLOW_ID / VITE_ONBOARDING_NAVIGATION_FLOW_ID / VITE_ONBOARDING_PROFILE_FLOW_ID / VITE_ONBOARDING_ROLES_FLOW_ID / VITE_ONBOARDING_BLOCK_TYPES_FLOW_ID / VITE_ONBOARDING_DESIGNER_OVERVIEW_FLOW_ID / VITE_ONBOARDING_BRANCHES_FLOW_ID / VITE_ONBOARDING_VALIDATION_FLOW_ID / VITE_ONBOARDING_OBJECTIVES_FLOW_ID / VITE_ONBOARDING_AI_DESIGNER_FLOW_ID / VITE_ONBOARDING_PUBLICATION_STATUS_FLOW_ID / VITE_ONBOARDING_PUBLICATION_LINKS_FLOW_ID / VITE_ONBOARDING_CATALOG_VISIBILITY_FLOW_ID / VITE_ONBOARDING_ENROLLMENTS_FLOW_ID / VITE_ONBOARDING_GROUPS_COHORTS_FLOW_ID / VITE_ONBOARDING_PROGRESS_FLOW_ID / VITE_ONBOARDING_CERTIFICATES_FLOW_ID / VITE_ONBOARDING_MEDIA_LIBRARY_FLOW_ID.',
  'pages.help.onboardingDashboardPlayerTitle': 'Eğitim — Lyrra creator gösterge paneli (onboarding)',
  'pages.help.onboardingNavigationPlayerTitle': 'Eğitim — Lyrra navigation & kenar çubuğu (onboarding)',
  'pages.help.onboardingProfilePlayerTitle': 'Eğitim — Lyrra profil & preferences (onboarding)',
  'pages.help.onboardingRolesPlayerTitle': 'Eğitim — Lyrra roller ve erişim rights (onboarding)',
  'pages.help.onboardingBlockTypesPlayerTitle': 'Eğitim — EduFlow blok types (onboarding)',
  'pages.help.onboardingDesignerOverviewPlayerTitle': 'Eğitim — EduFlow designer genel bakış (onboarding)',
  'pages.help.onboardingBranchesPlayerTitle': 'Eğitim — EduFlow branches & conditions (onboarding)',
  'pages.help.onboardingValidationPlayerTitle': 'Eğitim — EduFlow parcours doğrulama (onboarding)',
  'pages.help.onboardingObjectivesPlayerTitle': 'Eğitim — EduFlow öğrenme objectives (onboarding)',
  'pages.help.onboardingAiDesignerPlayerTitle': 'Eğitim — LyrraOne AI designer assistant (onboarding)',
  'pages.help.onboardingPublicationStatusPlayerTitle': 'Eğitim — LyrraOne taslak, publication ve updates (onboarding)',
  'pages.help.onboardingPublicationLinksPlayerTitle': 'Eğitim — LyrraOne erişim bağlantılar ve paylaşılıyor (onboarding)',
  'pages.help.onboardingCatalogVisibilityPlayerTitle': 'Eğitim — LyrraOne catalog ve visibility (onboarding)',
  'pages.help.onboardingEnrollmentsPlayerTitle': 'Eğitim — LyrraOne enrollments & katılımcılar (onboarding)',
  'pages.help.onboardingGroupsCohortsPlayerTitle': 'Eğitim — LyrraOne gruplar & cohorts (onboarding)',
  'pages.help.onboardingProgressPlayerTitle': 'Eğitim — LyrraOne ilerleme & time spent (onboarding)',
  'pages.help.onboardingCertificatesPlayerTitle': 'Eğitim — LyrraOne delivered sertifikalar (onboarding)',
  'pages.help.onboardingMediaLibraryPlayerTitle': 'Eğitim — LyrraOne medya library (onboarding)',
  'dashboard.period.week': 'Hafta',
  'dashboard.period.month': 'Ay',
  'dashboard.period.quarter': 'Çeyrek',
  'dashboard.vsLastPeriod': 'vs önceki period ({{period}})',
  'dashboard.completionPercent': 'Tamamlanma %',
  'dashboard.activeLearners': 'Aktif öğrenciler',
  'dashboard.sessions': 'Oturumlar',
  'dashboard.activityType.completion': 'Tamamlandı',
  'dashboard.activityType.enrollment': 'Kayıt',
  'dashboard.activityType.milestone': 'Milestone',
  'dashboard.activityType.feedback': 'Geri bildirim',
  'dashboard.activityType.start': 'Başla',
  'dashboard.totalLearners': 'Toplam öğrenci',
  'dashboard.activeEduFlows': 'Aktif eğitim yollar',
  'dashboard.publishedTraining': 'Yayınlandı kurslar',
  'dashboard.activeUsersPeriod': 'Aktif kullanıcılar (period)',
  'dashboard.completionRate': 'Tamamlanma rate',
  'dashboard.npsScore': 'NPS puan',
  'dashboard.topEduFlows': 'Üst eğitim yollar',
  'dashboard.topEduFlowsHint': 'Tamamlanma rate among the en çok kaydedildi kurslar (sorted tarafından öğrenci count).',
  'dashboard.engagement': 'Öğrenci engagement',
  'common.seeAll': 'See tümü',
  'common.startedOn': 'Başladı on',
  'admin.dashboard.totalUsers': 'Toplam kullanıcılar',
  'admin.dashboard.activeToday': 'Aktif bugün',
  'admin.dashboard.revenue': 'Revenue',
  'admin.dashboard.storageUsed': 'Storage kullanıldı',
  'admin.dashboard.vsLastMonth': 'vs son ay',
  'admin.dashboard.userGrowth': 'Kullanıcı growth',
  'admin.dashboard.monthlyRevenue': 'Aylık revenue (€)',
  'admin.dashboard.recentActivity': 'Son aktivite',
  'admin.dashboard.systemHealth': 'Sistem health',
  'admin.dashboard.quickActions': 'Quick eylemler',
  'admin.nav.stats': 'İstatistikler',
  'admin.nav.users': 'Kullanıcılar',
  'admin.nav.support': 'Destek & sohbet',
  'support.chat.title': 'Lyrra destek',
  'support.chat.subtitle': 'Sor sizin soru — bizim ekip replies burada.',
  'support.chat.empty': 'Yaz bir mesaj to başlangıç the conversation.',
  'support.chat.placeholder': 'Sizin mesaj…',
  'support.chat.send': 'Gönder',
  'support.chat.open': 'birç destek sohbet',
  'support.chat.fromSupport': 'Destek',
  'support.chat.fromYou': 'You',
  'admin.support.title': 'Destek conversations',
  'admin.support.loadError': 'Could değil load conversations.',
  'admin.support.replyError': 'Could değil gönder the reply.',
  'admin.support.selectThread': 'Seç bir conversation to görüntüle mesajlar.',
  'admin.support.replyPlaceholder': 'Sizin reply to the kullanıcı…',
  'admin.support.sendReply': 'Gönder',
  'admin.support.refresh': 'Yenile',
  'admin.support.user': 'Kullanıcı',
  'admin.support.subject': 'Konu',
  'admin.support.status': 'Durum',
  'admin.support.priority': 'Priority',
  'admin.support.updated': 'Güncellendi',
  'admin.support.messages': 'Konu dizisi',
  'admin.support.newestFirst': 'newest ilk',
  'admin.support.allStatuses': 'Tümü statuses',
  'admin.support.linearCreate': 'Oluştur Linear sorun',
  'admin.support.linearOpen': 'birç in Linear',
  'admin.support.linearError': 'Could değil oluştur the Linear sorun. Kontrol et LINEAR_API_KEY on the server.',
  'admin.nav.institutions': 'Institutions',
  'admin.nav.contracts': 'Sözleşmeler',
  'admin.nav.editors': 'Editors',
  'admin.nav.podcasts': 'Podcastler',
  'admin.nav.sounds': 'Lyrra sesler',
  'admin.nav.templates': 'Kurs şablonları',
  'admin.nav.demoFormations': 'Demo kurslar',
  'admin.nav.templatesImages': 'Görsel şablonlar',
  'admin.nav.tools': 'Tools',
  'admin.nav.files': 'Dosyalar',
  'admin.nav.logs': 'Logs',
  'admin.nav.webhooks': 'Web Kancaları',
  'admin.nav.email': 'E-posta',
  'admin.nav.docusign': 'DocuSign',
  'admin.docusign.title': 'DocuSign entegrasyon',
  'admin.docusign.subtitle': 'Entegrasyon key, API identifiers ve RSA özel key (JWT). Stored in the database, değil in Docker.',
  'admin.docusign.statusOk': 'Yapılandırıldı',
  'admin.docusign.statusIncomplete': 'Incomplete',
  'admin.docusign.keyStored': 'Özel key on dosya',
  'admin.docusign.consentHint': 'Için ilk-time JWT kullan, the DocuSign hesap gerekir grant application consent (URL from DocuSign). Eğer you al 401/403, kontrol et the PEM key, entegrasyon key ve consent.',
  'admin.docusign.loading': 'Yükleniyor…',
  'admin.docusign.loadError': 'Could değil load DocuSign ayarlar',
  'admin.docusign.saved': 'DocuSign ayarlar kaydedildi',
  'admin.docusign.saveError': 'Could değil kaydet',
  'admin.docusign.save': 'Kaydet',
  'admin.docusign.reload': 'Reload',
  'admin.docusign.fieldIntegrationKey': 'Entegrasyon key (client ID)',
  'admin.docusign.fieldUserId': 'Kullanıcı ID (GUID)',
  'admin.docusign.fieldAccountId': 'Hesap ID',
  'admin.docusign.fieldBasePath': 'REST API base URL',
  'admin.docusign.fieldOauthHost': 'OAuth host (olmadan https://)',
  'admin.docusign.fieldRsa': 'RSA özel key (PEM)',
  'admin.docusign.oauthPlaceholder': 'hesap-d.docusign.com',
  'admin.docusign.rsaPlaceholderKeep': 'Ayrıl boş to tut the mevcut key',
  'admin.docusign.rsaPlaceholderNew': 'Paste the dolu .pem dosya (BEGIN … Son)',
  'admin.nav.smtp': 'SMTP yapılandırma',
  'admin.nav.regulatoryWatch': 'Lyrra regulatory izle',
  'admin.nav.leBref': 'Le Bref',
  'admin.nav.helpCenter': 'Yardım orta',
  'admin.nav.platform': 'Platform entegrasyonlar',
  'admin.nav.eduflowPalette': 'EduFlow palette',
  'admin.users.adminScopeTitle': 'Admin gösterge paneli scope',
  'admin.users.adminScopeFull': 'Dolu erişim (tümü tabs)',
  'admin.users.adminScopeRestricted': 'Restrict to seçildi tabs',
  'admin.users.adminScopeHint': 'Restricted accounts sadece see the seçildi sections. Sonra changing tabs, the kullanıcı gerekir sign in tekrar (veya yenile the oturum) için the menü ve API erişim to güncelle.',
  'admin.users.adminScopeNeedOne': 'Seç at least one sekme, veya choose dolu erişim.',
  'admin.helpCenter.title': 'Yardım orta',
  'admin.helpCenter.subtitle': 'Sections shown ilk on /yardım ve /aide: kategori, başlık, short birçıklama, ve bağlantı (/… yol veya https URL) birçıldı ne zaman the kart is tıklandı.',
  'admin.helpCenter.reload': 'Yenile',
  'admin.helpCenter.loadError': 'Could değil load.',
  'admin.helpCenter.saveError': 'Could değil kaydet.',
  'admin.helpCenter.deleteError': 'Could değil sil.',
  'admin.helpCenter.saved': 'Kaydedildi',
  'admin.helpCenter.deleted': 'Silindi',
  'admin.helpCenter.catCreated': 'Kategori oluşturuldu',
  'admin.helpCenter.topicCreated': 'Article oluşturuldu',
  'admin.helpCenter.catTitleRequired': 'Kategori başlık is zorunlu.',
  'admin.helpCenter.topicFieldsRequired': 'Başlık ve formation bağlantı are zorunlu.',
  'admin.helpCenter.newCategory': 'Yeni kategori',
  'admin.helpCenter.createCategory': 'Yeni kategori',
  'admin.helpCenter.editCategory': 'Düzenle kategori',
  'admin.helpCenter.createTopic': 'Yeni article',
  'admin.helpCenter.editTopic': 'Düzenle article',
  'admin.helpCenter.fieldTitle': 'Başlık',
  'admin.helpCenter.fieldDescription': 'Açıklama',
  'admin.helpCenter.fieldIconKey': 'Lucide simge',
  'admin.helpCenter.fieldIconKeyHint': 'Seç bir simge; bir önizleme appears in the liste ve on the trigger düğme.',
  'admin.helpCenter.fieldFormationUrl': 'Formation bağlantı',
  'admin.helpCenter.formationPickPlaceholder': '— Seç bir genel kurs —',
  'admin.helpCenter.formationPickHint': 'Sadece yayınlandı kurslar ile anonymous genel erişim etkin are listed.',
  'admin.helpCenter.formationPickLoading': 'Yükleniyor kurslar…',
  'admin.helpCenter.publicFlowsLoadError': 'Could değil load the liste of genel kurslar.',
  'admin.helpCenter.legacyFormationPickLabel': 'Kaydedildi bağlantı (değil in liste)',
  'admin.helpCenter.fieldSort': 'Sipariş',
  'admin.helpCenter.fieldActive': 'Görünür',
  'admin.helpCenter.save': 'Kaydet',
  'admin.helpCenter.edit': 'Düzenle',
  'admin.helpCenter.addTopic': 'Makale',
  'admin.helpCenter.empty': 'Hayır kategoriler yet. Oluştur bir kategori, sonra articles.',
  'admin.helpCenter.noTopics': 'Hayır articles in bu kategori.',
  'admin.helpCenter.badgeActive': 'Aktif',
  'admin.helpCenter.badgeInactive': 'Gizli',
  'admin.helpCenter.iconLabel': 'Simge',
  'admin.helpCenter.confirmDeleteCategory': 'Sil bu kategori ve tümü its articles?',
  'admin.helpCenter.confirmDeleteTopic': 'Sil bu article?',
  'admin.nav.formationMigration': 'Kurs migration',
  'admin.nav.formationDuplicate': 'Çoğalt kurslar',
  'admin.nav.lyrraOneFormations': 'LyrraOne kurslar',
  'admin.lyrraOneFormations.title': 'LyrraOne-managed kurslar',
  'admin.lyrraOneFormations.subtitle': 'Ata bir EduFlow to LyrraOne: the technical owner is reassigned (PLATFORM_EDUFLOW_OWNER_USER_ID veya the ilk platform admin hesap), collaborators are kaldırıldı, ve sadece platform administrators can düzenle the kurs in the designer.',
  'admin.lyrraOneFormations.searchLabel': 'Ara (başlık veya kurs ID)',
  'admin.lyrraOneFormations.searchPlaceholder': 'e.g. onboarding veya UUID…',
  'admin.lyrraOneFormations.search': 'Ara',
  'admin.lyrraOneFormations.searchMin': 'Gir at least 2 characters.',
  'admin.lyrraOneFormations.results': 'Sonuçlar',
  'admin.lyrraOneFormations.noResults': 'Hayır kurs bulundu.',
  'admin.lyrraOneFormations.badge': 'LyrraOne',
  'admin.lyrraOneFormations.detailHint': 'The original author ve former collaborators lose düzenle erişim. Öğrenciler ve genel playback are değil affected.',
  'admin.lyrraOneFormations.assign': 'Ata to LyrraOne',
  'admin.lyrraOneFormations.alreadyAssigned': 'Zaten LyrraOne-managed',
  'admin.lyrraOneFormations.confirm': 'Onayla LyrraOne atama? Bu cannot be undone from burada: sadece platform administrators will be able to düzenle the kurs.',
  'admin.lyrraOneFormations.success': 'Kurs "{{başlık}}": LyrraOne atama tamamlandı.',
  'admin.lyrraOneFormations.assignedListTitle': 'Kurslar zaten atandı to LyrraOne',
  'admin.lyrraOneFormations.assignedListEmpty': 'Hiçbiri yet. Kullan the ara altında to ata one.',
  'admin.lyrraOneFormations.refreshList': 'Yenile liste',
  'admin.lyrraOneFormations.openDesigner': 'Designer',
  'admin.lyrraOneFormations.assignSectionTitle': 'Ara ve ata another kurs',
  'admin.lyrraOneFormations.publicPolicyHint': 'Kurslar atandı to LyrraOne are automatically yayınlandı, anonymously erişilebilir (/f/… short bağlantı), ve suitable için paylaşılıyor (QR, yardım-orta iframe).',
  'admin.lyrraOneFormations.drawerTitle': 'Genel bağlantı & QR code',
  'admin.lyrraOneFormations.publicShortLink': 'Short bağlantı (recommended)',
  'admin.lyrraOneFormations.publicLongLink': 'Genel player bağlantı (UUID)',
  'admin.lyrraOneFormations.copy': 'Kopyala',
  'admin.lyrraOneFormations.copied': 'Kopyalandı to clipboard.',
  'admin.lyrraOneFormations.copyFailed': 'Could değil kopyala (browser veya izinler).',
  'admin.lyrraOneFormations.publicLinksUnavailable': 'Bağlantılar mevcut değil: etkinleştir genel erişim veya kullan “Güncelle genel erişim” için kurslar oluşturuldu önce bu rule.',
  'admin.lyrraOneFormations.publicIncomplete': 'Genel erişim incomplete',
  'admin.lyrraOneFormations.publicRepairHint': 'Bu kurs is LyrraOne-managed ama is missing dolu genel ayarlar (yayınlandı state, anonymous erişim, short code).',
  'admin.lyrraOneFormations.publicRepairCta': 'Güncelle genel erişim',
  'admin.lyrraOneFormations.publicRepairOk': 'Genel erişim uygulandı için “{{başlık}}”.',
  'admin.formationDuplicate.title': 'Çoğalt bir kurs to another kurum',
  'admin.formationDuplicate.subtitle': 'Ara için bir kurs, sonra seç the kurum ve hesap o will own the kopyala. The original kurs is kalan unchanged. The kopyala is bir taslak (hayır catalogue, oturumlar, veya collaborators).',
  'admin.formationDuplicate.searchLabel': 'Ara (başlık veya kurs ID)',
  'admin.formationDuplicate.searchPlaceholder': 'e.g. onboarding veya UUID…',
  'admin.formationDuplicate.search': 'Ara',
  'admin.formationDuplicate.searchMin': 'Gir at least 2 characters.',
  'admin.formationDuplicate.results': 'Sonuçlar',
  'admin.formationDuplicate.noResults': 'Hayır kurs bulundu.',
  'admin.formationDuplicate.currentOwner': 'Mevcut owner',
  'admin.formationDuplicate.currentInstitution': 'Source kurum',
  'admin.formationDuplicate.targetInstitution': 'Kopyala destination kurum',
  'admin.formationDuplicate.pickInstitution': 'Seç bir kurum…',
  'admin.formationDuplicate.newOwner': 'Kopyala owner (eğitmen / HR)',
  'admin.formationDuplicate.pickOwner': 'Seç bir hesap…',
  'admin.formationDuplicate.noCandidates': 'Hayır eligible hesap in bu kurum.',
  'admin.formationDuplicate.duplicate': 'Çoğalt kurs',
  'admin.formationDuplicate.confirm': 'Oluştur bir kopyala of bu kurs için the seçildi hesap? The source kurs will değil be modified.',
  'admin.formationDuplicate.success': 'Kopyala oluşturuldu: "{{başlık}}" için {{e-posta}}. Yeni kurs ID: {{newFlowId}}.',
  'admin.formationDuplicate.loadInstitutionsError': 'Could değil load institutions.',
  'admin.formationDuplicate.loadCandidatesError': 'Could değil load eligible accounts.',
  'admin.formationMigration.title': 'Migrate bir kurs arasında institutions',
  'admin.formationMigration.subtitle': 'Ara bir EduFlow, seç the hedef kurum ve bir hesap o can own it (eğitmen, HR, etc.). Collaborators ve kurs kategoriler are cleared; catalogue bağlantılar, kampanyalar ve competencies from the önceki kurum are kaldırıldı.',
  'admin.formationMigration.searchLabel': 'Ara (başlık veya kurs ID)',
  'admin.formationMigration.searchPlaceholder': 'e.g. onboarding veya UUID…',
  'admin.formationMigration.search': 'Ara',
  'admin.formationMigration.searchMin': 'Gir at least 2 characters.',
  'admin.formationMigration.results': 'Sonuçlar',
  'admin.formationMigration.noResults': 'Hayır kurs bulundu.',
  'admin.formationMigration.currentOwner': 'Mevcut owner',
  'admin.formationMigration.currentInstitution': 'Source kurum',
  'admin.formationMigration.targetInstitution': 'Hedef kurum',
  'admin.formationMigration.pickInstitution': 'Seç bir kurum…',
  'admin.formationMigration.newOwner': 'Yeni owner (eğitmen / HR)',
  'admin.formationMigration.pickOwner': 'Seç bir hesap…',
  'admin.formationMigration.noCandidates': 'Hayır eligible hesap in bu kurum.',
  'admin.formationMigration.migrate': 'Migrate kurs',
  'admin.formationMigration.confirm': 'Onayla migration? Collaborators ve kategoriler will be cleared; inconsistent HR/catalogue bağlantılar will be kaldırıldı.',
  'admin.formationMigration.success': 'Tamamlandı: "{{başlık}}" is şimdi atandı to {{e-posta}}.',
  'admin.formationMigration.clearedCatalog': 'Catalogue bağlantı kaldırıldı (öğe belonged to another kurum).',
  'admin.formationMigration.loadInstitutionsError': 'Could değil load institutions.',
  'admin.formationMigration.loadCandidatesError': 'Could değil load eligible accounts.',
  'admin.regulatoryWatch.title': 'Regulatory izle — LyrraOne alerts',
  'admin.regulatoryWatch.subtitle': 'Yayınla bir alert to the “Regulatory izle” timeline of her aktif kurum. Içerik is kilitli on the eğitim organisation side; they can acknowledge it, ekle notlar, ve plan takip et-up.',
  'admin.regulatoryWatch.refresh': 'Yenile',
  'admin.regulatoryWatch.loadError': 'Could değil load veri.',
  'admin.regulatoryWatch.validationRequired': 'Başlık, birçıklama, ve source are zorunlu.',
  'admin.regulatoryWatch.publishError': 'Could değil yayınla.',
  'admin.regulatoryWatch.newBroadcastTitle': 'Yeni global alert',
  'admin.regulatoryWatch.placeholderTitle': 'Başlık',
  'admin.regulatoryWatch.placeholderDescription': 'birçıklama (görünür to tümü institutions)',
  'admin.regulatoryWatch.placeholderSource': 'Bağlantı veya source reference',
  'admin.regulatoryWatch.category.reglementaire': 'Regulatory',
  'admin.regulatoryWatch.category.pedagogique': 'Pedagogical',
  'admin.regulatoryWatch.category.technique': 'Technical',
  'admin.regulatoryWatch.category.sectoriel': 'Sector',
  'admin.regulatoryWatch.impact.fort': 'Yüksek impact',
  'admin.regulatoryWatch.impact.moyen': 'Orta impact',
  'admin.regulatoryWatch.impact.faible': 'Düşük impact',
  'admin.regulatoryWatch.publishing': 'Yayınlanıyor…',
  'admin.regulatoryWatch.publishButton': 'Yayınla to tümü aktif institutions',
  'admin.regulatoryWatch.historyTitle': 'History & acknowledgements',
  'admin.regulatoryWatch.loading': 'Yükleniyor…',
  'admin.regulatoryWatch.empty': 'Hayır alerts yayınlandı yet.',
  'admin.regulatoryWatch.institutionsCount': '{{count}} kurum(s)',
  'admin.regulatoryWatch.ackProgress': 'Acknowledged: {{ack}}/{{toplam}} ({{pct}}%)',
  'admin.regulatoryWatch.byAuthor': 'Tarafından {{kim}}',
  'admin.regulatoryWatch.unknownAuthor': '—',
  'admin.leBref.title': 'Le Bref — publication takvim',
  'admin.leBref.subtitle': 'Günlük brief shown on the genel sayfa /le-bref. Sadece one “yayınlandı” brief per takvim gün.',
  'admin.leBref.refresh': 'Yenile',
  'admin.leBref.loadError': 'Could değil load veri.',
  'admin.leBref.validationTitle': 'Başlık is zorunlu.',
  'admin.leBref.validationBlocks': 'Ekle at least one blok (text, ses, sınav, veya anket).',
  'admin.leBref.validationBlocksInvalid': 'Hayır geçerli bloklar: kontrol et sınavlar (soru + at least 2 cevaplar, geçerli doğru index), ses URLs, ve non-boş text.',
  'admin.leBref.blocksHint': 'Build the brief ile bloklar (text, medya, sınav, anket — hayır HTML). Legacy HTML briefs are converted ne zaman you birç them.',
  'admin.leBref.block.text': 'Metin',
  'admin.leBref.block.audio': 'Ses',
  'admin.leBref.block.quiz': 'Sınav',
  'admin.leBref.block.poll': 'Anket',
  'admin.leBref.blocksEmpty': 'Ekle bloklar (text, ses, sınav, anket). Hayır gerek to tür raw HTML.',
  'admin.leBref.block.moveUp': 'Taşı up',
  'admin.leBref.block.moveDown': 'Taşı down',
  'admin.leBref.block.remove': 'Kaldır blok',
  'admin.leBref.block.textPlaceholder': 'Paragraph (plain text veya line breaks)',
  'admin.leBref.block.audioUrl': 'Ses dosya URL',
  'admin.leBref.block.audioCaption': 'Caption (isteğe bağlı)',
  'admin.leBref.block.quizQuestion': 'Soru',
  'admin.leBref.block.quizOptions': 'Cevaplar',
  'admin.leBref.block.optionLabel': 'Seçenek',
  'admin.leBref.block.addOption': 'Ekle cevap',
  'admin.leBref.block.quizFeedback': 'Geri bildirim sonra kontrol et (isteğe bağlı)',
  'admin.leBref.block.pollQuestion': 'Anket soru',
  'admin.leBref.block.pollMulti': 'Allow multiple choices',
  'admin.leBref.block.image': 'Görsel',
  'admin.leBref.block.video': 'Video',
  'admin.leBref.block.imageUrl': 'Görsel URL (HTTPS veya hosted medya)',
  'admin.leBref.block.imageAlt': 'Alt text (accessibility)',
  'admin.leBref.block.imageCaption': 'Caption altında the görsel (isteğe bağlı)',
  'admin.leBref.block.videoHint': 'YouTube, Vimeo, veya direct video URL (mp4, WebM…), aynı idea as the designer video blok.',
  'admin.leBref.block.videoUrl': 'Video URL',
  'admin.leBref.block.videoPoster': 'Poster görsel URL (isteğe bağlı) — mainly için direct video dosyalar',
  'admin.leBref.block.videoCaption': 'Başlık veya caption (isteğe bağlı)',
  'admin.leBref.block.audioTtsHint': 'Text is oku ile Mistral TTS; the voice is picked automatically from the text dil (aynı idea as designer ses bloklar).',
  'admin.leBref.block.audioTtsPlaceholder': 'Text to speak…',
  'admin.leBref.block.audioTtsGenerate': 'Synthesize (Mistral TTS)',
  'admin.leBref.block.audioTtsReady': 'Ses ready — will be regenerated on kaydet eğer the text değişiklikler.',
  'admin.leBref.block.audioUrlReadonly': 'Ses dosya',
  'admin.leBref.block.audioPreviewUnsupported': 'Önizleme değil supported',
  'admin.leBref.block.audioTtsNeedText': 'Gir the text to oku ilk.',
  'admin.leBref.block.audioTtsBadResponse': 'Geçersiz TTS yanıt.',
  'admin.leBref.block.audioTtsError': 'Synthesis başarısız (Mistral TTS / entegrasyonlar).',
  'admin.leBref.saveError': 'Could değil kaydet.',
  'admin.leBref.deleteError': 'Could değil sil.',
  'admin.leBref.confirmDelete': 'Sil bu brief?',
  'admin.leBref.quizJsonInvalid': 'Geçersiz sınav JSON.',
  'admin.leBref.aiError': 'AI generation başarısız (Mistral key / platform entegrasyonlar).',
  'admin.leBref.prevMonth': 'Önceki ay',
  'admin.leBref.nextMonth': 'Sonraki ay',
  'admin.leBref.legend': 'Legend',
  'admin.leBref.status.published': 'Yayınlandı',
  'admin.leBref.status.draft': 'Taslak',
  'admin.leBref.status.archived': 'Arşivlendi',
  'admin.leBref.clickDayHint': 'Tıkla bir gün to başlangıç bir yeni brief için o tarih.',
  'admin.leBref.editBrief': 'Düzenle brief',
  'admin.leBref.newBrief': 'Yeni brief',
  'admin.leBref.aiBlockTitle': 'AI assistant (Mistral)',
  'admin.leBref.aiThemePlaceholder': 'Tema veya instructions (e.g. summary + sınav, HR practices anket, article URL, YouTube bağlantı…)',
  'admin.leBref.aiContextHint': 'State sizin amaç: summary, sınav, opinion anket, ses sürüm, veya paste bir URL / görsel veya video bağlantı — the AI adapts blok types (text, ses, görsel, video, sınav, anket).',
  'admin.leBref.aiGenerate': 'Fill ile AI',
  'admin.leBref.titlePlaceholder': 'Başlık',
  'admin.leBref.excerptPlaceholder': 'Short excerpt',
  'admin.leBref.bodyPlaceholder': 'Body (HTML allowed: p, strong, em, ul, li, br)',
  'admin.leBref.audioUrlPlaceholder': 'Isteğe bağlı ses URL (mp3, etc.)',
  'admin.leBref.quizPlaceholder': 'Isteğe bağlı sınav JSON: {"sorular":[{"soru":"…","seçenekler":["bir","B","C","D"],"correctIndex":0,"geri bildirim":"…"}]}',
  'admin.leBref.save': 'Kaydet',
  'admin.leBref.create': 'Oluştur',
  'admin.leBref.resetForm': 'Yeni / clear',
  'admin.leBref.delete': 'Sil',
  'admin.leBref.monthListTitle': 'Briefs bu ay',
  'admin.leBref.loading': 'Yükleniyor…',
  'admin.leBref.emptyMonth': 'Hayır briefs in bu range.',
  'admin.leBref.edit': 'Düzenle',
  'admin.smtp.pageTitle': 'SMTP yapılandırma',
  'admin.smtp.pageHint': 'Outgoing server için transactional platform e-posta.',
  'admin.smtp.cardTitle': 'Outbound e-posta (SMTP)',
  'admin.smtp.subtitle': 'Host, port, credentials, ve sender. Stored in the database — hayır Docker SMTP_* veya EMAIL_FROM variables.',
  'admin.smtp.host': 'SMTP host',
  'admin.smtp.port': 'Port',
  'admin.smtp.secure': 'TLS/SSL (e.g. port 465)',
  'admin.smtp.user': 'Username',
  'admin.smtp.password': 'Şifre',
  'admin.smtp.passwordPlaceholder': 'Ayrıl boş to tut the mevcut şifre',
  'admin.smtp.passwordPlaceholderNew': 'SMTP şifre',
  'admin.smtp.fromEmail': 'From e-posta',
  'admin.smtp.fromName': 'From display ad',
  'admin.smtp.hint': 'En çok providers require bir username ve şifre. Kullan the admin e-posta test tool sonra kaydediliyor.',
  'admin.smtp.save': 'Kaydet SMTP',
  'admin.smtp.saved': 'SMTP ayarlar kaydedildi',
  'admin.smtp.saveError': 'Could değil kaydet',
  'admin.smtp.loadError': 'Could değil load SMTP ayarlar',
  'admin.smtp.loading': 'Yükleniyor…',
  'admin.smtp.configured': 'Ayarlar kaydedildi',
  'admin.smtp.notConfigured': 'Incomplete',
  'admin.shell.title': 'Yönetim',
  'admin.shell.expandSidebar': 'Kenar çubuğunu genişlet',
  'admin.shell.collapseSidebar': 'Kenar çubuğunu daralt',
  'admin.shell.collapse': 'Menüyü daralt',
  'admin.header.workspace': 'Platform administration',
  'admin.institutionDetail.pageTitle': 'Kurum — Administration',
  'admin.institutionDetail.backToList': 'Geri to institutions',
  'manager.page.documentTitle': 'Yönetici workspace - LyrraOne',
  'manager.page.title': 'Yönetici workspace',
  'manager.page.subtitle': 'Yönet eğitim plans ve sizin ekip ilerleme',
  'manager.page.tabs.dashboard': 'Gösterge Paneli',
  'manager.page.tabs.team': 'Ekip',
  'manager.page.tabs.requests': 'İstekler',
  'manager.page.tabs.reviews': 'Değerlendirmeler',
  'collab.page.documentTitle': 'Benim eğitim - LyrraOne',
  'collab.page.title': 'Benim eğitim',
  'collab.page.subtitle': 'Track sizin ilerleme ve yönet sizin eğitim',
  'collab.page.tabs.dashboard': 'Gösterge Paneli',
  'collab.page.tabs.skills': 'Benim beceriler',
  'collab.page.tabs.request': 'Yap bir istek',
  'collab.page.tabs.certificates': 'Sertifikalar',
  'rh.page.documentTitle': 'HR gösterge paneli - LyrraOne',
  'rh.compliancePage.documentTitle': 'Uyumluluk & Qualiopi - LyrraOne',
  'rh.compliancePage.title': 'Uyumluluk & Qualiopi',
  'rh.compliancePage.subtitle': 'Yönet regulatory uyumluluk ve Qualiopi certification',
  'rh.compliancePage.tabs.dashboard': 'Gösterge Paneli',
  'rh.compliancePage.tabs.difficulty': 'Öğrenme difficulties',
  'rh.compliancePage.tabs.handicap': 'Disability liaison',
  'rh.compliancePage.tabs.learnerBilan': 'Öğrenci summary',
  'rh.compliancePage.tabs.qualiopi': 'Qualiopi',
  'rh.compliancePage.tabs.regulatory': 'Regulatory izle',
  'rh.compliancePage.tabs.satisfaction': 'Satisfaction',
  'rh.regulatoryWatch.lyrraBadge': 'LyrraOne',
  'rh.regulatoryWatch.ofResponse': 'Bizim yanıt / position',
  'rh.regulatoryWatch.ofResponsePlaceholder': 'Ne we did veya plan to do…',
  'rh.regulatoryWatch.ackStatus': 'Durum',
  'rh.regulatoryWatch.ack.pending': 'To işle',
  'rh.regulatoryWatch.ack.read': 'Acknowledged (oku)',
  'rh.regulatoryWatch.ack.actionTaken': 'Eylem alındı',
  'rh.regulatoryWatch.ack.notApplicable': 'Değil applicable',
  'rh.regulatoryWatch.pdf.title': 'Regulatory izle register',
  'rh.regulatoryWatch.pdf.subtitleFallback': 'Kurum',
  'rh.regulatoryWatch.pdf.generatedAt': 'Oluşturuldu on {{tarih}}',
  'rh.regulatoryWatch.pdf.colDate': 'Tarih',
  'rh.regulatoryWatch.pdf.colCategory': 'Cat.',
  'rh.regulatoryWatch.pdf.colTitle': 'Başlık',
  'rh.regulatoryWatch.pdf.colDesc': 'birçıklama (excerpt)',
  'rh.regulatoryWatch.pdf.colImpact': 'Impact',
  'rh.regulatoryWatch.pdf.colOrigin': 'Origin',
  'rh.regulatoryWatch.pdf.colStatus': 'Durum',
  'rh.regulatoryWatch.pdf.colAction': 'Eylem',
  'rh.regulatoryWatch.pdf.colWho': 'Kullanıcı',
  'rh.regulatoryWatch.pdf.colWhen': 'Timestamp',
  'rh.regulatoryWatch.pdf.originLyrra': 'LyrraOne',
  'rh.regulatoryWatch.pdf.originOf': 'Eğitim org.',
  'rh.regulatoryWatch.pdf.readYes': 'Oku',
  'rh.regulatoryWatch.pdf.readNo': 'Unread',
  'rh.regulatoryWatch.pdf.actionDone': 'Eylem tamamlandı',
  'rh.regulatoryWatch.pdf.actionOpen': 'Eylem in ilerleme',
  'rh.regulatoryWatch.pdf.emptyWatch': 'Hayır öğeler recorded',
  'rh.regulatoryWatch.pdf.auditSection': 'Internal audit log',
  'rh.regulatoryWatch.pdf.auditHint': 'Eylemler recorded automatically tarafından the platform.',
  'rh.regulatoryWatch.pdf.emptyAudit': 'Hayır son olaylar',
  'rh.regulatoryWatch.exportPdf': 'Dışbir aktar PDF',
  'rh.regulatoryWatch.exportPdfBusy': 'Dışbir aktarılıyor PDF…',
  'rh.regulatoryWatch.exportPdfError': 'PDF dışbir aktar başarısız',
  'rh.compliance': 'Uyumluluk',
  'rh.complianceAuditAction.qualiopi_corrective_action_create': 'Qualiopi corrective eylem oluşturuldu',
  'rh.complianceAuditAction.qualiopi_corrective_action_delete': 'Qualiopi corrective eylem silindi',
  'rh.complianceAuditAction.qualiopi_corrective_action_update': 'Qualiopi corrective eylem güncellendi',
  'rh.complianceAuditAction.qualiopi_evidence_create': 'Qualiopi evidence eklendi',
  'rh.complianceAuditAction.qualiopi_indicator_update': 'Qualiopi indicator güncellendi',
  'rh.complianceAuditAction.compliance_regulatory_watch_create': 'Regulatory izle öğe oluşturuldu',
  'rh.complianceAuditAction.compliance_regulatory_watch_update': 'Regulatory izle öğe güncellendi',
  'rh.complianceAuditAction.compliance_regulatory_watch_delete': 'Regulatory izle öğe silindi',
  'rh.auditDateUnknown': 'Değil ayarla',
  'rh.auditScheduleHint': 'Ayarla in kurum ayarlar',
  'rh.qualiopiEmpty': 'Hayır Qualiopi veri mevcut için bu kurum.',
  'rh.qualiopiLoading': 'Yükleniyor Qualiopi reference veri…',
  'v2.compliance': 'Uyumluluk & Qualiopi',
  'rh.dashboard.title': 'HR gösterge paneli',
  'rh.dashboard.subtitle': 'Eğitim & development genel bakış',
  'rh.dashboard.activeCampaigns': 'Aktif kampanyalar',
  'rh.dashboard.pendingAssignmentsKpi': 'Assignments (beklemede / kabul edildi)',
  'rh.dashboard.pendingRequestsCount': 'Beklemede istekler',
  'rh.dashboard.completionRateLabel': 'Tamamlanma rate (öğrenme yollar)',
  'rh.dashboard.budgetUsed': 'Kampanya budget kullanıldı',
  'rh.dashboard.budgetNotSet': 'Değil ayarla',
  'rh.dashboard.progressLabel': 'Ilerleme (%)',
  'rh.dashboard.chartCampaignsTitle': 'Kampanya ilerleme',
  'rh.dashboard.chartFormationsTitle': 'Öğrenme yol ilerleme',
  'rh.dashboard.chartCampaignsHint': 'Average atama tamamlanma rate per kampanya.',
  'rh.dashboard.chartFormationsHint': 'Paylaş of öğrenciler kim tamamlandı the yol (of mevcut enrollments).',
  'rh.dashboard.upcomingDeadlines': 'Yaklaşbir deadlines',
  'rh.dashboard.recentActivity': 'Son aktivite',
  'rh.dashboard.recentActivityHint': 'Kampanya assignments ve tamamlandı yollar.',
  'rh.dashboard.viewAll': 'Görüntüle tümü',
  'rh.dashboard.exportReport': 'Dışbir aktar rapor',
  'rh.dashboard.exportSoon': 'Dışbir aktar geliyor soon.',
  'rh.dashboard.newCampaign': 'Yeni kampanya',
  'rh.dashboard.campaignProgress': 'Kampanya ilerleme',
  'rh.dashboard.createCampaign': 'Oluştur kampanya',
  'rh.dashboard.reviewRequests': 'Değerlendirme istekler',
  'rh.dashboard.skillsMap': 'Beceriler framework',
  'rh.dashboard.budgetOverview': 'Budget genel bakış',
  'rh.dashboard.loadError': 'Could değil load HR gösterge paneli.',
  'rh.dashboard.emptyChart': 'Hayır veri to display yet.',
  'rh.dashboard.emptyDeadlines': 'Hayır yaklaşbir kampanya deadlines.',
  'rh.dashboard.emptyRecent': 'Hayır son aktivite.',
  'rh.dashboard.kindAssignment': 'Kampanya',
  'rh.dashboard.kindCompletion': 'Yol tamamlandı',
  'rh.dashboard.justNow': 'Sadece şimdi',
  'rh.dashboard.learnerInsightTitle': 'Eğitim operations (live veri)',
  'rh.dashboard.learnerInsightHint': 'Aggregated eğitim enrollments: scores from graded bloklar, blok friction, en son evaluations.',
  'rh.dashboard.enrollmentsTotal': 'Enrollments',
  'rh.dashboard.completionGlobal': 'Tamamlandı',
  'rh.dashboard.avgTimePerEnrollment': 'Avg. time per kayıt',
  'rh.dashboard.notStarted': 'Başlanmadı',
  'rh.dashboard.stalled': 'Stalled (>30d pasif sonra başlangıç)',
  'rh.dashboard.topFlowsDetail': 'En çok subscribed yollar',
  'rh.dashboard.colFlow': 'Yol',
  'rh.dashboard.colEnrolled': 'Kaydedildi',
  'rh.dashboard.colCompletedPct': 'Tamamlanma',
  'rh.dashboard.colAvgTime': 'Avg. time',
  'rh.dashboard.colAvgScore': 'Avg. puan',
  'rh.dashboard.blockFrictionTitle': 'Highest-friction bloklar (≥3 oturumlar)',
  'rh.dashboard.colBlock': 'Blok',
  'rh.dashboard.colSessions': 'Oturumlar',
  'rh.dashboard.colBlockCompletion': 'Blok tamamlanma',
  'rh.dashboard.recentEvalTitle': 'En son evaluations',
  'rh.dashboard.evalComment': 'Has yorum',
  'rh.dashboard.exportOk': 'CSV indirildi.',
  'rh.dashboard.exportFail': 'Indir başarısız.',
  'institution.dashboard.trainingCardTitle': 'Eğitim takip et-up (enrollments)',
  'institution.dashboard.trainingCardHint': 'Aggregated across tümü kurum öğrenme yollar.',
  'institution.dashboard.trainingCompleted': 'yollar tamamlandı',
  'institution.dashboard.trainingAvgMinutes': 'avg min / kayıt',
  'rh.status.urgent': 'Acil',
  'rh.status.soon': 'Yakında',
  'rh.status.upcoming': 'Yaklaşan',
  'rh.status.pending': 'Beklemede',
  'rh.status.approved': 'Onaylandı',
  'rh.status.rejected': 'Reddedildi',
  'producerAssignments.intro': 'Bu sayfa lists sadece içerik HR has atandı to you: catalog “shell” öğeler to çevir içine EduFlow kurslar in the designer, ve podcastler you are ayarla as producer için. Boş lists mean nothing is atandı yet.',
  'producerAssignments.errorForbidden': 'Erişim denied: sizin rol cannot kullan bu sayfa. Eğer you are bir eğitmen veya HR için sizin kuruluş, contact bir yönetici.',
  'producerAssignments.errorNoInstitution': 'Sizin hesap has hayır kurum linked in the database. Bir yönetici gerekir attach sizin kullanıcı to the kuruluş, sonra sign in tekrar.',
  'producerAssignments.errorGeneric': 'Could değil load sizin assignments.',
  'common.loading': 'Yükleniyor',
  'common.refresh': 'Yenile',
  'common.saving': 'Kaydediliyor...',
  'common.saved': 'Kaydedildi',
  'common.error': 'Hata',
  'common.success': 'Başarılı',
  'common.warning': 'Uyarı',
  'common.info': 'Bilgi',
  'common.yes': 'Evet',
  'common.no': 'Hayır',
  'common.or': 'veya',
  'common.and': 've',
  'common.all': 'Tümü',
  'common.none': 'Hiçbiri',
  'common.total': 'Toplam',
  'common.actions': 'Eylemler',
  'common.created_at': 'Oluşturuldu at',
  'common.updated_at': 'Güncellendi at',
  'common.sort_by': 'Sort tarafından',
  'common.per_page': 'Per sayfa',
  'common.page': 'Sayfa',
  'common.of': 'of',
  'common.results': '{{count}} sonuç(s)',
  'common.no_data': 'Veri yok',
  'common.coming_soon': 'Yakında',
  'common.beta': 'Beta',
  'common.new': 'Yeni',
  'common.delete_confirm': 'Bu eylem is irreversible. Devam et?',
  'common.copied': 'Kopyalandı!',
  'common.drag_drop': 'Sürükle ve bırak',
  'common.online': 'Çevrimiçi',
  'common.offline': 'Çevrimdışı',
  'common.version': 'Sürüm',
  'player.next': 'İleri',
  'player.previous': 'Önceki',
  'player.scrollDownHint': 'Scroll down için daha fazla',
  'player.image.clickForAnnotations': 'Tıkla the görsel to görüntüle annotations',
  'player.image.annotationNoDescription': 'Hayır birçıklama için bu annotation.',
  'player.image.noneAvailable': 'Hayır görsel mevcut',
  'player.manualVoiceoverMic': 'Kaydet voice-üzerinde için bu dil',
  'player.manualVoiceoverStudioTitle': 'Voice-üzerinde kayıt studio',
  'player.manualVoiceoverStudioLang': 'Kayıt dil',
  'player.manualVoiceoverRecord': 'Kaydet',
  'player.manualVoiceoverStop': 'Durdur',
  'player.manualVoiceoverPlay': 'Dinle',
  'player.manualVoiceoverSave': 'Kaydet to blok',
  'player.manualVoiceoverClose': 'Kapat',
  'player.manualVoiceoverHint': 'On the sağ: blok text veya görsel in the seçildi dil. Kaydet, sonra kaydet to attach the ses to bu dil.',
  'player.manualVoiceoverPreviewLoading': 'Yükleniyor içerik…',
  'player.manualVoiceoverNoMic': 'Microphone veya kayıt is değil mevcut in bu browser.',
  'player.manualVoiceoverNoText': 'Hayır birçıklama text long yeterli için bu blok.',
  'player.manualVoiceoverSaveError': 'Could değil kaydet the voice-üzerinde to the blok.',
  'player.manualVoiceoverUploadError': 'Ses yükle başarısız.',
  'player.manualVoiceoverSaved': 'Voice-üzerinde kaydedildi to the blok.',
  'eduflow.versionHistory': 'Sürüm history',
  'eduflow.versionHistory.count': '{{count}} sürüm(s)',
  'eduflow.versionHistory.create': 'Oluştur bir sürüm',
  'eduflow.versionHistory.createVersion': 'Oluştur v{{sürüm}}',
  'eduflow.versionHistory.minor': 'Minor',
  'eduflow.versionHistory.major': 'Major',
  'eduflow.versionHistory.minorBadge': 'Minor sürüm',
  'eduflow.versionHistory.majorBadge': 'Major sürüm',
  'eduflow.versionHistory.latest': 'En son',
  'eduflow.versionHistory.public': 'Genel sürüm',
  'eduflow.versionHistory.publicActive': 'Live',
  'eduflow.versionHistory.publish': 'Yayınla bu sürüm',
  'eduflow.versionHistory.publishCta': 'Yayınla',
  'eduflow.versionHistory.openPublicPlayer': 'birç genel player',
  'eduflow.versionHistory.copyPublicPlayer': 'Kopyala genel bağlantı',
  'eduflow.versionHistory.copyPublicPlayerError': 'Unable to kopyala the genel bağlantı',
  'eduflow.versionHistory.systemPublished': 'Yayınlandı {{sürüm}}',
  'eduflow.versionHistory.systemSaved': 'Kaydedildi {{sürüm}}',
  'eduflow.versionHistory.systemAutosaveRestore': 'Auto-kaydet önce restoring {{sürüm}}',
  'eduflow.versionHistory.descriptionPlaceholder': 'Describe the değişiklikler…',
  'eduflow.versionHistory.empty': 'Hayır sürüm oluşturuldu yet.',
  'eduflow.versionHistory.emptyHint': 'Kaydet bir sürüm to erişim it burada.',
  'eduflow.versionHistory.blocks': '{{count}} bloklar',
  'eduflow.versionHistory.restoreTitle': 'Geri yükle sürüm v{{sürüm}}?',
  'eduflow.versionHistory.restoreWarning': 'The mevcut içerik will be replaced. Bir otomatik backup will be oluşturuldu önce the geri yükle.',
  'eduflow.versionHistory.createSuccess': 'Sürüm {{sürüm}} oluşturuldu',
  'eduflow.versionHistory.createError': 'Hata iken oluşturuluyor the sürüm',
  'eduflow.versionHistory.restoreSuccess': 'Sürüm {{sürüm}} geri yüklendi',
  'eduflow.versionHistory.restoreError': 'Hata iken restoring the sürüm',
  'eduflow.versionHistory.publishSuccess': 'Sürüm {{sürüm}} yayınlandı',
  'eduflow.versionHistory.publishError': 'Hata iken yayınlanıyor the sürüm',
  'eduflow.versionHistory.now': 'sadece şimdi',
  'eduflow.versionHistory.minutesAgo': '{{count}} min önce',
  'eduflow.versionHistory.hoursAgo': '{{count}} h önce',
  'eduflow.versionHistory.yesterday': 'dün',
  'eduflow.versionHistory.daysAgo': '{{count}} gün önce',
  'podcast.episodes.pageTitle': 'Bölümler',
  'podcast.episodes.count': '{{count}} bölüm(s)',
  'podcast.episodes.newEpisode': 'Yeni bölüm',
  'podcast.episodes.searchPlaceholder': 'Ara tarafından başlık…',
  'podcast.episodes.filterAllStatuses': 'Tümü statuses',
  'podcast.episodes.filterDraft': 'Taslak',
  'podcast.episodes.filterPublished': 'Yayınlandı',
  'podcast.episodes.emptyTitle': 'Hayır episodes bulundu',
  'podcast.episodes.emptyHint': 'Oluştur sizin ilk bölüm to al başladı',
  'podcast.episodes.emptyCreateCta': 'Oluştur bir bölüm',
  'podcast.episodes.backPodcasts': 'Podcastler',
  'podcast.episodes.paginationTotal': '{{toplam}} bölüm(s) toplam',
  'podcast.episodes.pageOf': 'Sayfa {{sayfa}} / {{totalPages}}',
  'podcast.episodes.deleteTitle': 'Sil bu bölüm?',
  'podcast.episodes.deleteHint': '“{{başlık}}” will be permanently silindi.',
  'podcast.episodes.deleteCancel': 'İptal',
  'podcast.episodes.deleteConfirm': 'Sil',
  'podcast.episodes.statusPublished': 'Yayınlandı',
  'podcast.episodes.statusDraft': 'Taslak',
  'podcast.episodes.noDescription': 'Hayır birçıklama',
  'podcast.episodes.noAudio': 'Hayır ses',
  'podcast.episodes.retry': 'Tekrar Dene',
  'podcast.createEpisode.panelTitle': 'Yeni bölüm',
  'podcast.createEpisode.panelSubtitle': 'Gir bir başlık ve optionally bir birçıklama ve cover görsel. Sonra you onayla, the bölüm is oluşturuldu ve the editor opens to build the içerik.',
  'podcast.createEpisode.titleLabel': 'Başlık',
  'podcast.createEpisode.descriptionLabel': 'Açıklama',
  'podcast.createEpisode.coverLabel': 'Cover görsel (isteğe bağlı)',
  'podcast.createEpisode.coverHint': 'JPEG, PNG, WebP veya GIF — max 5 MB.',
  'podcast.createEpisode.coverChoose': 'Choose görsel',
  'podcast.createEpisode.coverRemove': 'Kaldır görsel',
  'podcast.createEpisode.titlePlaceholder': 'e.g. Safety modül introduction',
  'podcast.createEpisode.descriptionPlaceholder': 'Summary, goals… (isteğe bağlı)',
  'podcast.createEpisode.validate': 'Oluştur ve birç editor',
  'podcast.createEpisode.titleRequired': 'Başlık is zorunlu.',
  'podcast.createEpisode.error': 'Could değil oluştur the bölüm.',
  'podcast.createEpisode.uploadCoverError': 'Bölüm oluşturuldu, ama cover yükle başarısız.',
  'podcast.createEpisode.coverTooLarge': 'Görsel gerekir be 5 MB veya smaller.',
  'podcast.editor.defaultNewTitle': 'Yeni bölüm',
  'eduflow.title': 'EduFlow editor',
  'eduflow.new_flow': 'Yeni kurs',
  'eduflow.list.title': 'Kurslar',
  'eduflow.list.subtitle': 'Design sizin interactive öğrenme experiences',
  'eduflow.list.searchPlaceholder': 'Ara bir kurs…',
  'eduflow.list.import': 'İçe Aktar',
  'eduflow.list.importHint': '.lyrra package (medya included) veya legacy Lyrra V1 JSON dışbir aktar.',
  'eduflow.list.importSuccess': 'Kurs içe aktarıldı. Opening the designer.',
  'eduflow.list.importError': 'Could değil içe aktar — kontrol et the dosya (geçerli .lyrra veya JSON dışbir aktar, at least one blok).',
  'eduflow.list.filterAll': 'Tümü',
  'eduflow.list.filterDraft': 'Taslaklar',
  'eduflow.list.filterPublished': 'Yayınlandı',
  'eduflow.list.filterArchived': 'Arşivlendi',
  'eduflow.list.archiveFormation': 'Arşivle kurs',
  'eduflow.list.restoreFromArchive': 'Geri yükle from arşivle (taslak)',
  'eduflow.list.archiveSuccess': 'Kurs arşivlendi',
  'eduflow.list.archiveError': 'Could değil arşivle the kurs.',
  'eduflow.list.restoreSuccess': 'Kurs geri yüklendi as taslak',
  'eduflow.list.restoreError': 'Could değil geri yükle the kurs.',
  'eduflow.list.viewModeGrid': 'Grid görüntüle',
  'eduflow.list.viewModeList': 'Liste görüntüle',
  'eduflow.list.viewByCategory': 'Kategori görüntüle',
  'eduflow.list.categoryBack': 'Tümü kategoriler',
  'eduflow.list.categoryBrowseHint': 'Seç bir kategori to see its kurslar.',
  'eduflow.list.categoryFormationCount': '{{count}} kurs(s)',
  'eduflow.list.categoryEmptyFiltered': 'Hayır kurslar in bu görüntüle (aktif filtrele veya ara).',
  'eduflow.list.uncategorizedCardHint': 'Kurslar olmadan bir kategori etiket.',
  'eduflow.list.uncategorized': 'Uncategorized',
  'eduflow.list.manageCategories': 'Yönet kategoriler',
  'eduflow.list.categoriesPanelTitle': 'Kurs kategoriler',
  'eduflow.list.noCategoryAvailable': 'Hayır kategori mevcut.',
  'eduflow.list.categoriesSaveError': 'Unable to kaydet kategoriler.',
  'eduflow.list.emptyFilteredTitle': 'Sonuç yok',
  'eduflow.list.emptyFilteredHint': 'Dene changing sizin ara veya filtreler.',
  'eduflow.list.emptyFirstTitle': 'Oluştur sizin ilk kurs',
  'eduflow.list.emptyFirstHint': 'Build interactive öğrenme ile the visual designer.',
  'eduflow.list.emptyCreateCta': 'Oluştur benim ilk kurs',
  'eduflow.list.deleteToTrashTitle': 'Taşı bu kurs to trash?',
  'eduflow.list.deleteToTrashBody': '“{{başlık}}” will be kaldırıldı from sizin liste (soft sil). Sizin kuruluş can geri yükle it from the kurum trash.',
  'eduflow.list.deleteToTrashConfirm': 'Taşı to trash',
  'eduflow.createFormation.panelTitle': 'Yeni kurs',
  'eduflow.createFormation.panelSubtitle': 'Gir bir başlık ve birçıklama. Sonra you onayla, the kurs is oluşturuldu ve the designer opens to build the flow.',
  'eduflow.createFormation.titleLabel': 'Başlık',
  'eduflow.createFormation.descriptionLabel': 'Açıklama',
  'eduflow.createFormation.titlePlaceholder': 'e.g. Safety modül introduction',
  'eduflow.createFormation.descriptionPlaceholder': 'Goals, audience, etc. (isteğe bağlı)',
  'eduflow.createFormation.validate': 'Oluştur ve birç designer',
  'eduflow.createFormation.titleRequired': 'Başlık is zorunlu.',
  'eduflow.createFormation.error': 'Could değil oluştur the kurs.',
  'eduflow.shareFormation.title': 'Paylaş kurs',
  'eduflow.shareFormation.publicLinkTitle': 'Genel bağlantı (hayır sign-in)',
  'eduflow.shareFormation.publicLinkCopy': 'Kopyala bağlantı',
  'eduflow.shareFormation.publicLinkCopied': 'Kopyalandı',
  'eduflow.shareFormation.publishRequired': 'Yayınla the kurs to al bir bağlantı o works olmadan sign-in.',
  'eduflow.shareFormation.embedTitle': 'Embed düğme ve player modal',
  'eduflow.shareFormation.embedHint': 'Paste bu blok on sizin site. Include the script sadece bir kez per sayfa; için daha fazla kurslar, ekle extra buttons tarafından kopyalanıyor the düğme line ve changing the URL in veri-lyrra-eduflow-url. The player URL includes kenar çubuğu=0 so the outline starts collapsed in the modal embed.',
  'eduflow.shareFormation.embedCopy': 'Kopyala HTML code',
  'eduflow.shareFormation.embedCopied': 'Kopyalandı',
  'eduflow.shareFormation.embedCloseAria': 'Kapat',
  'eduflow.shareFormation.embedButtonLabel': 'birç: {{başlık}}',
  'eduflow.shareFormation.embedToggle': 'Website embed',
  'eduflow.shareFormation.removeAccessSuccess': 'Erişim kaldırıldı için the öğrenci.',
  'eduflow.shareFormation.removeAccessError': 'Unable to kaldır öğrenci erişim.',
  'eduflow.shareFormation.assignSuccess': 'Kurs paylaşıldı ve davet e-posta gönderildi.',
  'eduflow.shareFormation.assignError': 'Unable to ata bu öğrenci.',
  'eduflow.shareFormation.createAssignSuccess': 'Hesap oluşturuldu/linked, kurs atandı, ve davet e-posta gönderildi.',
  'eduflow.shareFormation.createLearnerError': 'Unable to oluştur öğrenci.',
  'eduflow.shareFormation.selectExistingLearner': 'Seç bir existing öğrenci',
  'eduflow.shareFormation.searchLearnerPlaceholder': 'Ara öğrenci (ilk ad, son ad, e-posta)',
  'eduflow.shareFormation.loadingLearners': 'Yükleniyor öğrenciler...',
  'eduflow.shareFormation.noLearnerAvailable': 'Hayır öğrenci mevcut.',
  'eduflow.shareFormation.hideQuickCreate': 'Gizle quick oluştur',
  'eduflow.shareFormation.createNewLearner': 'Oluştur bir yeni öğrenci',
  'eduflow.shareFormation.firstNameRequired': 'Ilk ad *',
  'eduflow.shareFormation.lastNameRequired': 'Son ad *',
  'eduflow.shareFormation.emailRequired': 'E-posta *',
  'eduflow.shareFormation.createShareInvite': 'Oluştur, paylaş, ve gönder davet',
  'eduflow.shareFormation.assignedLearnersCount_one': '{{count}} öğrenci atandı',
  'eduflow.shareFormation.assignedLearnersCount_other': '{{count}} öğrenciler atandı',
  'eduflow.shareFormation.noAssignedLearner': 'Hayır öğrenci atandı to bu kurs.',
  'eduflow.shareFormation.removeAccessTitle': 'Kaldır erişim',
  'eduflow.shareFormation.inviteEmailsTitle': 'Davet et tarafından e-posta (existing hesap)',
  'eduflow.shareFormation.inviteEmailsHint': 'One veya daha fazla addresses: LyrraOne accounts sadece (including another kurum). People olmadan bir hesap are atlandı — kullan “Oluştur yeni öğrenci” to davet et them.',
  'eduflow.shareFormation.inviteEmailsPlaceholder': 'One address per line veya comma-separated\\nexample@şirket.com, diğer@org.fr',
  'eduflow.shareFormation.inviteEmailsSubmit': 'Ekle these accounts to the kurs',
  'eduflow.shareFormation.inviteEmailsInvalid': 'Gir at least one geçerli e-posta address.',
  'eduflow.shareFormation.inviteEmailsError': 'Could değil ekle the addresses.',
  'eduflow.shareFormation.inviteEmailsSummaryOk': '{{count}} hesap(s) eklendi.',
  'eduflow.shareFormation.inviteEmailsSummaryNoAccount': '{{count}} ile hayır LyrraOne hesap.',
  'eduflow.shareFormation.inviteEmailsSummaryAlready': '{{count}} zaten atandı.',
  'eduflow.participant.flowTitle': 'Öğrenme yol',
  'eduflow.participant.stepWelcome': 'Hoş Geldiniz',
  'eduflow.participant.stepModule1': 'Modül 1',
  'eduflow.participant.stepEvaluation': 'Değerlendirme',
  'eduflow.participant.stepContentPlaceholder': 'Interactive adım içerik displayed için the öğrenci.',
  'eduflow.edit_flow': 'Düzenle yol',
  'eduflow.flow_name': 'Yol ad',
  'eduflow.block_palette': 'Blok palette',
  'eduflow.canvas': 'Canvas',
  'eduflow.properties': 'Properties',
  'eduflow.publish': 'Yayınla',
  'eduflow.publish_confirm': 'Are you sure you iste to yayınla bu yol?',
  'eduflow.save_draft': 'Kaydet taslak',
  'eduflow.preview': 'Önizleme',
  'eduflow.versions': 'Versions',
  'eduflow.add_block': 'Ekle blok',
  'eduflow.remove_block': 'Kaldır blok',
  'eduflow.connect_blocks': 'Connect bloklar',
  'eduflow.undo': 'Geri al',
  'eduflow.redo': 'Yinele',
  'eduflow.zoom_in': 'Yakınlaştır',
  'eduflow.zoom_out': 'Uzaklaştır',
  'eduflow.fit_view': 'Fit görüntüle',
  'eduflow.auto_layout': 'Auto layout',
  'eduflow.unsaved_changes': 'Unsaved değişiklikler',
  'eduflow.blocks.quiz_mcq': 'MCQ',
  'eduflow.blocks.quiz_open': 'birç soru',
  'eduflow.blocks.video': 'Video',
  'eduflow.blocks.audio': 'Ses',
  'eduflow.blocks.text': 'Metin',
  'eduflow.blocks.evaluation': 'Değerlendirme',
  'eduflow.blocks.form': 'Form',
  'eduflow.blocks.mindmap': 'Zihin Haritası',
  'eduflow.blocks.poll': 'Anket',
  'eduflow.blocks.flashcard': 'Flash Kart',
  'eduflow.blocks.timeline': 'Zaman Çizelgesi',
  'eduflow.blocks.pdf': 'PDF belge',
  'eduflow.blocks.image': 'Görsel',
  'eduflow.blocks.code': 'Kod',
  'eduflow.blocks.whiteboard': 'Beyaz Tahta',
  'eduflow.blocks.ai_chat': 'AI sohbet',
  'eduflow.blocks.certificate': 'Sertifika',
  'eduflow.blocks.attendance': 'Attendance',
  'eduflow.blocks.sortable': 'Sıralama',
  'eduflow.blocks.pair_matching': 'Eşleştirme',
  'eduflow.blocks.drawing': 'Çizim',
  'eduflow.blocks.embed': 'Embedded içerik',
  'eduflow.blocks.h5p': 'H5P',
  'eduflow.blocks.scorm': 'SCORM',
  'eduflow.blocks.conditional': 'Koşul',
  'eduflow.blocks.timer': 'Zamanlayıcı',
  'eduflow.blocks.randomizer': 'Rastgele',
  'eduflow.blocks.grouping': 'Gruplama',
  'eduflow.blocks.debate': 'Tartışma',
  'eduflow.blocks.roleplay': 'Rol oynat',
  'eduflow.blocks.simulation': 'Simülasyon',
  'eduflow.blocks.scenario': 'Senaryo',
  'eduflow.blocks.checklist': 'Kontrol Listesi',
  'eduflow.blocks.kanban': 'Kanban',
  'eduflow.blocks.peer_review': 'Peer değerlendirme',
  'eduflow.designer.paletteCategory.structure': 'Yol & structure',
  'eduflow.designer.paletteCategory.content': 'Içerik & medya',
  'eduflow.designer.paletteCategory.interactive': 'Activities & değerlendirme',
  'eduflow.designer.paletteCategory.accessibility': 'Accessibility (DYS)',
  'eduflow.designer.paletteCategory.enterprise': 'Uyumluluk & gelişmiş',
  'eduflow.designer.flowSettings.toolbarTitle': 'Kurs & player ayarlar',
  'eduflow.designer.flowSettings.panelTitle': 'Kurs ayarlar',
  'eduflow.designer.flowSettings.intro': 'Shown in the player (başlık, birçıklama, cover). You can gizle the “Önceki” düğme için bir strictly linear yol.',
  'eduflow.designer.flowSettings.titleLabel': 'Kurs başlık',
  'eduflow.designer.flowSettings.descriptionLabel': 'Kurs birçıklama',
  'eduflow.designer.flowSettings.coverLabel': 'Cover görsel',
  'eduflow.designer.flowSettings.coverUpload': 'Yükle bir görsel',
  'eduflow.designer.flowSettings.coverUrlPlaceholder': 'Veya paste bir görsel URL (https://…)',
  'eduflow.designer.flowSettings.coverRemove': 'Kaldır cover',
  'eduflow.designer.flowSettings.allowPreviousLabel': '“Önceki” düğme in the player',
  'eduflow.designer.flowSettings.allowPreviousHint': 'Ne zaman off, öğrenciler cannot git geri to the önceki blok (including keyboard shortcuts).',
  'eduflow.designer.flowSettings.coverUploadError': 'Could değil yükle the cover görsel.',
  'eduflow.designer.flowSettings.certificate.uploadError': 'Geçersiz server yanıt.',
  'eduflow.designer.flowSettings.certificate.uploadFailed': 'Could değil yükle the Word şablon.',
  'eduflow.designer.blockLabel.start': 'Başla',
  'eduflow.designer.blockLabel.end': 'Son',
  'eduflow.designer.blockLabel.summary': 'Özet',
  'eduflow.designer.blockLabel.form': 'Form',
  'eduflow.designer.blockLabel.loop': 'Loop',
  'eduflow.designer.blockLabel.merge': 'Merge',
  'eduflow.designer.blockLabel.split': 'Branch',
  'eduflow.designer.blockLabel.subflow': 'Sub-eğitim',
  'eduflow.designer.blockLabel.timer': 'Zamanlayıcı',
  'eduflow.designer.blockLabel.email': 'Automated e-posta',
  'eduflow.designer.blockLabel.text': 'Metin',
  'eduflow.designer.blockLabel.podcast': 'Podcast',
  'eduflow.designer.blockLabel.video': 'Video',
  'eduflow.designer.blockLabel.audio': 'Ses',
  'eduflow.designer.blockLabel.image': 'Annotated görsel',
  'eduflow.designer.blockLabel.pdf': 'PDF belge',
  'eduflow.designer.blockLabel.browser': 'Embedded web sayfa',
  'eduflow.designer.blockLabel.presentation': 'Slideshow',
  'eduflow.designer.blockLabel.timeline': 'Zaman Çizelgesi',
  'eduflow.designer.blockLabel.chart': 'Interactive grafik',
  'eduflow.designer.blockLabel.mindmap': 'Zihin Haritası',
  'eduflow.designer.blockLabel.visual_ai': 'AI visual',
  'eduflow.designer.blockLabel.quiz_mcq': 'Sınav (MCQ / T-F / sipariş)',
  'eduflow.designer.blockLabel.poll': 'Live anket',
  'eduflow.designer.blockLabel.self_assessment': 'Self-değerlendirme',
  'eduflow.selfAssessment.panelTitle': 'Self-değerlendirme',
  'eduflow.selfAssessment.panelHint': 'Define her dimension to rate: bir short başlık ve, eğer gerekli, bir birçıklama to guide the öğrenci.',
  'eduflow.selfAssessment.scaleLabel': 'Puan scale',
  'eduflow.selfAssessment.scaleHint': 'From 1 to N (e.g. 5 = Likert)',
  'eduflow.selfAssessment.criteriaSection': 'Kriterler',
  'eduflow.selfAssessment.addCriterion': 'Ekle',
  'eduflow.selfAssessment.emptyCriteria': 'Hayır criteria yet. Ekle at least one so öğrenciler can self-assess.',
  'eduflow.selfAssessment.criterionTitle': 'Başlık',
  'eduflow.selfAssessment.criterionTitlePh': 'e.g. Communication, Autonomy…',
  'eduflow.selfAssessment.criterionDescription': 'birçıklama (isteğe bağlı)',
  'eduflow.selfAssessment.criterionDescriptionPh': 'Clarify ne the öğrenci should reflect on veya observe…',
  'eduflow.selfAssessment.moveUp': 'Taşı up',
  'eduflow.selfAssessment.moveDown': 'Taşı down',
  'eduflow.selfAssessment.removeCriterion': 'Kaldır bu criterion',
  'eduflow.selfAssessment.responseTypeLabel': 'Yanıt tür',
  'eduflow.selfAssessment.typeNumeric': 'Numbers',
  'eduflow.selfAssessment.typeNumericHint': 'Buttons 1 to N',
  'eduflow.selfAssessment.typeStars': 'Stars',
  'eduflow.selfAssessment.typeStarsHint': 'Visual puan',
  'eduflow.selfAssessment.typeText': 'Ücretsiz text',
  'eduflow.selfAssessment.typeTextHint': 'Badges (short words) veya ücretsiz text per criterion',
  'eduflow.selfAssessment.badgeOptionsLabel': 'Seçenekler (badges)',
  'eduflow.selfAssessment.badgeOptionsHint': 'Short words veya phrases — öğrenciler seç them as chips. Eğer boş → ücretsiz-text field.',
  'eduflow.selfAssessment.removeBadge': 'Kaldır',
  'eduflow.selfAssessment.badgeInputPlaceholder': 'e.g. Sık sık, Asla, Bazen…',
  'eduflow.selfAssessment.addBadge': 'Ekle',
  'eduflow.selfAssessment.starCountLabel': 'Number of stars',
  'eduflow.selfAssessment.starCountHint': 'Sık sık 5',
  'eduflow.selfAssessment.textModeHint': 'Öğrenciler yaz bir cevap için her criterion. The global yorum field remains altında in the player.',
  'eduflow.designer.blockLabel.evaluation': 'Multi-soru değerlendirme',
  'eduflow.designer.blockLabel.phrase_reveal': 'Progressive reveal',
  'eduflow.designer.blockLabel.voice_assessment': 'Voice değerlendirme',
  'eduflow.designer.blockLabel.dys_reader': 'DYS reader (syllables + TTS)',
  'eduflow.designer.blockLabel.dys_image_zones': 'Interactive görsel zones',
  'eduflow.designer.blockLabel.dys_clock': 'DYS renk clock',
  'eduflow.designer.blockLabel.dys_reading_practice': 'Adapted reading exercise',
  'eduflow.designer.blockLabel.glossary': 'Glossary + built-in sınav',
  'eduflow.designer.blockLabel.html': 'Özel HTML / JavaScript',
  'eduflow.designer.blockLabel.certification': 'Sertifika (Word şablon)',
  'eduflow.designer.blockLabel.signature': 'Öğrenci signature',
  'eduflow.designer.blockLabel.facial_recognition': 'Facial recognition',
  'eduflow.designer.blockLabel.attendance': 'Digital attendance',
  'eduflow.designer.startBlockTitle': 'Başla',
  'eduflow.designer.placeholderUntitled': 'Untitled',
  'eduflow.designer.placeholderFlowDescription': 'Eğitim birçıklama (max 255 characters)',
  'eduflow.designer.saving': 'Kaydediliyor…',
  'eduflow.designer.unsaved': 'Değil kaydedildi',
  'eduflow.designer.saved': 'Kaydedildi',
  'eduflow.designer.blocksPanelTitle': 'Bloklar',
  'eduflow.designer.paletteSearchLabel': 'Ara bloklar',
  'eduflow.designer.paletteSearchPlaceholder': 'Ara bloklar…',
  'eduflow.designer.paletteSearchEmpty': 'Hayır bloklar match sizin ara.',
  'eduflow.designer.autoLayoutShort': 'Auto-layout',
  'eduflow.designer.validate': 'Doğrula',
  'eduflow.designer.validateTitle': 'Doğrula yol',
  'eduflow.designer.validationBeforePreview': 'Düzeltme yol hatalar önce önizleme.',
  'eduflow.designer.validationBeforePublish': 'Düzeltme yol hatalar önce yayınlanıyor.',
  'eduflow.designer.aiShort': 'AI',
  'eduflow.designer.aiTitle': 'AI assistant',
  'eduflow.designer.ragChatbotTitle': 'Kurs chatbot',
  'eduflow.ragChatbot.panelTitle': 'Kurs chatbot (RAG)',
  'eduflow.ragChatbot.loadError': 'Could değil load chatbot ayarlar.',
  'eduflow.ragChatbot.needDoc': 'Ekle at least one belge önce enabling the chatbot.',
  'eduflow.ragChatbot.enabledOk': 'Chatbot etkin için the player.',
  'eduflow.ragChatbot.disabledOk': 'Chatbot devre dışı.',
  'eduflow.ragChatbot.toggleError': 'Could değil güncelle.',
  'eduflow.ragChatbot.uploadOk': 'Belge indexed.',
  'eduflow.ragChatbot.uploadSavedNotIndexed': 'Belge kaydedildi. It will değil be kullanıldı için RAG kadar the vector store is yapılandırıldı on the server.',
  'eduflow.ragChatbot.ragIndexFailed': 'Belge kaydedildi ama değil indexed. Kontrol et pgvector (DATABASE_VECTOR_URL) ve Mistral, sonra re-yükle eğer gerekli.',
  'eduflow.ragChatbot.uploadError': 'Yükle veya indexing başarısız.',
  'eduflow.ragChatbot.confirmDelete': 'Sil bu belge ve its index?',
  'eduflow.ragChatbot.deleted': 'Belge kaldırıldı.',
  'eduflow.ragChatbot.deleteError': 'Could değil sil.',
  'eduflow.ragChatbot.vectorHint': 'To index PDF / TXT / MD: ayarla DATABASE_VECTOR_URL veya PGVECTOR_HOST (PostgreSQL + pgvector) ve Mistral in Admin → Platform entegrasyonlar (API key + embedding model). Otherwise yükle ve indexing başarısız.',
  'eduflow.ragChatbot.chatHint': 'Player cevaplar ve RAG embeddings kullan Mistral. Yüklendi belgeler are retrieved ile Mistral embeddings + pgvector; ile hayır belgeler, sadece blok text is kullanıldı as context.',
  'eduflow.ragChatbot.playerToggle': 'Göster in player',
  'eduflow.ragChatbot.playerToggleHint': 'Öğrenciler sor sorular sadece hakkında bu kurs: blok text in the yol, plus indexed belgeler eğer you eklendi herhangi.',
  'eduflow.ragChatbot.addDocument': 'Ekle belge (PDF, TXT, MD)',
  'eduflow.ragChatbot.docCount': 'Indexed belgeler: {{count}}',
  'eduflow.ragChatbot.emptyDocs': 'Hayır belgeler. The chatbot will kullan kurs blok text sadece.',
  'eduflow.ragChatbot.open': 'birç assistant',
  'eduflow.ragChatbot.dialogTitle': 'Kurs assistant',
  'eduflow.ragChatbot.playerDisclaimer': 'Cevaplar are based on bu kurs’s belgeler ve içerik sadece.',
  'eduflow.ragChatbot.playerWelcome': 'Sor bir soru hakkında the kurs veya the provided belgeler.',
  'eduflow.ragChatbot.playerError': 'Could değil al bir yanıt. Lütfen dene tekrar sonra.',
  'eduflow.ragChatbot.placeholder': 'Sizin soru…',
  'eduflow.ragChatbot.send': 'Gönder',
  'eduflow.designer.aiPanel.welcome': 'Tür sizin istek altında. **The blok birç in Properties** is the varsayılan hedef (rewrite, translate…). Kullan **Seçenekler** (alt) için streaming, auto-uygula, URLs, belge içe aktar, ve shortcuts.',
  'eduflow.designer.aiPanel.subtitle': 'Copilot: içerik, graph, ve objectives.',
  'eduflow.designer.aiPanel.focusContextLabel': 'Hedef:',
  'eduflow.designer.aiPanel.focusPrimary': '"{{etiket}}" ({{tür}}) — Properties',
  'eduflow.designer.aiPanel.focusMulti': '{{count}} bloklar seçildi — söyle hangi to düzenle, veya focus one blok.',
  'eduflow.designer.aiPanel.focusNone': 'Hayır focused blok — birç Properties on bir node veya ad bir blok in sizin mesaj.',
  'eduflow.designer.aiPanel.followUpsLabel': 'Suggested sonraki adımlar',
  'eduflow.designer.aiPanel.ideasToggle': 'Ready-yapıldı ideas',
  'eduflow.designer.aiPanel.advancedToggle': 'Seçenekler (stream, sources, shortcuts…)',
  'eduflow.designer.aiPanel.removeDocument': 'Kaldır',
  'eduflow.designer.aiPanel.importDocumentTitle': 'Içe aktar PDF, Word, veya PowerPoint',
  'eduflow.designer.aiPanel.webSourcesLabel': 'Web sayfalar (max 3, isteğe bağlı)',
  'eduflow.designer.aiPanel.webSourcesPlaceholder': 'https://example.org/doc\\nhttps://…',
  'eduflow.designer.aiPanel.idea.auditPath': 'Audit the graph: broken yollar, isolated nodes ve flow sipariş — uygula fixes',
  'eduflow.designer.aiPanel.idea.microLearning': 'Design bir concise micro‑öğrenme variant from the mevcut flow iken preserving intent',
  'eduflow.designer.aiPanel.idea.formativeGap': 'Insert short formative bridging activities wherever the pathway is cognitively heavy',
  'eduflow.designer.aiPanel.idea.titleCoherence': 'Align blok titles ile the proje başlık ve the overall eğitim tone',
  'eduflow.designer.aiPanel.idea.remediation': 'Ekle bir remediation yol sonra the main MCQ sınav (başarısızlık / düşük-puan branch)',
  'eduflow.designer.aiPanel.idea.mobileWording': 'Shorten ve clarify HTML text in bloklar o are çok long on mobile',
  'eduflow.designer.aiPanel.idea.quizWording': 'Unify wording style across tümü sınav instructions (“Seç…”, tone, formal register)',
  'eduflow.designer.aiPanel.idea.summaryBeforeEnd': 'Ekle veya rewrite bir recap blok immediately önce the Son node',
  'eduflow.designer.aiPanel.streamMode': 'Streaming',
  'eduflow.designer.aiPanel.streamModeHint': 'Yanıt streams as it generates; the final payload is normalized like non-streaming mode.',
  'eduflow.designer.aiPanel.streamError': 'Stream interrupted veya refused.',
  'eduflow.designer.aiPanel.streamIncomplete': 'Incomplete yanıt from server. Tekrar dene veya devre dışı bırak streaming.',
  'eduflow.designer.aiPanel.skillPath': 'Yol audit (server)',
  'eduflow.designer.aiPanel.skillPathHint': 'Structural graph analysis eklendi to the prompt.',
  'eduflow.designer.aiPanel.skillQuiz': 'Strict MCQ schema (server)',
  'eduflow.designer.aiPanel.skillQuizHint': 'Official Lyrra quiz_mcq şablon in the prompt.',
  'eduflow.designer.aiPanel.serverSkills': 'Server boosts',
  'eduflow.designer.aiPanel.quickActions': 'Quick eylemler',
  'eduflow.designer.aiPanel.placeholder': 'Sor bir soru, brainstorm, değerlendirme içerik, veya değiştir the yol…',
  'eduflow.designer.aiPanel.apply': 'Uygula to canvas',
  'eduflow.designer.aiPanel.autoApply': 'Auto-uygula to graph',
  'eduflow.designer.aiPanel.autoApplyHint': 'Structured assistant operations güncelle the yol olmadan tıklanıyor Uygula.',
  'eduflow.designer.aiPanel.dismissOps': 'Dismiss',
  'eduflow.designer.aiPanel.applied': 'Değişiklikler uygulandı to the yol.',
  'eduflow.designer.aiPanel.applyPartial': 'Uygulandı ile uyarılar: {{details}}',
  'eduflow.designer.aiPanel.applyFailed': 'Hayır operations could be uygulandı to the canvas (geçersiz operation format veya blok types).',
  'eduflow.designer.aiPanel.objectivesSaved': 'Öğrenme objectives kaydedildi (Objectives panel).',
  'eduflow.designer.aiPanel.objectivesSaveError': 'Could değil kaydet objectives. Lütfen dene tekrar.',
  'eduflow.designer.aiPanel.error': 'Could değil reach the assistant. Kontrol et sizin AI yapılandırma (API key) ve network.',
  'eduflow.designer.aiPanel.newConversation': 'Yeni conversation',
  'eduflow.designer.aiPanel.clearConversation': 'Clear conversation',
  'eduflow.designer.aiPanel.conversationHistory': 'Geçmiş',
  'eduflow.designer.aiPanel.deleteConversation': 'Sil',
  'eduflow.designer.aiPanel.maxConversations': 'You’ve reached the limit of {{max}} kaydedildi conversations. Sil one to başlangıç bir yeni one.',
  'eduflow.designer.aiPanel.unnamedConversation': 'Konuşma',
  'eduflow.designer.aiQuick.plan': 'Yol plan',
  'eduflow.designer.aiQuick.expand': 'Interactive bloklar',
  'eduflow.designer.aiQuick.quiz': 'Sınav modül',
  'eduflow.designer.aiQuick.objectives': 'Objectives (panel)',
  'eduflow.designer.aiQuick.rewriteFocus': 'Rewrite Properties blok',
  'eduflow.designer.aiQuick.translateFocus': 'Translate Properties blok (FR)',
  'eduflow.designer.voiceShort': 'Voice',
  'eduflow.designer.voiceTitle': 'Voice ayarlar',
  'eduflow.designer.objectivesShort': 'Objectives',
  'eduflow.designer.objectivesTitle': 'Öğrenme objectives',
  'eduflow.designer.flowVariablesTitle': 'Global variables',
  'eduflow.designer.flowVariables.subtitle': 'Ayarla key / value pairs. Kullan @ followed tarafından the key ad in blok titles ve descriptions (e.g. @course_name). Values are substituted için öğrenciler.',
  'eduflow.designer.flowVariables.empty': 'Hayır variables yet. Ekle bazı to personalize kurs wording.',
  'eduflow.designer.flowVariables.keyLabel': 'Anahtar',
  'eduflow.designer.flowVariables.keyPlaceholder': 'e.g. course_name',
  'eduflow.designer.flowVariables.keyHelp': 'Letters, numbers, hyphen ve underscore sadece. @key matching is case-sensitive.',
  'eduflow.designer.flowVariables.valueLabel': 'Varsayılan value',
  'eduflow.designer.flowVariables.valuePlaceholder': 'Text shown bunun yerine of @key',
  'eduflow.designer.flowVariables.add': 'Ekle variable',
  'eduflow.designer.flowVariables.delete': 'Kaldır',
  'eduflow.designer.flowVariables.invalidKey': 'Her key gerekir be ayarla ve kullan sadece allowed characters.',
  'eduflow.designer.flowVariables.duplicateKey': 'Çoğalt keys (case-insensitive) are değil allowed.',
  'eduflow.designer.flowVariables.savedToast': 'Variables kaydedildi',
  'eduflow.designer.flowVariables.errorToast': 'Could değil kaydet variables.',
  'eduflow.designer.flowVariables.saveNow': 'Kaydet şimdi',
  'eduflow.designer.blockFlowVariablesHint': 'Global variables: kullan @your_key in the başlık veya birçıklama (yapılandır them ile the { } simge in the toolbar).',
  'eduflow.designer.blockFlowVariablesPreviewTitle': 'Önizleme (başlık)',
  'eduflow.designer.blockFlowVariablesPreviewDescription': 'Önizleme (birçıklama)',
  'eduflow.designer.flowVariables.mentionNoMatch': 'Hayır matching variable.',
  'eduflow.designer.formFieldsSlash.mentionNoMatch': 'Hayır matching field.',
  'eduflow.designer.onlineCount': '{{count}} çevrimiçi',
  'eduflow.designer.editingBlocks_one': '{{count}} blok being düzenlendi',
  'eduflow.designer.editingBlocks_other': '{{count}} bloklar being düzenlendi',
  'eduflow.designer.invite': 'Davet Et',
  'eduflow.designer.inviteTitle': 'Davet et bir işbirlikçi',
  'eduflow.designer.exportTitle': 'Dışbir aktar yol',
  'eduflow.designer.importTitle': 'Içe aktar kurs (dosya veya JSON paste)',
  'eduflow.designer.exportNeedSavedFlow': 'Kaydet the kurs ilk to dışbir aktar bir .lyrra package.',
  'eduflow.designer.canvasUntitled': 'Untitled',
  'eduflow.designer.selectBlock': 'Seç bir blok',
  'eduflow.designer.selectBlockHint': 'Tıkla bir blok on the canvas to düzenle its properties',
  'eduflow.designer.blockPropertiesSubtitle': 'Blok properties',
  'eduflow.designer.blockLockedReadOnly': 'Bu blok is kilitli: properties are shown as oku-sadece.',
  'eduflow.designer.blockTitleField': 'Başlık',
  'eduflow.designer.blockTitlePlaceholder': 'Blok başlık',
  'eduflow.designer.newFlowDefaultTitle': 'Yeni kurs',
  'eduflow.designer.you': 'You',
  'eduflow.designer.blockInfoPosition': 'ID: {{id}} | Position: ({{x}}, {{y}})',
  'eduflow.designer.toastBlockCopied': 'Blok kopyalandı',
  'eduflow.designer.toastCollaboratorInvited': 'Işbirlikçi davet edildi',
  'eduflow.designer.toastInviteError': 'Could değil davet et bu işbirlikçi',
  'eduflow.designer.createFlowError': 'Could değil oluştur the yol',
  'eduflow.designer.loadFlowError': 'Could değil load bu eğitim.',
  'eduflow.designer.loadFlowForbidden': 'You do değil have erişim to bu eğitim.',
  'eduflow.designer.loadFlowNotFound': 'Eğitim değil bulundu veya kaldırıldı.',
  'eduflow.duplicateFlowError': 'Could değil çoğalt the eğitim.',
  'eduflow.designer.editConnection': 'Düzenle connection',
  'eduflow.designer.deleteConnection': 'Sil connection',
  'eduflow.translation.toolbarTitle': 'Içerik translation',
  'eduflow.translation.toolbarShort': 'Çevir',
  'eduflow.translation.title': 'Multilingual translation',
  'eduflow.translation.subtitle': 'Translate blok text (AI) ve optionally regenerate birçıklama voiceovers. Sonuçlar are stored per dil.',
  'eduflow.translation.subtitleV2': 'Seç bir Mistral voice per dil için birçıklama voiceovers in the player (on-demand translation). Batch translation jobs altında are isteğe bağlı.',
  'eduflow.translation.voicesSection': 'TTS voices per dil',
  'eduflow.translation.voicesSectionHint': 'Önizleme uses sample text in o dil. Ile hayır voice seçildi, “Marie - sad” is kullanıldı için French, Italian ve Spanish; “Paul - sad” için diğer diller.',
  'eduflow.translation.voicesLangCount': '{{count}} diller (FR, EN, ES, DE, IT, PT, LB, UK, RU, AR): seç bir voice, sonra tap “Oynat sample”.',
  'eduflow.translation.voicesLoadError': 'Could değil load voices. Kontrol et sizin connection veya dene tekrar.',
  'eduflow.translation.voicePreview': 'Oynat sample',
  'eduflow.translation.previewStop': 'Durdur',
  'eduflow.translation.voicePlaceholder': '— Choose bir voice —',
  'eduflow.translation.voiceSelectAria': 'Voice için {{lang}}',
  'eduflow.translation.voicesSaveError': 'Could değil kaydet voices.',
  'eduflow.translation.selectVoiceFirst': 'Choose bir voice için bu dil ilk.',
  'eduflow.translation.previewError': 'Ses playback başarısız.',
  'eduflow.translation.batchSection': 'Precomputed translations (isteğe bağlı)',
  'eduflow.translation.batchSectionHint': 'The player can translate on the fly; çalıştır bir job sadece eğer you iste text + ses stored ahead of time.',
  'eduflow.translation.sourceLang': 'Kurs source dil',
  'eduflow.translation.bulkSection': 'Tümü diller',
  'eduflow.translation.includeText': 'Metin',
  'eduflow.translation.includeAudio': 'Ses (birçıklama voiceover)',
  'eduflow.translation.runAll': 'Translate tümü diller (except source)',
  'eduflow.translation.runAllHint': 'Starts one job per hedef dil among the 12 supported languages, excluding the source dil.',
  'eduflow.translation.perLanguage': 'Per dil',
  'eduflow.translation.sourceBadge': 'Kaynak',
  'eduflow.translation.runOne': 'Çevir',
  'eduflow.translation.history': 'Son jobs',
  'eduflow.translation.noHistory': 'Hayır jobs yet.',
  'eduflow.translation.saveFirst': 'Kaydet the yol önce başlıyor bir translation.',
  'eduflow.translation.prefsSaveError': 'Could değil kaydet translation preferences (per-dil Text / Ses toggles).',
  'eduflow.translation.jobStarted': 'Translation başladı için {{lang}}.',
  'eduflow.translation.jobError': 'Could değil başlangıç translation.',
  'eduflow.translation.bulkStarted': '{{count}} translation job(s) başladı.',
  'eduflow.translation.bulkNone': 'Hayır yeni jobs: translations may zaten be çalışıyor için tümü hedef diller, veya hayır seçenekler were seçildi.',
  'eduflow.translation.bulkError': 'Could değil başlangıç bulk translations.',
  'eduflow.translation.statusPending': 'Beklemede',
  'eduflow.translation.statusProcessing': 'Devam ediyor',
  'eduflow.translation.statusCompleted': 'Tamamlandı',
  'eduflow.translation.statusFailed': 'Başarısız',
  'eduflow.translation.missingSourceAudioHint': 'Ses translation: oluştur the birçıklama voiceover in {{lang}} için her long birçıklama ilk. Blok(s) missing ses ({{count}}): {{bloklar}}.',
  'eduflow.translation.missingSourceAudioToast': '{{count}} blok(s) olmadan source-dil voiceover: {{bloklar}}. Oluştur ses from the blok properties, sonra dene tekrar.',
  'player.complete': 'Tamamla',
  'player.exit': 'Exit',
  'player.fullscreen': 'Tam ekran',
  'player.exitFullscreen': 'Exit fullscreen',
  'player.webinarFollowBanner': 'You are takip edilen the host — navigation is kilitli. You can değiştir the display dil kullanarak the globe düğme.',
  'player.textBlockTipsHeading': 'Tips',
  'player.textBlockReadDone': 'Reading tamamla',
  'player.institutionLogo': 'Kuruluş logosu',
  'player.exitConfirmTitle': 'Exit eğitim?',
  'player.exitConfirmMessage': 'Sizin ilerleme will be kaydedildi. Are you sure you iste to exit?',
  'player.cancel': 'İptal',
  'player.summary': 'Özet',
  'player.summary.badge': 'Recap',
  'player.summary.noItems': 'Hayır summary puanlar were defined için bu blok.',
  'player.summary.blockTranslating': 'Translating…',
  'player.summary.blockSimplifying': 'Simplifying text…',
  'player.simplifiedTextLoadingTitle': 'Preparing simplified text…',
  'player.simplifiedTextLoadingHint': 'We simplify the görünür blok ilk, sonra the rest of the kurs in the arka plan.',
  'player.contents': 'İçerik',
  'player.progress': 'İlerleme',
  'player.block': 'Blok',
  'player.parallelBranches': 'Parallel branches',
  'player.parallelBranchesTitle': 'Ne’s sonraki?',
  'player.parallelBranchesHint': 'The diğer seçenekler will be offered sonra.',
  'player.parallelBranchShowFull': 'Göster daha fazla',
  'player.parallelBranchShowLess': 'Göster daha az',
  'player.parallelBranchChoose': 'Aç',
  'player.parallelBranchDismiss': 'Kapat',
  'player.parallelBranchDismissHint': 'Return to the blok. Kullan “Sonraki” to choose bir branch.',
  'player.parallelBranchesPickTitle': 'Choose sizin sonraki yol',
  'player.parallelBranchesPickHint': 'Yollar you zaten took are marked “Tamamlandı”. Bitir her remaining branch önce the paylaşıldı part of the kurs.',
  'player.parallelBranchFromBlock': 'From: {{başlık}}',
  'player.parallelBranchesProgress': '{{tamamlandı}} / {{toplam}} yollar tamamlandı',
  'player.parallelBranchesOverview': 'İlerleme',
  'player.parallelBranchStatusDone': 'Tamamlandı',
  'player.parallelBranchStatusTodo': 'Beklemede',
  'player.parallelBranchStatusNext': 'Up sonraki',
  'player.parallelBranchAction': 'Al bu yol',
  'player.notes': 'Al notlar...',
  'player.noBlocks': 'Hayır bloklar to display.',
  'player.contentTranslatingTitle': 'Adapting içerik to sizin dil…',
  'player.contentTranslatingHint': 'Translation in ilerleme. The ilk load may al bir little longer.',
  'player.contentLanguageReloadFailed': 'Could değil reload içerik in bu dil (timeout veya server hata). The önceki sürüm is hâlâ shown. Dene tekrar shortly veya precompute translations in the designer.',
  'player.contentLanguageSubflowHint': 'To güncelle text ve ses, bitir veya ayrıl the mevcut sub-bölüm, sonra seç the dil tekrar.',
  'player.defaultFlowTitle': 'Kurs',
  'player.docTitle.error': 'Kurs mevcut değil',
  'player.docTitle.completed': 'Kurs tamamlandı',
  'player.docTitle.loading': 'Yükleniyor kurs',
  'player.docTitle.fallback': 'Kurs',
  'player.initError.title': 'The kurs is temporarily mevcut değil',
  'player.initError.loadFailed': 'The kurs could değil be loaded sağ şimdi.',
  'player.initError.loadFailedWithDetail': 'The kurs could değil be loaded sağ şimdi.{{detail}} Lütfen dene tekrar in bir moment.',
  'player.initError.hintsIntro': 'You can:',
  'player.initError.hintRefresh': 'yenile the sayfa;',
  'player.initError.hintConnection': 'kontrol et sizin internet connection;',
  'player.initError.hintRetryLater': 'dene tekrar in bir birkaç dakika.',
  'api.error.network': 'Unable to reach the server. Kontrol et sizin connection.',
  'api.error.unexpected': 'Bir unexpected hata occurred.',
  'api.error.badRequest': 'Geçersiz istek.',
  'api.error.forbidden': 'Erişim denied.',
  'api.error.notFound': 'Kaynak değil bulundu.',
  'api.error.conflict': 'Conflict — bu kaynak zaten exists.',
  'api.error.unprocessable': 'The gönderildi veri is değil geçerli.',
  'api.error.tooManyRequests': 'Çok birçok istekler. Lütfen dene tekrar shortly.',
  'api.error.server': 'Internal server hata.',
  'api.error.badGateway': 'Service temporarily mevcut değil.',
  'api.error.maintenance': 'Service altında maintenance.',
  'api.error.generic': 'Hata {{durum}}',
  'player.textBlockReadMinutes': '{{count}} min oku',
  'player.textBlockWordCount_one': '{{count}} word',
  'player.textBlockWordCount_other': '{{count}} words',
  'player.textBlockNoContent': 'Hayır içerik mevcut.',
  'player.blockUnknown': 'Unknown blok',
  'player.objectivesPanelTitle': 'Öğrenme objectives',
  'player.objectivesOpenLabel': 'Görüntüle öğrenme objectives',
  'player.objectivesCloseLabel': 'Kapat objectives panel',
  'player.objectivesAchievementRate': 'Başarı rate',
  'player.objectivesAchievedCount': '{{achieved}}/{{toplam}} objectives achieved',
  'player.objectivesNoneDefined': 'Hayır objectives defined için bu kurs.',
  'player.objectiveCategory.savoir': 'Bilgi',
  'player.objectiveCategory.savoirFaire': 'Beceriler',
  'player.objectiveCategory.savoirEtre': 'Attitudes',
  'player.objectiveLevel.connaissance': 'Bilgi',
  'player.objectiveLevel.comprehension': 'Kavrama',
  'player.objectiveLevel.application': 'Uygulama',
  'player.objectiveLevel.analyse': 'Analiz',
  'player.objectiveLevel.synthese': 'Sentez',
  'player.objectiveLevel.evaluation': 'Değerlendirme',
  'player.objectiveBloom': 'Bloom · {{seviye}}',
  'player.objectiveRequired': 'Zorunlu',
  'player.objectiveLinkedBlocks': 'Linked bloklar',
  'player.objectiveCriterionScore': 'Puan ≥ {{min}}%',
  'player.objectiveCriterionCompletion': 'Blok tamamlanma',
  'player.objectiveNoLinkedBlocks': 'Hayır linked blok — overall ilerleme does değil measure bu hedef.',
  'player.completion.congratulations': '🎉 Congratulations!',
  'player.completion.finished': '📋 Kurs tamamlandı',
  'player.completion.youCompleted': 'You have tamamlandı',
  'player.completion.passed': 'Passed ✓',
  'player.completion.failed': 'Değil doğrulandı ✗',
  'player.completion.requiredScore': 'Zorunlu puan: {{puan}}%',
  'player.completion.totalTime': 'Toplam time',
  'player.completion.blocksCompleted': 'Bloklar tamamlandı',
  'player.completion.quizPassed': 'Sınavlar passed',
  'player.completion.successRate': 'Başarılı rate',
  'player.completion.blockCompleted': 'Tamamlandı ✓',
  'player.completion.blockFailed': 'Başarısız ✗',
  'player.completion.blockSkipped': 'Atlandı',
  'player.completion.detail': '📊 Detail tarafından blok',
  'player.completion.type': 'Tür',
  'player.completion.timeSpent': 'Time spent',
  'player.completion.downloadCertificate': '📄 Indir sertifika',
  'player.completion.certificateSoon': 'The sertifika will be mevcut soon.',
  'player.completion.restart': '🔄 Restart',
  'player.completion.viewDetails': '📊 Görüntüle details',
  'player.completion.backToDashboard': '← Gösterge paneline dön',
  'player.completion.embedDismissHint': 'Bu modülü tamamladınız. Çıkmak için pencerenin üstündeki × işaretini veya aşağıdaki düğmeyi kullanın.',
  'player.completion.embedDismissButton': 'Pencereyi kapat',
  'player.previewBanner': 'Önizleme modu — bu görünüm eğitiminizin gerçek verilerini yansıtır',
  'player.closePreview': 'Önizlemeyi kapat',
  'player.flowPreviewMap': 'Flow map',
  'player.flowPreviewTitle': 'Flow önizleme',
  'player.flowPreviewHint': 'Oku-sadece genel bakış (aynı layout as in the designer). The orange frame shows the blok currently shown in the player.',
  'player.flowPreviewLegendCurrent': 'Mevcut blok',
  'player.flowPreviewClose': 'Kapat',
  'player.toggleSidebarShow': 'Göster kenar çubuğu',
  'player.toggleSidebarHide': 'Gizle kenar çubuğu',
  'player.mobileSummary': 'Outline',
  'player.mobileObjectives': 'Objectives',
  'player.mobileMoreOptions': 'Daha fazla seçenekler',
  'player.sidebarExpand': 'Kenar çubuğunu genişlet',
  'player.sidebarCollapse': 'Kenar çubuğunu daralt',
  'player.keyboardShortcuts': 'Keyboard shortcuts',
  'player.keyboardShortcutPrev': 'Önceki blok',
  'player.keyboardShortcutNext': 'Sonraki blok',
  'player.keyboardShortcutsHint': 'Çevir on “Keyboard navigation” in the accessibility panel (alt-sağ düğme). Devre dışı iken typing in fields.',
  'player.a11yCenter': 'Accessibility orta',
  'player.reviewSummary': 'Görüntüle summary',
  'player.viewResults': 'Görüntüle sonuçlar',
  'player.submitFirst': 'Gönder ilk',
  'player.phraseRevealCompleteFirst': 'Görüntüle tümü phrases ilk',
  'player.phraseReveal.emptyBlock': 'Hayır phrases are yapılandırıldı için bu blok.',
  'player.phraseReveal.revealNextAria': 'Tıkla veya bas Space to reveal the sonraki phrase',
  'player.phraseReveal.lastPhraseHint': 'Son phrase — kullan “Sonraki” to devam et the yol.',
  'player.phraseReveal.morePhrasesHint': 'Tıkla, Space, veya sağ arrow için the sonraki phrase',
  'player.phraseReveal.previousPhrases': 'Önceki phrases ({{count}})',
  'player.certificateUnavailable': 'The sertifika will be mevcut soon.',
  'player.browser.embeddedContentTitle': 'Embedded içerik',
  'player.browser.noValidUrl': 'Hayır geçerli URL',
  'player.browser.enterHttpsHint': 'Gir bir address başlıyor ile https:// (veya http://) in the blok ayarlar.',
  'player.browser.loadingContent': 'Yükleniyor içerik…',
  'player.browser.defaultPageTitle': 'Embedded web sayfa',
  'player.browser.continue': 'Devam Et',
  'player.browser.stepSaved': 'Adım kaydedildi',
  'player.browser.fullscreen': 'Tam ekran',
  'player.browser.exitFullscreen': 'Exit fullscreen',
  'player.podcast.defaultShowTitle': 'Podcast',
  'player.podcast.defaultEpisode': 'Bölüm',
  'player.podcast.loadError': 'Could değil load the podcast.',
  'player.podcast.loadingEpisodes': 'Yükleniyor episodes…',
  'player.podcast.playAll': 'Oynat tümü',
  'player.podcast.nextEpisode': 'Sonraki bölüm',
  'player.podcast.episodesHeading': 'Bölümler',
  'player.podcast.noEpisodes': 'Hayır episodes.',
  'player.podcast.noAudio': 'Hayır ses',
  'player.podcast.chainPlayback': 'Playlist · {{mevcut}}/{{toplam}}',
  'player.podcast.selectOrPlayAll': 'Seç bir bölüm from the liste veya tap “Oynat tümü”.',
  'player.podcast.audioUnavailable': 'Ses is değil mevcut için bu bölüm.',
  'player.podcast.showEpisodeText': 'Göster transcript',
  'player.podcast.hideEpisodeText': 'Gizle transcript',
  'player.podcast.episodeCount_one': '{{count}} bölüm',
  'player.podcast.episodeCount_other': '{{count}} episodes',
  'player.podcast.showChapters': 'Göster chapters',
  'player.podcast.hideChapters': 'Gizle chapters',
  'player.podcast.coverDialogLabel': 'Cover artwork: {{başlık}}',
  'player.podcast.coverEnlargePodcast': 'Enlarge podcast cover artwork',
  'player.podcast.coverEnlargeEpisode': 'Enlarge bölüm cover artwork',
  'player.podcast.coverEnlarge': 'Enlarge cover artwork',
  'player.audio.play': 'Oynat',
  'player.audio.pause': 'Duraklat',
  'player.audio.mute': 'Mute',
  'player.audio.unmute': 'Unmute',
  'player.audio.seek': 'Ses track position',
  'player.audio.playbackSpeed': 'Playback speed',
  'player.audio.completed': 'Ses track bitti',
  'player.audio.subtitlesAria': 'Text synced ile playback',
  'player.audio.subtitlesWaiting': 'Text segments will appear burada sırasında playback.',
  'player.audio.subtitlesNeedText': 'Ekle text (TTS veya blok içerik) to göster segments burada.',
  'player.audio.subtitlesHintSr': 'Approximate sync: text is spread üzerinde the ses süre, değil word-seviye timecodes.',
  'player.timeline.defaultTitle': 'Zaman Çizelgesi',
  'player.timeline.subtitle': 'Timeline to explore.',
  'player.timeline.eventFallback': 'Olay',
  'player.timeline.voiceoverLabel': 'Voice-üzerinde',
  'player.timeline.playVoiceover': 'Oynat voice-üzerinde',
  'player.timeline.pauseVoiceover': 'Duraklat voice-üzerinde',
  'player.timeline.generateVoiceover': 'Oluştur voice-üzerinde',
  'player.timeline.showDetail': 'Görüntüle details',
  'player.timeline.hideDetail': 'Gizle details',
  'player.timeline.emptyTitle': 'Hayır olaylar on bu timeline',
  'player.timeline.emptyHint': 'Ekle adımlar in the blok yapılandırma panel.',
  'player.timeline.voiceoverUnavailableTitle': 'Voice-üzerinde mevcut değil',
  'player.timeline.voiceoverUnavailableDesc': 'birç bu yol from bir connected eğitim to oluştur ses.',
  'player.timeline.voiceoverTextTooShortTitle': 'Text çok short',
  'player.timeline.voiceoverTextTooShortDesc': 'Ekle bir birçıklama (at least 20 characters) veya bir daha fazla detailed başlık için voice-üzerinde.',
  'player.timeline.voiceoverGenerationErrorTitle': 'Voice-üzerinde generation başarısız',
  'player.timeline.voiceoverSlowTitle': 'Voice-üzerinde',
  'player.timeline.voiceoverSlowDesc': 'Generation is alınıyor longer than expected. Dene tekrar in bir moment.',
  'player.timeline.retryLater': 'Lütfen dene tekrar sonra.',
  'player.timeline.openFullscreen': 'birç fullscreen',
  'player.timeline.openFullscreenAria': 'birç timeline in fullscreen',
  'player.timeline.closeFullscreenAria': 'Kapat fullscreen',
  'player.timeline.reviewed': 'Timeline reviewed',
  'player.video.seek': 'Video position',
  'player.video.subtitlesShow': 'Göster subtitles',
  'player.video.subtitlesHide': 'Gizle subtitles',
  'player.video.trackLabel': 'Altyazılar',
  'player.video.completed': 'Video tamamlandı',
  'player.video.markWatched': 'I have watched the video',
  'player.video.defaultIframeTitle': 'Embedded video',
  'player.podcast.playAllAria': 'Oynat tümü “{{başlık}}” — {{count}} bölüm(s) ile ses',
  'player.podcast.skipNextQueuedAria': 'Atla to sonraki bölüm in queue',
  'player.podcast.playEpisodeAria': 'Oynat bölüm: {{başlık}}',
  'player.podcast.episodeNoAudioAria': 'Bölüm ile hayır ses dosya: {{başlık}}',
  'player.renderError': 'Hata rendering blok: {{blockType}}',
  'player.blocks.defaultWelcome': 'Hoş geldiniz to bu eğitim',
  'player.blocks.defaultEndTitle': 'Congratulations!',
  'player.quiz.selectCorrectAnswer': 'Seç the doğru cevap:',
  'player.quiz.correctAnswer': '✓ Doğru cevap!',
  'player.quiz.incorrectAnswer': '✗ Yanlış cevap.',
  'player.blockTimer.aria': 'Time remaining için bu blok',
  'player.blockTimer.modeShortCountup': 'Elapsed',
  'player.blockTimer.modeShortCountdown': 'Countdown',
  'player.form.successMessage': 'Thank you için sizin yanıt!',
  'player.form.noFieldsConfigured': 'Bu form does değil have herhangi yapılandırıldı fields yet.',
  'player.selfAssessment.empty': 'Hayır criteria are defined için bu self-değerlendirme.',
  'player.selfAssessment.continue': 'Devam Et',
  'player.selfAssessment.pick': 'Choose bir puan',
  'player.selfAssessment.rateAria': 'Puan {{n}}: {{etiket}}',
  'player.selfAssessment.criterionFallback': 'criterion',
  'player.selfAssessment.commentLabel': 'Yorum (isteğe bağlı)',
  'player.selfAssessment.commentPlaceholder': 'Personal reflections, areas için growth…',
  'player.selfAssessment.submitted': 'Responses kaydedildi.',
  'player.selfAssessment.submit': 'Gönder self-değerlendirme',
  'player.selfAssessment.textAnswerPlaceholder': 'Sizin cevap…',
  'player.selfAssessment.pickBadges': 'Seç one veya daha fazla seçenekler:',
  'player.evaluation.commentsLabel': 'Yorumlar (isteğe bağlı)',
  'player.evaluation.commentsPlaceholder': 'Paylaş sizin geri bildirim...',
  'player.evaluation.submitted': 'Evaluation gönderildi',
  'player.evaluation.submit': 'Gönder evaluation',
  'player.time.lessThanMinute': 'Daha az than bir dakika',
  'player.time.oneMinute': '1 dakika',
  'player.time.minutes': '{{count}} dakika',
  'player.time.shortSeconds': '{{count}}s',
  'player.time.shortMinutes': '{{count}}min',
  'player.time.shortMinutesSeconds': '{{dakika}}min {{saniye}}s',
  'player.completion.scoreLabel': 'Puan',
  'accessibility.openCenter': 'birç accessibility orta',
  'accessibility.center': 'Erişilebilirlik',
  'accessibility.modalTitle': 'Adapted reading orta',
  'accessibility.modalDescription': 'Adjust the interface için düşük vision, dyslexia ve daha fazla comfortable reading.',
  'accessibility.closeCenter': 'Kapat accessibility orta',
  'accessibility.accessPad.connected': 'Lyrra Access Pad bağlandı',
  'accessibility.accessPad.playGuide': 'LyrraPad rehberini dinle',
  'accessibility.accessPad.pauseGuide': 'LyrraPad rehberini duraklat',
  'accessibility.presets': 'Preset profiles',
  'accessibility.preset.standard.label': 'Standart',
  'accessibility.preset.standard.desc': 'Varsayılan application rendering.',
  'accessibility.preset.lowVision.label': 'Düşük vision',
  'accessibility.preset.lowVision.desc': 'Stronger contrast, larger text ve clearer visual cues.',
  'accessibility.preset.dys.label': 'Dys',
  'accessibility.preset.dys.desc': 'Easier reading ile daha fazla spacing ve bir daha fazla legible yazı tipi.',
  'accessibility.typography': 'Typography ayarlar',
  'accessibility.fontScale': 'Text boyut',
  'accessibility.lineHeight': 'Line yükseklik',
  'accessibility.letterSpacing': 'Letter spacing',
  'accessibility.wordSpacing': 'Word spacing',
  'accessibility.visualAids': 'Visual aids',
  'accessibility.highContrast': 'Yüksek contrast',
  'accessibility.highContrastDesc': 'Strengthens reading contrast, borders ve visual cues.',
  'accessibility.underlineLinks': 'Underlined bağlantılar',
  'accessibility.underlineLinksDesc': 'Makes bağlantılar ve interactive areas easier to identify.',
  'accessibility.dyslexiaFont': 'Easier reading yazı tipi',
  'accessibility.dyslexiaFontDesc': 'Uses bir daha fazla comfortable yazı tipi için dyslexic kullanıcılar ve tired readers.',
  'accessibility.reducedMotion': 'Reduced motion',
  'accessibility.reducedMotionDesc': 'Reduces animations ve transitions to limit visual discomfort.',
  'accessibility.mouseMagnifier': 'Reading magnifier',
  'accessibility.mouseMagnifierDesc': 'Shows bir circular lens o follows the pointer ve enlarges kurs içerik altında it (magnified görüntüle için reading sadece).',
  'accessibility.alwaysOn': 'Her zaman-on iyileştirmeler',
  'accessibility.alwaysOnFocus': 'Daha fazla görünür keyboard focus',
  'accessibility.alwaysOnLinks': 'Bağlantılar ve interactive elements easier to detect',
  'accessibility.alwaysOnSaved': 'Ayarlar automatically kaydedildi on bu device',
  'accessibility.navigation': 'Navigation',
  'accessibility.keyboardNavigation': 'Keyboard navigation',
  'accessibility.keyboardNavigationDesc': 'Kullan Kalan / Up arrow için the önceki blok ve Sağ / Down arrow için the sonraki blok (aynı as the alt buttons).',
  'learner.header.workspace': 'Öğrenci alanı',
  'learner.tabs.home': 'Ana Sayfa',
  'learner.tabs.parcours': 'Benim Yollar',
  'learner.tabs.formations': 'Benim Kurslar',
  'learner.tabs.webinars': 'Web Seminerleri',
  'learner.tabs.podcasts': 'Podcastler',
  'learner.tabs.documents': 'Belgeler',
  'learner.tabs.progress': 'Benim Ilerleme',
  'learner.tabs.profile': 'Profil',
  'learner.sidebar.tagline': 'Öğrenci',
  'learner.sidebar.webinars': 'Web Seminerleri',
  'learner.webinars.title': 'Benim web seminerleri',
  'learner.webinars.loading': 'Yükleniyor sizin web seminerleri…',
  'learner.webinars.empty': 'Hayır web seminerleri yet. Ne zaman bir eğitmen invites you tarafından e-posta, they will appear burada.',
  'learner.webinars.join': 'Join room',
  'learner.webinars.invitedOn': 'Davet edildi on',
  'learner.webinars.scheduledFor': 'Zamanlanmış için',
  'learner.webinars.duration': 'Süre: {{süre}}',
  'learner.webinars.loadError': 'Could değil load web seminerleri.',
  'learner.webinars.status.draft': 'Taslak',
  'learner.webinars.status.scheduled': 'Zamanlanmış',
  'learner.webinars.status.live': 'Live',
  'learner.webinars.status.ended': 'Ended',
  'learner.sidebar.myProfile': 'Benim profil',
  'learner.sidebar.logout': 'Çıkış Yap',
  'learner.sidebar.collapse': 'Menüyü daralt',
  'learner.sidebar.expandAria': 'Kenar çubuğunu genişlet',
  'learner.sidebar.collapseAria': 'Kenar çubuğunu daralt',
  'learner.sidebar.backToTrainer': 'Eğitmen gösterge paneli',
  'learner.sidebar.backToTrainerAria': 'Git geri to the eğitmen gösterge paneli',
  'learner.home.resumeTraining': 'Devam et sizin kurslar',
  'learner.home.viewAll': 'Görüntüle tümü →',
  'learner.home.trainingDomains': 'Eğitim domains',
  'learner.home.courses': 'kurslar',
  'learner.home.episodes': 'episodes',
  'learner.home.recommendedPodcasts': 'Recommended podcastler',
  'learner.home.explore': 'Explore →',
  'learner.formations.title': 'Benim Kurslar',
  'learner.formations.searchPlaceholder': 'Ara bir kurs…',
  'learner.formations.all': 'Tümü',
  'learner.formations.formation': 'Kurs',
  'learner.formations.inProgress': 'Devam ediyor',
  'learner.formations.completed': 'Tamamlandı',
  'learner.formations.notStarted': 'Başlanmadı',
  'learner.formations.loading': 'Yükleniyor sizin kurslar...',
  'learner.formations.empty': 'Hayır kurs bulundu.',
  'learner.formations.progress': 'İlerleme',
  'learner.formations.instructor': 'Eğitmen',
  'learner.formations.opening': 'Opening...',
  'learner.formations.review': 'Değerlendirme',
  'learner.formations.start': 'Başla',
  'learner.formations.continue': 'Devam Et',
  'learner.podcasts.title': 'Explore Podcastler',
  'learner.podcasts.searchPlaceholder': 'Ara bir podcast…',
  'learner.podcasts.all': 'Tümü',
  'learner.podcasts.assigned': 'Atandı podcast',
  'learner.podcasts.defaultCategory': 'Podcast',
  'learner.podcasts.loading': 'Yükleniyor sizin podcastler...',
  'learner.podcasts.empty': 'Hayır atandı podcast.',
  'learner.podcasts.episodes': 'episodes',
  'learner.podcasts.opening': 'Opening...',
  'learner.podcasts.listen': 'Dinle',
  'learner.documents.title': 'Benim Belgeler',
  'learner.documents.loading': 'Yükleniyor sizin belgeler...',
  'learner.documents.view': 'Görüntüle belge',
  'learner.documents.empty': 'Hayır paylaşıldı belge.',
  'learner.progress.title': 'Benim Ilerleme',
  'learner.progress.completedFormations': 'Tamamlandı kurslar',
  'learner.progress.trainingHours': 'Eğitim saat',
  'learner.progress.listenedPodcasts': 'Podcastler listened',
  'learner.progress.earnedBadges': 'Badges earned',
  'learner.progress.weeklyActivity': 'Haftalık aktivite',
  'learner.progress.badges': 'Badges',
  'learner.progress.recentActivity': 'Son aktivite',
  'learner.progress.rarity.common': 'Common',
  'learner.progress.rarity.rare': 'Rare',
  'learner.progress.rarity.epic': 'Epic',
  'learner.progress.rarity.legendary': 'Legendary',
  'learner.progress.days.mon': 'Pzt',
  'learner.progress.days.tue': 'Sal',
  'learner.progress.days.wed': 'Çar',
  'learner.progress.days.thu': 'Per',
  'learner.progress.days.fri': 'Cum',
  'learner.progress.days.sat': 'Cmt',
  'learner.progress.days.sun': 'Paz',
  'learner.profile.title': 'Benim Profil',
  'learner.profile.defaultName': 'Öğrenci',
  'learner.profile.defaultEmail': 'öğrenci@example.com',
  'learner.profile.memberSince': 'Üye den beri January 2024',
  'learner.profile.editProfile': 'Düzenle profil',
  'learner.profile.formations': 'Kurslar',
  'learner.profile.hours': 'Saat',
  'learner.profile.podcasts': 'Podcastler',
  'learner.profile.badges': 'Badges',
  'learner.profile.preferences': 'Preferences',
  'learner.profile.theme': 'Tema',
  'learner.profile.themeLight': 'Açık',
  'learner.profile.themeDark': 'Koyu',
  'learner.profile.themeSystem': 'Sistem',
  'learner.profile.language': 'Dil',
  'learner.profile.notifications': 'Bildirimler',
  'learner.profile.fontSize': 'Text boyut',
  'learner.profile.fontNormal': 'Normal',
  'learner.profile.fontLarge': 'Büyük',
  'learner.profile.highContrast': 'Yüksek contrast',
  'learner.profile.a11ySection': 'Erişilebilirlik',
  'learner.profile.dangerZone': 'Danger zone',
  'learner.profile.logoutBtn': 'Çıkış Yap',
  'learner.parcours.title': 'Benim Yollar',
  'learner.parcours.assigned': 'atandı yol(s)',
  'learner.parcours.loading': 'Yükleniyor sizin yollar…',
  'learner.parcours.loadError': 'Unable to load sizin yollar.',
  'learner.parcours.noAssigned': 'Hayır atandı yol',
  'learner.parcours.noAssignedDesc': 'Sizin eğitmen will ata yollar burada.',
  'learner.parcours.completedBadge': 'Tamamlandı ✓',
  'learner.parcours.by': 'Tarafından',
  'learner.parcours.contents': 'içerik(s)',
  'learner.parcours.completedItems': 'tamamlandı',
  'learner.parcours.emptyPath': 'Hayır içerik in bu yol.',
  'learner.parcours.locked': 'Tamamla the önceki one ilk',
  'learner.parcours.review': 'Değerlendirme',
  'learner.parcours.listen': 'Dinle',
  'learner.parcours.open': 'Aç',
  'learner.modal.loading': 'Yükleniyor…',
  'learner.modal.noEpisodes': 'Hayır bölüm mevcut.',
  'learner.modal.markedDone': '✓ Marked as tamamlandı',
  'learner.modal.listenThenMark': 'Dinle sonra mark as tamamlandı',
  'learner.modal.alreadyDone': 'Zaten tamamlandı',
  'learner.modal.markDone': 'Mark as tamamlandı',
  'learner.modal.formationDone': '✓ Kurs tamamlandı',
  'learner.modal.completeThenMark': 'Tamamla the kurs sonra mark it as tamamlandı',
  'learner.modal.formationAlreadyDone': 'Zaten tamamlandı',
  'learner.modal.markFormationDone': 'Mark as tamamlandı',
  'learner.modal.formationInstruction': 'Takip et the modules of bu kurs in sipariş, sonra mark it as tamamlandı to ilerleme in sizin yol.',
  'learner.modal.launchFormation': 'Launch kurs',
  'learner.modal.openFormationHint': 'birç the kurs in bir yeni sekme, sonra mark it as tamamlandı from sizin yol.',
  'learner.home.loadingHome': 'Yükleniyor sizin ana sayfa…',
  'learner.home.noFormationsAssigned': 'Hayır kurs atandı yet. They will appear burada ne zaman bir eğitmen assigns one to you.',
  'learner.home.loadingPaths': 'Yükleniyor sizin yollar…',
  'learner.home.noPathsAssigned': 'Hayır yol atandı yet. They will appear burada ne zaman bir eğitmen assigns one to you.',
  'learner.home.byTheme': 'Sizin içerik tarafından tema',
  'learner.home.themesHint': 'Themes gel from the kategoriler of sizin atandı kurslar ve podcastler.',
  'learner.home.categoryOther': 'Diğer',
  'learner.home.contentsCount_one': '{{count}} öğe',
  'learner.home.contentsCount_other': '{{count}} öğeler',
  'learner.home.resumeSubtitleProgress': 'Ilerleme {{percent}}%',
  'learner.home.resumeSubtitleNotStarted': 'Değil başladı yet',
  'learner.home.podcastsAssigned': 'Atandı podcastler',
  'learner.home.viewAllPodcasts': 'See tümü →',
  'learner.home.gamificationHomeHint': 'Badges ve dolu aktivite are altında the « Benim ilerleme » sekme.',
  'learner.home.gamificationHomeCta': 'birç benim ilerleme',
  'learner.podcasts.mineTitle': 'Benim podcastler',
  'learner.podcasts.episodeCount_one': '{{count}} bölüm',
  'learner.podcasts.episodeCount_other': '{{count}} episodes',
  'learner.progress.loading': 'Yükleniyor sizin ilerleme…',
  'learner.progress.statPodcastsCompleted': 'Podcastler tamamlandı',
  'learner.progress.statTimeFormationsHours': 'Time on kurslar (h)',
  'learner.progress.statAssignedContents': 'Atandı içerik',
  'learner.progress.weeklyEstimated': 'Son 7 gün aktivite (estimated)',
  'learner.progress.badgesSoon': 'Badges ve rewards will be mevcut in sizin space soon.',
  'learner.progress.gamificationSection': 'Seviye ve experience',
  'learner.progress.gamificationLevelLine': 'Seviye {{seviye}} — {{ad}}',
  'learner.progress.gamificationXpToNext': '{{xp}} XP kadar the sonraki seviye',
  'learner.progress.rewardFormation': 'Kurs tamamlandı',
  'learner.progress.rewardPathItem': 'Öğrenme yol adım',
  'learner.progress.rewardPathComplete': 'Öğrenme yol tamamlandı',
  'learner.progress.rewardDesignerBlocks': 'Kurs puanlar (tamamlandı bloklar)',
  'learner.progress.rewardDesignerPerfect': 'Perfect sınav puan bonus',
  'learner.progress.rewardDesignerBadge': 'Kurs rozet',
  'learner.progress.rewardDesignerBadgeNoXp': 'Hayır XP puanlar (visual ödül)',
  'learner.progress.badgesEmpty': 'Tamamla bir kurs veya bir öğrenme yol to earn puanlar ve see sizin rewards burada.',
  'learner.progress.plusXp': '+{{xp}} XP',
  'learner.progress.noRecentHint': 'Hayır son aktivite yet. birç bir kurs veya bir podcast to feed bu liste.',
  'learner.progress.hoursShort': '{{saat}}h',
  'learner.profile.statFormationsRatio': 'Kurslar (tamamlandı / toplam)',
  'learner.profile.statTimeFormations': 'Kurs time (h)',
  'learner.profile.statPodcastsAssigned': 'Atandı podcastler',
  'learner.profile.statPathsAssigned': 'Atandı yollar',
  'learner.profile.memberSincePrefix': 'Üye den beri {{tarih}}',
  'learner.parcours.playPath': 'Takip et bu yol',
  'learner.parcours.playPathTitle': 'Opens the dolu-screen yol in bir yeni sekme',
  'learner.parcours.steps_zero': 'Hayır adımlar',
  'learner.parcours.steps_one': '1 adım',
  'learner.parcours.steps_other': '{{count}} adımlar',
  'learner.parcours.doneBadge': 'Tamamlandı',
  'learner.parcours.completedSingle': '{{tamamlandı}}/{{toplam}} tamamlandı',
  'learner.parcours.completedPlural': '{{tamamlandı}}/{{toplam}} tamamlandı',
  'learner.parcours.byAuthor': 'Tarafından {{firstName}} {{lastName}}',
  'learner.parcours.pathListAria': 'Sizin yollar liste',
  'learner.parcours.assignedCount_one': '{{count}} atandı yol',
  'learner.parcours.assignedCount_other': '{{count}} atandı yollar',
  'learner.pathPlayer.loading': 'Yükleniyor yol…',
  'learner.pathPlayer.errorGeneric': 'Hata',
  'learner.pathPlayer.pathNotFound': 'Yol değil bulundu',
  'learner.pathPlayer.loadError': 'Unable to load yol.',
  'learner.pathPlayer.backToPaths': 'Geri to benim yollar',
  'learner.pathPlayer.showTocAria': 'Göster outline',
  'learner.pathPlayer.prevActivityAria': 'Önceki aktivite',
  'learner.pathPlayer.prev': 'Önceki',
  'learner.pathPlayer.nextActivityAria': 'Sonraki aktivite',
  'learner.pathPlayer.next': 'İleri',
  'learner.pathPlayer.closePlayerTitle': 'Kapat ve return to yollar',
  'learner.pathPlayer.close': 'Kapat',
  'learner.pathPlayer.congrats': 'Congratulations',
  'learner.pathPlayer.pathCompleteTitle': 'Yol tamamlandı',
  'learner.pathPlayer.pathCompleteBody': 'You have tamamlandı tümü activities in the yol “{{başlık}}”.',
  'learner.pathPlayer.activitiesCompleted_one': '{{count}} aktivite tamamlandı',
  'learner.pathPlayer.activitiesCompleted_other': '{{count}} activities tamamlandı',
  'learner.pathPlayer.seeMyPaths': 'See benim yollar',
  'learner.pathPlayer.closeTocAria': 'Kapat outline',
  'learner.pathPlayer.tocNavAria': 'Yol outline',
  'learner.pathPlayer.pathTypeLabel': 'Eğitim yol',
  'learner.pathPlayer.noDescription': 'Hayır birçıklama.',
  'learner.pathPlayer.activityCount_zero': 'Hayır activities',
  'learner.pathPlayer.activityCount_one': '1 aktivite',
  'learner.pathPlayer.activityCount_other': '{{count}} activities',
  'learner.pathPlayer.progressPercent': 'Ilerleme {{percent}}%',
  'learner.pathPlayer.quit': 'Ayrıl',
  'learner.pathPlayer.summary': 'Outline',
  'learner.pathPlayer.outsideModule': 'Outside modül',
  'learner.pathPlayer.moduleContents': 'Modül içerikler',
  'learner.pathPlayer.step': 'Adım',
  'learner.pathPlayer.podcastHint': 'Dinle to the bölüm, sonra mark the aktivite as tamamla.',
  'learner.pathPlayer.showChapters': 'Göster chapters',
  'learner.pathPlayer.hideChapters': 'Gizle chapters',
  'learner.pathPlayer.showText': 'Göster transcript',
  'learner.pathPlayer.hideText': 'Gizle transcript',
  'learner.pathPlayer.selectEpisode': 'Seç bir bölüm to başlangıç.',
  'learner.pathPlayer.loadingShort': 'Yükleniyor…',
  'learner.pathPlayer.noEpisodes': 'Hayır episodes mevcut.',
  'learner.pathPlayer.listenThenMark': 'Dinle, sonra mark as tamamla',
  'learner.pathPlayer.updating': 'Güncelleniyor…',
  'learner.pathPlayer.alreadyDone': 'Zaten tamamlandı',
  'learner.pathPlayer.markComplete': 'Mark as tamamla',
  'learner.pathPlayer.nextStepBtn': 'Sonraki adım',
  'learner.pathPlayer.embeddedFormationHint': 'The kurs appears altında in the yol. Kullan the outline on the kalan için detailed adımlar.',
  'learner.pathPlayer.loadingFormation': 'Yükleniyor kurs…',
  'learner.pathPlayer.loadingReader': 'Yükleniyor player…',
  'learner.pathPlayer.emptyPathTitle': 'Bu yol does değil have herhangi activities yet.',
  'learner.pathPlayer.emptyPathDesc': 'Içerik will be eklendi tarafından sizin eğitim kuruluş. You can kapat bu window ve gel geri sonra.',
  'learner.pathPlayer.pickActivity': 'Choose bir aktivite in the outline to al başladı.',
  'learner.pathPlayer.footerStep': 'Adım {{mevcut}} / {{toplam}}',
  'learner.pathPlayer.unmute': 'Unmute',
  'learner.pathPlayer.mute': 'Mute',
  'learner.activity.flowCompleted': 'Kurs “{{başlık}}” tamamlandı',
  'learner.activity.flowProgress': 'Kurs “{{başlık}}” — {{ilerleme}}%',
  'learner.activity.podcast': 'Podcast “{{başlık}}”',
  'learner.webinars.durationMin': '{{m}} min',
  'learner.webinars.durationH': '{{h}} h',
  'learner.webinars.durationHM': '{{h}} h {{m}}',
  'learner.formations.durationHours': '{{saat}} h',
  'producerAssignments.createInDesigner': 'Oluştur / birç kurs',
  'producerAssignments.draft': 'Taslak',
  'producerAssignments.enterprise': 'Enterprise',
  'producerAssignments.enterprisePaths': 'Enterprise yollar',
  'producerAssignments.episodes': 'ep.',
  'producerAssignments.formations': 'Kurs cards',
  'producerAssignments.markCompleted': 'Mark as tamamlandı',
  'producerAssignments.markInProgress': 'In production',
  'producerAssignments.markReady': 'Ready',
  'producerAssignments.modulesCatalog': '{{count}} catalog modül(s) · güncellendi {{tarih}}',
  'producerAssignments.noneEnterprisePaths': 'Hayır enterprise yol istekler.',
  'producerAssignments.noneFormations': 'Hayır cards atandı.',
  'producerAssignments.nonePodcasts': 'Hayır podcastler atandı.',
  'producerAssignments.openInDesigner': 'birç in designer',
  'producerAssignments.openPodcasts': 'Podcast studio',
  'producerAssignments.planningDeadline': 'Son tarih {{tarih}}',
  'producerAssignments.planningFrom': 'Başlıyor {{tarih}}',
  'producerAssignments.planningRange': '{{başlangıç}} → {{son}}',
  'producerAssignments.podcasts': 'Podcastler to produce',
  'producerAssignments.productionStatus.completed': 'Tamamlandı',
  'producerAssignments.productionStatus.in_progress': 'Devam ediyor',
  'producerAssignments.productionStatus.not_started': 'Başlanmadı',
  'producerAssignments.productionStatus.published': 'Yayınlandı',
  'producerAssignments.publishedCatalog': 'Yayınlandı to catalog',
  'producerAssignments.rhPlanning': 'HR planning',
  'producerAssignments.subtitle': 'Kurslar to oluştur in the designer ve podcastler to produce, atandı tarafından HR.',
  'producerAssignments.title': 'Benim production assignments',
  'podcasts.actions.cancel': 'İptal',
  'podcasts.actions.close': 'Kapat',
  'podcasts.actions.create': 'Oluştur',
  'podcasts.actions.edit': 'Düzenle',
  'podcasts.actions.retry': 'Tekrar Dene',
  'podcasts.actions.save': 'Kaydet',
  'podcasts.actions.saving': 'Kaydediliyor…',
  'podcasts.actions.share': 'Paylaş',
  'podcasts.category.ariaGroup': 'Podcast kategori',
  'podcasts.category.emptyBanner': 'Ekle kategoriler in the Kurum space to better organize podcastler.',
  'podcasts.category.emptyInstitutionHint': 'Hayır kurum kategoriler yet — you can yayınla olmadan one.',
  'podcasts.category.noneChip': 'Hayır kategori',
  'podcasts.category.sectionTitle': 'Kategori',
  'podcasts.category.withCategoriesHint': 'Catalog placement ve kurum-side filtreler.',
  'podcasts.cover.ariaDropzone': 'Choose veya bırak bir cover görsel',
  'podcasts.cover.browseFiles': 'göz at dosyalar',
  'podcasts.cover.cancelNewFile': 'Iptal yeni dosya',
  'podcasts.cover.dragDrop': 'Sürükle ve bırak bir görsel',
  'podcasts.cover.dropHere': 'Bırak görsel burada',
  'podcasts.cover.errorMaxSize': 'Görsel gerekir değil exceed 5 MB.',
  'podcasts.cover.errorUnsupportedFormat': 'Unsupported görsel format.',
  'podcasts.cover.formatsHint': 'PNG, JPG, WebP, GIF · max 5 MB',
  'podcasts.cover.help': 'Square format recommended. Sürükle ve bırak bir dosya veya tıkla to göz at.',
  'podcasts.cover.or': 'veya',
  'podcasts.cover.replaceHint': 'Replace görsel',
  'podcasts.cover.sectionTitle': 'Cover görsel',
  'podcasts.deleteDialog.body': '"{{başlık}}" will be kaldırıldı from the liste (soft sil). Episodes are değil erased. Eğer sizin hesap is linked to bir kurum, bir yönetici can geri yükle the podcast from the Kurum space trash.',
  'podcasts.deleteDialog.confirm': 'Taşı to trash',
  'podcasts.deleteDialog.title': 'Taşı podcast to trash?',
  'podcasts.editPanel.createdOn': 'Oluşturuldu on ',
  'podcasts.editPanel.headerTitle': 'Düzenle podcast',
  'podcasts.editPanel.saving': 'Kaydediliyor…',
  'podcasts.editPanel.statsEpisodes': 'Episodes: ',
  'podcasts.editPanel.statsSubscribers': 'Subscribers: ',
  'podcasts.editPanel.successSaved': 'Değişiklikler kaydedildi',
  'podcasts.episodeStatus.draft': 'Taslak',
  'podcasts.episodeStatus.published': 'Yayınlandı',
  'podcasts.episodesPanel.addEpisode': 'Ekle bölüm',
  'podcasts.episodesPanel.emptySubtitle': 'Ekle episodes to bu podcast',
  'podcasts.episodesPanel.emptyTitle': 'Hayır episodes',
  'podcasts.episodesPanel.episodeCount': '{{count}} bölüm(s)',
  'podcasts.episodesPanel.noEpisodeAvailable': 'Hayır bölüm mevcut',
  'podcasts.episodesPanel.remove': 'Kaldır',
  'podcasts.episodesPanel.searchPlaceholder': 'Ara bir bölüm…',
  'podcasts.episodesPanel.title': 'Podcast episodes',
  'podcasts.error.retry': 'Tekrar Dene',
  'podcasts.filters.allCategories': 'Tümü kategoriler',
  'podcasts.filters.categoryLabel': 'Kategori',
  'podcasts.filters.searchLabel': 'Text ara',
  'podcasts.filters.searchPlaceholder': 'Başlık, birçıklama…',
  'podcasts.filters.viewCategories': 'Kategoriler görüntüle',
  'podcasts.filters.viewList': 'Liste görüntüle',
  'podcasts.form.descriptionLabel': 'Açıklama',
  'podcasts.form.descriptionPlaceholder': 'Describe sizin podcast…',
  'podcasts.form.namePlaceholder': 'Podcast ad',
  'podcasts.form.titleLabel': 'Başlık',
  'podcasts.language.ariaGroup': 'Podcast dil',
  'podcasts.language.help': 'Platformun 11 dili arasından — podcast\'i öğrenci oynatıcı ve arayüzüyle aynı yerel ayara hizalamak için.',
  'podcasts.language.label': 'Dil',
  'podcasts.lightbox.ariaClose': 'Kapat',
  'podcasts.lightbox.ariaDialog': 'Podcast cover önizleme',
  'podcasts.list.actionActivate': 'Activate',
  'podcasts.list.actionDeactivate': 'Deactivate',
  'podcasts.list.actionDelete': 'Sil',
  'podcasts.list.filterAll': 'Tümü',
  'podcasts.list.filterArchived': 'Arşivlendi',
  'podcasts.list.archivePodcast': 'Arşivle podcast',
  'podcasts.list.restoreFromArchive': 'Geri yükle from arşivle',
  'podcasts.list.archiveSuccess': 'Podcast arşivlendi',
  'podcasts.list.archiveError': 'Could değil arşivle the podcast.',
  'podcasts.list.restoreSuccess': 'Podcast geri yüklendi',
  'podcasts.list.restoreError': 'Could değil geri yükle the podcast.',
  'podcasts.list.badgeArchived': 'Arşivlendi',
  'podcasts.list.emptyArchivedNone': 'Hayır arşivlendi podcastler.',
  'podcasts.list.emptyAllArchived': 'Tümü podcastler are arşivlendi. birç the « Arşivlendi » sekme to see them.',
  'podcasts.list.actionManageEpisodes': 'Yönet episodes',
  'podcasts.list.actionPreview': 'Önizleme & dinle',
  'podcasts.list.coverPreviewAria': 'Podcast cover önizleme {{başlık}}',
  'podcasts.list.createFirst': 'Oluştur bir podcast',
  'podcasts.list.emptySubtitle': 'Oluştur sizin ilk podcast to al başladı',
  'podcasts.list.emptyTitle': 'Hayır podcastler',
  'podcasts.list.loadError': 'Unable to load podcastler.',
  'podcasts.list.enterpriseBadge': 'Şirket',
  'podcasts.list.enterpriseNeedTitle': 'Gerek defined tarafından sizin şirket',
  'podcasts.list.episodesShort': '{{count}} ep.',
  'podcasts.list.groupPodcastCount': '{{count}} podcast(s)',
  'podcasts.list.subscribersShort': '{{count}} sub.',
  'podcasts.list.uncategorized': 'Uncategorized',
  'podcasts.modal.errorRequiredFields': 'Başlık ve birçıklama are zorunlu.',
  'podcasts.modal.errorSaveFailed': 'Hata iken kaydediliyor.',
  'podcasts.modal.subtitleNew': 'Gir başlık, birçıklama ve seçenekler. You can ekle episodes afterwards.',
  'podcasts.modal.titleEdit': 'Düzenle podcast',
  'podcasts.modal.titleNew': 'Yeni podcast',
  'podcasts.page.episodesLink': 'Bölümler',
  'podcasts.page.newButton': 'Yeni',
  'podcasts.page.title': 'Podcastler',
  'podcasts.page.totalCount': '{{count}} podcast(s)',
  'podcasts.pagination.pageOf': 'Sayfa {{sayfa}} / {{toplam}}',
  'podcasts.pagination.totalSummary': '{{count}} podcast(s) in toplam',
  'podcasts.player.listen': 'Dinle',
  'podcasts.player.noAudio': 'Hayır ses',
  'podcasts.player.pause': 'Duraklat',
  'podcasts.preview.emptySubtitle': 'Bu podcast has hayır episodes yet',
  'podcasts.preview.emptyTitle': 'Hayır episodes',
  'podcasts.preview.episodeCount': '{{count}} bölüm(s)',
  'podcasts.preview.fallbackDescription': 'Dinle to mevcut ses episodes.',
  'podcasts.preview.playAll': 'Oynat tümü',
  'podcasts.preview.title': 'Podcast önizleme',
  'podcasts.public': 'Podcast',
  'podcasts.public.subscribeButton': 'Subscribe için updates',
  'podcasts.public.subscribeModalTitle': 'Al yeni episodes tarafından e-posta',
  'podcasts.public.subscribeModalIntro': 'Gir sizin details. We will e-posta you ne zaman bir yeni bölüm is yayınlandı.',
  'podcasts.public.fieldFirstName': 'Ilk ad',
  'podcasts.public.fieldLastName': 'Son ad',
  'podcasts.public.fieldEmail': 'E-posta',
  'podcasts.public.fieldCompany': 'Şirket (isteğe bağlı)',
  'podcasts.public.submitSubscribe': 'Onayla subscription',
  'podcasts.public.cancel': 'İptal',
  'podcasts.public.done': 'Tamamlandı',
  'podcasts.public.subscribeSuccess': 'Thank you! You will be notified için her yeni bölüm.',
  'podcasts.public.subscribeError': 'Could değil tamamla subscription. Lütfen dene tekrar sonra.',
  'podcasts.public.subscribeValidationRequired': 'Ilk ad, son ad ve e-posta are zorunlu.',
  'podcasts.share.assignedLearnersHeading': '{{count}} öğrenci(s) atandı',
  'podcasts.share.copied': 'Kopyalandı',
  'podcasts.share.copyLink': 'Kopyala bağlantı',
  'podcasts.share.emailPlaceholder': 'E-posta *',
  'podcasts.share.errorCreateLearner': 'Unable to oluştur öğrenci.',
  'podcasts.share.errorPublicLink': 'Unable to oluştur genel bağlantı.',
  'podcasts.share.errorRemoveLearner': 'Unable to kaldır öğrenci.',
  'podcasts.share.errorShare': 'Unable to paylaş bu podcast.',
  'podcasts.share.firstNamePlaceholder': 'Ilk ad *',
  'podcasts.share.generatingLink': 'Oluşturuluyor bağlantı…',
  'podcasts.share.hideQuickCreate': 'Gizle quick oluştur',
  'podcasts.share.lastNamePlaceholder': 'Son ad *',
  'podcasts.share.loadingAssigned': 'Yükleniyor…',
  'podcasts.share.loadingLearners': 'Yükleniyor öğrenciler...',
  'podcasts.share.messageAccessRemoved': 'Erişim kaldırıldı için the öğrenci.',
  'podcasts.share.messageCreatedAndShared': 'Hesap oluşturuldu/linked, podcast paylaşıldı ve davet e-posta gönderildi.',
  'podcasts.share.messageShared': 'Podcast paylaşıldı ve davet gönderildi to the öğrenci.',
  'podcasts.share.noAssignedLearners': 'Hayır öğrenci atandı to bu podcast.',
  'podcasts.share.noLearnerAvailable': 'Hayır öğrenci mevcut.',
  'podcasts.share.panelTitle': 'Paylaş podcast',
  'podcasts.share.publicLinkSection': 'Genel bağlantı (hayır login)',
  'podcasts.share.removeAccessTitle': 'Kaldır erişim',
  'podcasts.share.searchLearnerPlaceholder': 'Ara bir öğrenci (son ad, ilk ad, e-posta)',
  'podcasts.share.selectExistingLearnerLabel': 'Seç bir existing öğrenci',
  'podcasts.share.showQuickCreate': 'Oluştur yeni öğrenci',
  'podcasts.share.submitCreateAndInvite': 'Oluştur, paylaş ve gönder davet',
  'podcasts.share.socialNetworksHeading': 'Paylaş on social',
  'podcasts.share.shareLinkedIn': 'Paylaş on LinkedIn',
  'podcasts.share.shareFacebook': 'Paylaş on Facebook',
  'podcasts.share.shareTwitter': 'Paylaş on X (Twitter)',
  'podcasts.share.publicShareStatsHeading': 'Genel sayfa stats',
  'podcasts.share.publicShareStatsVisits': 'Visits (genel sayfa)',
  'podcasts.share.publicShareStatsLoading': 'Yükleniyor stats…',
  'podcasts.share.publicShareStatsUnavailable': 'Stats mevcut değil sağ şimdi.',
  'podcasts.share.publicShareStatsLinkedIn': 'LinkedIn',
  'podcasts.share.publicShareStatsFacebook': 'Facebook',
  'podcasts.share.publicShareStatsTwitter': 'X (Twitter)',
  'podcasts.share.publicSubscribersHeading': 'Subscribers (e-posta bildirimler)',
  'podcasts.share.publicSubscribersEmpty': 'Hayır subscribers yet.',
  'podcasts.share.publicSubscribersCompany': 'Şirket',
  'share.publicQrTitle': 'Genel bağlantı QR code',
  'share.publicQrError': 'Could değil oluştur the QR code.',
  'share.downloadQrPng': 'Indir as PNG',
  'podcasts.status.active': 'Aktif',
  'podcasts.status.inactive': 'Pasif',
  'learningPaths.card.contents': '{{count}} içerik öğeler',
  'learningPaths.card.delete': 'Sil',
  'learningPaths.card.edit': 'Düzenle',
  'learningPaths.card.learners': '{{count}} öğrenciler',
  'learningPaths.card.publish': 'Yayınla',
  'learningPaths.card.unpublish': 'Yayından Kaldır',
  'learningPaths.card.updatedAt': 'Güncellendi {{tarih}}',
  'learningPaths.createPanel.cancel': 'İptal',
  'learningPaths.createPanel.description': 'Ad sizin yol; you can ekle podcastler ve kurslar to it.',
  'learningPaths.createPanel.descriptionLabel': 'Açıklama',
  'learningPaths.createPanel.descriptionPlaceholder': 'Yol amaç, hedef audience…',
  'learningPaths.createPanel.nameLabel': 'Yol ad',
  'learningPaths.createPanel.namePlaceholder': 'e.g. HR onboarding yol…',
  'learningPaths.createPanel.submit': 'Oluştur yol',
  'learningPaths.createPanel.title': 'Yeni yol',
  'learningPaths.deleteDialog.body': 'You are hakkında to sil "{{başlık}}". Bu eylem cannot be undone.',
  'learningPaths.deleteDialog.cancel': 'İptal',
  'learningPaths.deleteDialog.confirm': 'Sil',
  'learningPaths.deleteDialog.title': 'Sil yol',
  'learningPaths.empty.createFirst': 'Oluştur bir yol',
  'learningPaths.empty.noPathsHint': 'Oluştur sizin ilk yol tarafından combining podcastler ve kurslar.',
  'learningPaths.empty.noPathsYet': 'Hayır yollar yet',
  'learningPaths.empty.noResults': 'Sonuç yok',
  'learningPaths.empty.noResultsHint': 'Adjust sizin filtreler veya oluştur bir yeni yol.',
  'learningPaths.error.loadFailed': 'Could değil load yollar',
  'learningPaths.error.retry': 'Tekrar Dene',
  'learningPaths.filters.allStatuses': 'Tümü statuses',
  'learningPaths.filters.draft': 'Taslak',
  'learningPaths.filters.published': 'Yayınlandı',
  'learningPaths.filters.searchPlaceholder': 'Ara için bir yol…',
  'learningPaths.page.newButton': 'Yeni yol',
  'learningPaths.page.subtitle': 'Oluştur ordered eğitim yollar',
  'learningPaths.page.title': 'Yollar',
  'learningPaths.page.totalCount': '{{count}} yollar',
  'learningPaths.pagination.next': 'İleri',
  'learningPaths.pagination.pageOf': 'Sayfa {{sayfa}} / {{toplam}} · {{count}} yollar',
  'learningPaths.pagination.previous': 'Önceki',
  'learningPaths.status.draft': 'Taslak',
  'learningPaths.status.published': 'Yayınlandı',
  'learningPaths.editor.backToList': 'Geri to yollar',
  'learningPaths.editor.pathNameLabel': 'Yol ad *',
  'learningPaths.editor.idCopyHint': 'Yol ID (için destek)',
  'learningPaths.editor.sectionNavAria': 'Yol editor sections',
  'learningPaths.editor.tabContents': 'Içerikler',
  'learningPaths.editor.tabLearners': 'Öğrenciler',
  'webinars.card.code': 'Code {{code}}',
  'webinars.card.copyLink': 'Kopyala bağlantı',
  'webinars.card.exportAttendance': 'Indir attendance (CSV)',
  'webinars.card.attendanceExportError': 'Could değil indir the attendance dosya.',
  'webinars.card.delete': 'Sil',
  'webinars.card.edit': 'Düzenle',
  'webinars.card.openRoom': 'birç room',
  'webinars.card.publicSignupBadge': 'Genel signup',
  'webinars.deleteDialog.body': 'Sil "{{başlık}}"? Bu eylem cannot be undone.',
  'webinars.deleteDialog.cancel': 'İptal',
  'webinars.deleteDialog.confirm': 'Sil',
  'webinars.deleteDialog.title': 'Sil web semineri',
  'webinars.eligibility.default': 'Web seminerleri are değil mevcut için sizin hesap (kontrol et the API connection veya contact sizin yönetici).',
  'webinars.eligibility.moduleDisabled': 'The web seminerleri modül is değil yet etkin için sizin kurum. Bir yönetici gerekir etkinleştir \\\'Etkinleştir web seminerleri\\\' in Kurum → Web seminerleri.',
  'webinars.eligibility.noInstitution': 'Hayır kurum is linked to sizin hesap.',
  'webinars.eligibility.notAuthorized': 'Sizin hesap is değil on the liste of authorized hosts. Sor sizin kurum to ekle you (Web semineri yönetim → Authorized hosts).',
  'webinars.eligibility.roleNotAllowed': 'Sizin rol does değil allow you to host web seminerleri ile bu hesap.',
  'webinars.empty.createFirst': 'Oluştur bir web semineri',
  'webinars.empty.noResults': 'Sonuç yok',
  'webinars.empty.noResultsHint': 'Değiştir sizin ara.',
  'webinars.empty.noWebinarsHint': 'Oluştur bir room ve davet et sizin katılımcılar from the side panel.',
  'webinars.empty.noWebinarsYet': 'Hayır web seminerleri yet',
  'webinars.externalInvite.closeButton': 'Kapat',
  'webinars.externalInvite.description': 'People kim are değil on the öğrenci liste: her address receives bir e-posta ile the room bağlantı ve bir takvim attachment.',
  'webinars.externalInvite.done': 'Tamamlandı.',
  'webinars.externalInvite.duplicatesCount_one': '{{count}} zaten davet edildi',
  'webinars.externalInvite.duplicatesCount_other': '{{count}} zaten davet edildi',
  'webinars.externalInvite.emailsHint': 'One address per line, veya separated tarafından commas. Duplicates ve invitations zaten gönderildi are ignored.',
  'webinars.externalInvite.emailsLabel': 'E-posta addresses',
  'webinars.externalInvite.emailsPlaceholder': 'john.doe@example.com\\njane@example.org',
  'webinars.externalInvite.errorMax200': 'Maximum 200 addresses per gönder.',
  'webinars.externalInvite.errorMinOne': 'Gir at least one geçerli e-posta address.',
  'webinars.externalInvite.errorsLabel': 'hatalar: {{hatalar}}',
  'webinars.externalInvite.sendButton': 'Gönder invitations',
  'webinars.externalInvite.sendFailed': 'Gönder başarısız',
  'webinars.externalInvite.sentCount_one': '{{count}} e-posta gönderildi',
  'webinars.externalInvite.sentCount_other': '{{count}} emails gönderildi',
  'webinars.externalInvite.skippedCount_one': '{{count}} atlandı',
  'webinars.externalInvite.skippedCount_other': '{{count}} atlandı',
  'webinars.externalInvite.title': 'E-posta invitations',
  'webinars.invite.duplicatesCount_one': '{{count}} zaten davet edildi',
  'webinars.invite.duplicatesCount_other': '{{count}} zaten davet edildi',
  'webinars.invite.errorsLabel': 'hatalar: {{hatalar}}',
  'webinars.invite.externalButton': 'Off-liste (e-posta)',
  'webinars.invite.failed': 'Başarısız',
  'webinars.invite.groupSuccess': 'Grup invitations işlendi (emails gönderildi to üyeler).',
  'webinars.invite.inviteButton': 'Davet Et',
  'webinars.invite.learnersHelp': 'Ara için bir öğrenci at sizin kurum: bir <strong>davet e-posta</strong> (bağlantı + takvim) is gönderildi ile her davet.',
  'webinars.invite.learnersTitle': 'Öğrenciler',
  'webinars.invite.noCandidates': 'Hayır öğrenciler to göster (dene another ara veya kullan \\\'Off-liste\\\' için external emails).',
  'webinars.invite.noInvitations': 'Hayır invitations recorded.',
  'webinars.invite.searchLabel': 'Ara için bir öğrenci',
  'webinars.invite.searchPlaceholder': 'Ad veya e-posta…',
  'webinars.invite.searching': 'Aranıyor…',
  'webinars.invite.sentCount_one': '{{count}} davet gönderildi (e-posta)',
  'webinars.invite.sentCount_other': '{{count}} invitations gönderildi (e-posta)',
  'webinars.invite.sentInvitationsToggle': 'Invitations gönderildi',
  'webinars.page.newButton': 'Yeni web semineri',
  'webinars.page.searchPlaceholder': 'Ara…',
  'webinars.page.subtitle': 'Liste of sizin rooms — birç the panel to oluştur, düzenle veya davet et katılımcılar.',
  'webinars.page.title': 'Web Seminerleri',
  'webinars.panel.backgroundHint': 'Görsel behind paylaşıldı içerik için katılımcılar: gir bir URL (https veya http), yükle bir dosya (kaydedildi to Benim görseller), veya seç bir existing one from sizin library. Ayrıl boş için the built-in Lyrra visual.',
  'webinars.panel.backgroundLabel': 'Arka plan görsel (katılımcı görüntüle)',
  'webinars.panel.backgroundPlaceholder': 'https://… veya Benim görseller yol',
  'webinars.panel.backgroundUrlLabel': 'Görsel address (URL)',
  'webinars.panel.backgroundUploadTitle': 'Yükle bir görsel (Benim görseller)',
  'webinars.panel.backgroundLibraryTitle': 'Benim görseller',
  'webinars.panel.backgroundLibraryEmpty': 'Hayır görseller yet — yükle üstünde veya from the Görseller sayfa in sizin gösterge paneli.',
  'webinars.panel.backgroundOpenImagesPage': 'birç Görseller sayfa',
  'webinars.panel.backgroundUseDefault': 'Kullan varsayılan Lyrra arka plan',
  'webinars.panel.backgroundUploading': 'Yükleniyor…',
  'webinars.panel.backgroundUploadError': 'Görsel yükle başarısız.',
  'webinars.panel.copyLink': 'Kopyala bağlantı',
  'webinars.panel.createButton': 'Oluştur',
  'webinars.panel.createDescription': 'Fill in the bilgi sonra kaydet. You can davet et katılımcılar afterwards.',
  'webinars.panel.createTitle': 'Yeni web semineri',
  'webinars.panel.dateLabel': 'Gün (isteğe bağlı)',
  'webinars.panel.deleteButton': 'Sil',
  'webinars.panel.descriptionLabel': 'Açıklama',
  'webinars.panel.durationError': 'Gir bir süre in saat:dakika format (e.g. 1:00 veya 0:45).',
  'webinars.panel.durationHint': 'Zorunlu eğer bir gün is ayarla. E.g. 1:30 için 1 h 30, 0:45 için 45 min.',
  'webinars.panel.durationLabel': 'Süre (h:mm)',
  'webinars.panel.editTitle': 'Web semineri',
  'webinars.panel.loading': 'Yükleniyor…',
  'webinars.panel.openRoom': 'birç room',
  'webinars.panel.presentersLabel': 'Co-presenters',
  'webinars.panel.roomCode': 'Room code:',
  'webinars.panel.timeHint': 'Eğer boş: 9:00.',
  'webinars.panel.timeLabel': 'Başlangıç time',
  'webinars.panel.titleLabel': 'Başlık',
  'webinars.panel.waitingHtmlLabel': 'Bekleniyor room HTML (isteğe bağlı)',
  'webinars.panel.waitingHtmlPlaceholder': '<p>Hoş geldiniz…</p>',
  'webinars.panel.publicAccessTitle': 'Genel signup (form)',
  'webinars.panel.publicAccessHelp': 'Katılımcılar kim are değil co-presenters fill in bir form sonra signing in to Lyrra: e-posta, şifre (they choose it) ve herhangi extra fields you ekle altında.',
  'webinars.panel.publicFormFixedFieldsHint': 'E-posta ve şifre (min. 8 characters) are her zaman zorunlu için katılımcılar; ekle isteğe bağlı veya zorunlu extra fields burada.',
  'webinars.panel.publicFormAddFieldButton': 'Ekle field',
  'webinars.panel.publicFormFieldNumber': 'Field {{n}}',
  'webinars.panel.publicFormFieldLabel': 'Etiket shown',
  'webinars.panel.publicFormFieldType': 'Tür',
  'webinars.panel.publicFormFieldTypeText': 'Short text',
  'webinars.panel.publicFormFieldTypeTextarea': 'Long text',
  'webinars.panel.publicFormFieldRequired': 'Zorunlu',
  'webinars.panel.publicFormFieldRemove': 'Kaldır',
  'webinars.panel.publicFormFieldIdHint': 'Technical id:',
  'webinars.panel.publicFormFieldLabelRequired': 'Her field gerekir have bir etiket.',
  'webinars.panel.publicAccessLoginLabel': 'Signup form login',
  'webinars.panel.publicAccessPasswordLabel': 'Signup form şifre',
  'webinars.panel.publicAccessPasswordPlaceholderNew': 'At least 8 characters',
  'webinars.panel.publicAccessPasswordPlaceholderKeep': 'Ayrıl blank to tut the mevcut şifre',
  'webinars.panel.publicAccessPasswordHint': 'On oluştur veya ilk activation: şifre zorunlu (min. 8). Sonra: ayrıl blank to tut the mevcut şifre.',
  'webinars.panel.publicAccessLoginRequired': 'Gir bir login için genel signup.',
  'webinars.panel.publicAccessPasswordRequired': 'Ayarla bir şifre of at least 8 characters.',
  'webinars.panel.publicAccessPasswordMin': 'The genel şifre gerekir be at least 8 characters.',
  'webinars.status.draft': 'Taslak',
  'webinars.status.ended': 'Ended',
  'webinars.status.live': 'Live',
  'webinars.status.scheduled': 'Zamanlanmış',
  'videos.addPanel.cancel': 'İptal',
  'videos.addPanel.continue': 'Devam Et',
  'videos.addPanel.description': 'Içe aktar MP4, WebM, veya MOV to kullan them in sizin eğitim.',
  'videos.addPanel.dropzoneFormats': 'MP4, WebM, MOV',
  'videos.addPanel.dropzoneLabel': 'Tıkla to choose bir video',
  'videos.addPanel.title': 'Ekle bir video',
  'videos.addPanel.titleLabel': 'Başlık',
  'videos.addPanel.titlePlaceholder': 'Video başlık…',
  'videos.card.delete': 'Sil',
  'videos.card.edit': 'Düzenle',
  'videos.card.noThumbnail': 'Hayır thumbnail',
  'videos.card.publishedStudio': 'Yayınlandı (editable in Studio)',
  'videos.card.draft': 'Taslak',
  'videos.deleteDialog.body': '« {{başlık}} » will be permanently silindi.',
  'videos.deleteDialog.cancel': 'İptal',
  'videos.deleteDialog.confirm': 'Sil',
  'videos.deleteDialog.title': 'Sil video?',
  'videos.empty.addButton': 'Ekle bir video',
  'videos.empty.description': 'Içe aktar sizin ilk video to yönet it ve kullan it in sizin eğitim.',
  'videos.empty.title': 'Hayır videolar',
  'videos.page.addButton': 'Ekle bir video',
  'videos.page.count_one': '{{count}} video in sizin library',
  'videos.page.count_other': '{{count}} videolar in sizin library',
  'videos.page.title': 'Videolar',
  'videos.page.studioButton': 'Studio',
  'videos.studio.title': 'Video studio',
  'videos.studio.rail.prep': 'Prep',
  'videos.studio.rail.capture': 'Capture',
  'videos.studio.rail.post': 'Düzenle',
  'videos.studio.rail.aria': 'Video studio adımlar',
  'videos.studio.badge.setup': 'Setup',
  'videos.studio.badge.capture': 'Capture',
  'videos.studio.badge.recording': 'Kayıt',
  'videos.studio.badge.post': 'Düzenle',
  'videos.studio.cannotLeaveRecord': 'Durdur kayıt önce switching adım.',
  'videos.studio.railNeedRecording': 'Kaydet bir video to birç the düzenle adım.',
  'videos.studio.sidebar.captureHelp': 'Kayıt captures the entire paylaşıldı feed (screen, sekme, veya window). Cropping to the useful area will be tamamlandı in the Düzenle adım.',
  'videos.studio.sidebar.sources': 'Sources',
  'videos.studio.sidebar.recordingLive': 'Kayıt in ilerleme',
  'videos.studio.sidebar.finalizeHint': 'Kaydet to sizin library kullanarak the düğme in the üst bar.',
  'videos.studio.canvas.setupEmpty': 'Oku the side panel, sonra git to the Capture adım.',
  'videos.studio.stepSetup': 'Setup',
  'videos.studio.stepCapture': 'Capture',
  'videos.studio.stepPost': 'Düzenle',
  'videos.studio.titleLabel': 'Video başlık',
  'videos.studio.titlePlaceholder': 'Benim kayıt…',
  'videos.studio.saveSetup': 'Devam et to capture',
  'videos.studio.fieldDescription': 'Açıklama',
  'videos.studio.fieldCategories': 'Kategoriler',
  'videos.studio.categoriesHint': 'One veya daha fazla kategoriler from sizin kurum (isteğe bağlı).',
  'videos.studio.categoriesEmptyInstitution': 'Hayır kategoriler are ayarla up için sizin kurum.',
  'videos.studio.audioTrackPlanned': 'Planned ses track',
  'videos.studio.voiceHumanPlan': 'Human voice (recorded microphone)',
  'videos.studio.voiceAiPlan': 'AI voice (choose için the düzenle adım)',
  'videos.studio.postVoiceHumanKeep': 'You chose human voice: the video keeps the microphone ses. Finalize ne zaman you are ready.',
  'videos.studio.titleUntitled': 'Untitled',
  'videos.studio.voiceAiNoVoices': 'Hayır AI voices are mevcut sağ şimdi.',
  'videos.studio.postVoiceAiPipeline': 'AI voice: polish the text, oluştur the ses track, sonra uygula it to the video.',
  'videos.studio.allowMedia': 'Allow screen ve microphone',
  'videos.studio.controlsHint': 'Tip: to avoid kayıt bu bar, paylaş bir sekme veya bir window bunun yerine of the dolu screen, veya kullan bir saniye display. Space = duraklat / devam et ne zaman bu sayfa is focused.',
  'videos.studio.warnTabOnly': 'You seçildi bir single sekme: sadece o sekme will be recorded, even eğer you birç diğer tabs. To capture multiple tabs veya windows, restart capture ve choose "Entire Screen".',
  'videos.studio.templateMenuTitle': 'Şablonlar menü',
  'videos.studio.templateEmpty': 'Hayır kaydedildi şablon',
  'videos.studio.templatesHintCompact': 'Tıkla + to kaydet, uygula, veya sil bir şablon.',
  'videos.studio.overlayAddMusic': 'Arka plan music',
  'videos.studio.musicInvalidType': 'Geçersiz format. Kullan bir ses dosya (MP3, WAV, M4A, OGG).',
  'videos.studio.musicTooLarge': 'Ses dosya gerekir değil exceed 50 MB.',
  'videos.studio.musicDefault': 'Music',
  'videos.studio.musicAdded': 'Arka plan music eklendi to timeline.',
  'videos.studio.musicUploadError': 'Unable to ekle arka plan music.',
  'videos.studio.layerScreenBorder': 'Outer kenarlık',
  'videos.studio.layerScreenBorderSize': 'Boyut',
  'videos.studio.layerScreenBorderColor': 'Renk',
  'videos.studio.layerScreenBorderRadius': 'Corner radius',
  'videos.studio.segmentToolsTitle': 'Segment tools',
  'videos.studio.segmentZoom': 'Yakınlaştırma',
  'videos.studio.segmentResetView': 'Sıfırla görüntüle',
  'videos.studio.segmentTransition': 'Geçiş',
  'videos.studio.transitionNone': 'Hiçbiri',
  'videos.studio.transitionFade': 'Fade',
  'videos.studio.transitionWipeLeft': 'Wipe →',
  'videos.studio.transitionSlideUp': 'Slide ↑',
  'videos.studio.textEditor.toolbar': 'Text formatting',
  'videos.studio.textEditor.bold': 'Kalın',
  'videos.studio.textEditor.italic': 'İtalik',
  'videos.studio.textEditor.underline': 'Altı çizili',
  'videos.studio.textEditor.textColor': 'Text renk (seçim)',
  'videos.studio.textEditor.size': 'Boyut',
  'videos.studio.textEditor.font': 'Yazı tipi',
  'videos.studio.textEditor.fontFamily.system': 'Sistem',
  'videos.studio.textEditor.fontFamily.sansInter': 'Sans (Inter)',
  'videos.studio.textEditor.fontFamily.serif': 'Serif',
  'videos.studio.textEditor.fontFamily.mono': 'Mono',
  'videos.studio.textEditor.fontFamily.script': 'Script',
  'videos.studio.controlsHintTab': 'You are paylaşılıyor another sekme: the kayıt does değil include bu Studio sayfa (so these buttons are değil in the video). Tut Studio birç in another browser window veya on bir saniye screen sonraki to sizin içerik. Için Duraklat, Durdur, veya Tamamlandı, switch to the window nerede Studio is birç (Alt+Sekme veya Cmd+Sekme). Space sadece works ne zaman the Studio sayfa is focused.',
  'videos.studio.controlsHintMonitor': 'You are paylaşılıyor the dolu screen: bu bar may appear in the kayıt. Prefer paylaşılıyor bir Sekme veya Window, veya taşı the controls to another monitor.',
  'videos.studio.controlsHintWindow': 'You are paylaşılıyor one window: the rest of the desktop (ve diğer windows) is usually değil recorded. Kullan the buttons altında için Duraklat, Durdur, veya Tamamlandı.',
  'videos.studio.startRecord': 'Kaydet',
  'videos.studio.pause': 'Duraklat',
  'videos.studio.resume': 'Devam et',
  'videos.studio.stop': 'Durdur',
  'videos.studio.terminer': 'Tamamlandı',
  'videos.studio.processingUpload': 'Yükleniyor ve transcribing…',
  'videos.studio.timeline': 'Playback',
  'videos.studio.transcript': 'Recognized text',
  'videos.studio.transcriptRefining': 'Refining transcription…',
  'videos.studio.transcriptPlaceholder': 'Recognized text from sizin kayıt will appear burada…',
  'videos.studio.voiceMode': 'Ses track',
  'videos.studio.voiceOriginal': 'Benim voice (recorded mic)',
  'videos.studio.voiceAi': 'AI voice (Mistral TTS)',
  'videos.studio.voiceSelect': 'Voice',
  'videos.studio.polish': 'Prepare text için AI voice',
  'videos.studio.generateTts': 'Oluştur voiceover',
  'videos.studio.applyVoiceover': 'Uygula AI voice to video',
  'videos.studio.preview': 'Önizleme',
  'videos.studio.preview.noFile': 'Hayır video dosya to önizleme.',
  'videos.studio.bgImage': 'Arka plan görsel',
  'videos.studio.bgImageChoose': 'Choose',
  'videos.studio.bgImageInvalidType': 'Geçersiz format. Kullan bir görsel (PNG, JPG, WebP).',
  'videos.studio.bgImageTooLarge': 'Görsel gerekir değil exceed 10 MB.',
  'videos.studio.bgImageLoadError': 'Could değil load the arka plan görsel.',
  'videos.studio.bgImageUploading': 'Yükleniyor…',
  'videos.studio.bgImageUploadError': 'Could değil yükle the görsel. Dene tekrar.',
  'videos.studio.bgImageLibraryTitle': 'Video studio arka plan',
  'videos.studio.postLayoutTitle': 'Frame & arka plan',
  'videos.studio.postLayoutHint': 'Önizleme matches the yayınlandı video: kaydet the taslak sonra yayınla to uygula arka plan, boyut, ve position.',
  'videos.studio.bgImageVideoSize': 'Video boyut',
  'videos.studio.dragToMove': 'Sürükle to taşı',
  'videos.studio.finalize': 'Kaydet to library',
  'videos.studio.saveDraft': 'Taslak',
  'videos.studio.publish': 'Yayınla',
  'videos.studio.successDraft': 'Video kaydedildi as taslak',
  'videos.studio.successPublish': 'Video yayınlandı to sizin library',
  'videos.studio.processingPublish': 'Işleniyor video…',
  'videos.studio.back': 'Geri to videolar',
  'videos.studio.errorMedia': 'Could değil erişim screen veya microphone.',
  'videos.studio.errorInsecureContext': 'Screen capture requires HTTPS veya localhost. birç the app via https:// veya http://127.0.0.1 / localhost.',
  'videos.studio.errorNotSupported': 'Bu browser veya device does değil destek screen capture burada. Kullan bir up-to-tarih Chrome veya Edge on desktop.',
  'videos.studio.errorMicDenied': 'Microphone blocked: allow microphone için bu site (kilitle veya bilgi simge in the address bar), sonra dene tekrar.',
  'videos.studio.errorScreenDenied': 'Screen paylaşılıyor denied: seç bir screen veya sekme in the browser dialog ve onayla « Paylaş ».',
  'videos.studio.errorMicMissing': 'Hayır microphone bulundu. Kontrol et hardware ve sistem ayarlar.',
  'videos.studio.errorScreenMissing': 'Screen paylaşılıyor is değil mevcut on bu device veya browser.',
  'videos.studio.errorMicBusy': 'Microphone is in kullan tarafından another app. Kapat it ve dene tekrar.',
  'videos.studio.errorScreenBusy': 'Could değil capture the screen (kaynak busy). Tekrar dene veya restart the browser.',
  'videos.studio.errorScreenCancelled': 'Screen paylaşılıyor iptal edildi.',
  'videos.studio.errorMicCancelled': 'Microphone erişim iptal edildi.',
  'videos.studio.errorMicGeneric': 'Could değil erişim the microphone.',
  'videos.studio.errorScreenGeneric': 'Could değil capture the screen.',
  'videos.studio.errorScreenEnded': 'Screen paylaşılıyor durduruldu.',
  'videos.studio.mediaHints': 'Chrome veya Edge on desktop. Eğer you kullan http:// ile bir LAN IP (e.g. 192.168.x.x), capture is sık sık blocked: kullan http://localhost:5173 veya geçerli HTTPS.',
  'videos.studio.errorRecord': 'Kayıt is değil supported in bu browser.',
  'videos.studio.errorUpload': 'Yükle başarısız.',
  'videos.studio.errorLoadDraft': 'Could değil load taslak.',
  'videos.studio.errorTranscribe': 'Transcription mevcut değil.',
  'videos.studio.errorPolish': 'AI polish başarısız.',
  'videos.studio.errorTts': 'Text-to-speech başarısız.',
  'videos.studio.errorMux': 'Ses merge başarısız.',
  'videos.studio.muxSuccess': 'AI voice uygulandı to the video',
  'videos.studio.successFinal': 'Video kaydedildi to sizin library',
  'videos.studio.generatingTimeline': 'Oluşturuluyor timeline…',
  'videos.studio.crop': 'Kırp',
  'videos.studio.cropReset': 'Sıfırla crop',
  'videos.studio.cropActive': 'Crop aktif — sürükle veya resize the region on the video',
  'videos.studio.cropDone': 'Tamamlandı',
  'videos.studio.cropApplied': 'Crop uygulandı',
  'videos.studio.cropEdit': 'Düzenle',
  'videos.studio.cropRemove': 'Kaldır',
  'videos.studio.trimIn': 'IN',
  'videos.studio.trimOut': 'OUT',
  'videos.studio.trimDuration': 'süre',
  'videos.preview.noFile': 'Hayır dosya mevcut.',
  'videos.status.draft': 'Taslak',
  'videos.status.published': 'Yayınlandı',
  'sounds.card.delete': 'Sil',
  'sounds.card.mute': 'Mute',
  'sounds.deleteDialog.body': '« {{başlık}} » will be permanently kaldırıldı from the server ve sizin library.',
  'sounds.deleteDialog.cancel': 'İptal',
  'sounds.deleteDialog.confirm': 'Sil',
  'sounds.deleteDialog.title': 'Sil bu ses?',
  'sounds.empty.description': 'Içe aktar sizin dosyalar: they are stored in the database ve kopyalandı to the server so nothing is lost.',
  'sounds.empty.importButton': 'Içe aktar bir ses',
  'sounds.empty.title': 'Hayır sesler içe aktarıldı',
  'sounds.fileSize.bytes': '{{boyut}} B',
  'sounds.fileSize.kb': '{{boyut}} KB',
  'sounds.fileSize.mb': '{{boyut}} MB',
  'sounds.importPanel.cancel': 'İptal',
  'sounds.importPanel.changeFile': 'Değiştir dosya',
  'sounds.importPanel.createTag': 'Oluştur « {{etiket}} »',
  'sounds.importPanel.description': 'Ekle bir ses dosya to sizin library için sizin öğrenme yollar.',
  'sounds.importPanel.descriptionLabel': 'Açıklama',
  'sounds.importPanel.descriptionPlaceholder': 'Describe bu ses…',
  'sounds.importPanel.dropzoneBrowse': 'göz at',
  'sounds.importPanel.dropzoneFormats': 'MP3, WAV, OGG, M4A, AAC, FLAC',
  'sounds.importPanel.dropzoneLabel': 'Bırak bir ses dosya veya',
  'sounds.importPanel.optional': '(isteğe bağlı)',
  'sounds.importPanel.submit': 'İçe Aktar',
  'sounds.importPanel.submitting': 'Gönderiliyor…',
  'sounds.importPanel.tagsHint': 'Tür ve bas Gir · Yeni etiketler are oluşturuldu automatically',
  'sounds.importPanel.tagsLabel': 'Etiketler',
  'sounds.importPanel.tagsPlaceholder': 'Ekle etiketler…',
  'sounds.importPanel.title': 'Içe aktar bir ses',
  'sounds.importPanel.titleLabel': 'Başlık',
  'sounds.importPanel.titlePlaceholder': 'Ses ad…',
  'sounds.importPanel.titleRequired': 'Başlık is zorunlu',
  'sounds.noResults': 'Hayır ses matches « {{query}} »',
  'sounds.page.count_one': '{{count}} dosya — kaydedildi in the database ve on the server',
  'sounds.page.count_other': '{{count}} dosyalar — kaydedildi in the database ve on the server',
  'sounds.page.importButton': 'İçe Aktar',
  'sounds.page.searchPlaceholder': 'Başlık, birçıklama, etiket…',
  'sounds.page.title': 'Sesler',
  'documents.count_one': '{{count}} belge',
  'documents.count_other': '{{count}} belgeler',
  'documents.delete.body': 'The belge "{{filename}}" will be kaldırıldı from sizin library.',
  'documents.delete.cancel': 'İptal',
  'documents.delete.confirm': 'Sil',
  'documents.delete.irreversible': 'Bu eylem cannot be undone.',
  'documents.delete.title': 'Sil belge?',
  'documents.importPanel.cancel': 'İptal',
  'documents.importPanel.chooseFile': 'Choose bir PDF belge',
  'documents.importPanel.description': 'The belge will be mevcut in sizin PDF bloklar ve in bu library.',
  'documents.importPanel.descriptionLabel': 'Açıklama',
  'documents.importPanel.descriptionPlaceholder': 'birçıklama (isteğe bağlı)',
  'documents.importPanel.fileHint': 'The belge will be mevcut in sizin PDF blok ve in bu library.',
  'documents.importPanel.submit': 'İçe Aktar',
  'documents.importPanel.title': 'Içe aktar PDF',
  'documents.importPanel.titleLabel': 'Başlık',
  'documents.importPanel.titlePlaceholder': 'Belge başlık',
  'documents.importPanel.uploading': 'Yükleniyor',
  'documents.importPdf': 'Içe aktar PDF',
  'documents.loading': 'Yükleniyor library…',
  'documents.newDocument': 'Yeni belge',
  'documents.noDocuments': 'Hayır belgeler',
  'documents.noDocumentsHint': 'Içe aktar sizin PDFs burada to reuse them sonra in the PDF blok.',
  'documents.noResults': 'Hayır belgeler match sizin ara.',
  'documents.pages_one': '{{count}} sayfa',
  'documents.pages_other': '{{count}} sayfalar',
  'documents.previewTitle': 'Belge önizleme',
  'documents.searchPlaceholder': 'Ara için bir PDF...',
  'documents.share.accessRemoved': 'Erişim kaldırıldı için the öğrenci.',
  'documents.share.assignedTitle': 'Öğrenciler ile erişim',
  'documents.share.close': 'Kapat',
  'documents.share.createAndShare': 'Oluştur, paylaş, ve gönder davet',
  'documents.share.createError': 'Could değil oluştur the öğrenci.',
  'documents.share.createLearner': 'Oluştur yeni öğrenci',
  'documents.share.createdSuccess': 'Hesap oluşturuldu/linked, belge paylaşıldı, ve e-posta gönderildi.',
  'documents.share.creating': 'Gönderiliyor...',
  'documents.share.emailPlaceholder': 'E-posta *',
  'documents.share.firstNamePlaceholder': 'Ilk ad *',
  'documents.share.hideCreateLearner': 'Gizle quick oluştur',
  'documents.share.lastNamePlaceholder': 'Son ad *',
  'documents.share.loadingAssigned': 'Yükleniyor…',
  'documents.share.loadingLearners': 'Yükleniyor öğrenciler...',
  'documents.share.noAssigned': 'Hayır öğrenciler atandı to bu belge.',
  'documents.share.noLearners': 'Hayır öğrenciler mevcut.',
  'documents.share.removeButton': 'Kaldır',
  'documents.share.removeError': 'Could değil kaldır erişim.',
  'documents.share.searchPlaceholder': 'Ara için bir öğrenci (ilk ad, son ad, e-posta)',
  'documents.share.selectLearner': 'Seç bir existing öğrenci',
  'documents.share.shareButton': 'Paylaş',
  'documents.share.shareError': 'Could değil paylaş the belge.',
  'documents.share.sharedSuccess': 'Belge paylaşıldı ve davet gönderildi.',
  'documents.share.title': 'Paylaş belge',
  'documents.subtitle': 'Reusable PDF belge library için the designer.',
  'documents.title': 'Belgeler',
  'documents.toast.importError': 'Içe aktar başarısız',
  'documents.toast.importErrorDefault': 'The içe aktar başarısız.',
  'documents.toast.importSuccess': 'Belge içe aktarıldı',
  'documents.toast.importSuccessDesc': '{{filename}} has been eklendi to sizin belge library.',
  'documents.updating': 'Güncelleniyor…',
  'help.categories.analytics.description': 'Dashboards, filtreler ve exports to steer the impact of eğitim.',
  'help.categories.analytics.title': 'Analytics & raporlar',
  'help.categories.apprenants.description': 'Track enrollments, cohorts ve katılımcı ilerleme.',
  'help.categories.apprenants.title': 'Öğrenciler, gruplar & tracking',
  'help.categories.boutique.description': 'Sell veya ata eğitim ne zaman the store is etkin.',
  'help.categories.boutique.title': 'Store & monetization',
  'help.categories.demarrage.description': 'Learn the interface, sizin profil ve günlük navigation in Lyrra.',
  'help.categories.demarrage.title': 'Alınıyor başladı & hesap',
  'help.categories.donnees.description': 'GDPR, retention, veri subject rights ve güvenlik best practices.',
  'help.categories.donnees.title': 'Personal veri & güvenlik',
  'help.categories.eduflow.description': 'Design öğrenme yollar ile bloklar, connections ve navigation logic.',
  'help.categories.eduflow.title': 'Yollar & EduFlow designer',
  'help.categories.evaluation.description': 'Sınavlar, assessments, surveys ve geri bildirim to measure öğrenme outcomes.',
  'help.categories.evaluation.title': 'Değerlendirme & aktif öğrenme',
  'help.categories.institution.description': 'Yapılandır sizin kuruluş, collaborators ve içerik structure.',
  'help.categories.institution.title': 'Kurum & ekip',
  'help.categories.marque.description': 'Align colors, labels ve the öğrenci experience ile sizin identity.',
  'help.categories.marque.title': 'Branding & kullanıcı experience',
  'help.categories.medias.description': 'Yönet library, imports ve integrated ses / video / görsel tools in Lyrra.',
  'help.categories.medias.title': 'Medya & creative studio',
  'help.categories.parcours-v2.description': 'Kampanyalar, beceriler, entegrasyonlar: everything o enriches eğitim yönetim.',
  'help.categories.parcours-v2.title': 'Gelişmiş özellikler & roadmap',
  'help.categories.podcasts.description': 'Oluştur ve distribute long-form ses içerik outside the blok-tarafından-blok yol.',
  'help.categories.podcasts.title': 'Podcastler & audiobooks',
  'help.categories.publication.description': 'Yap bir yol mevcut to öğrenciler ve paylaş the sağ erişim.',
  'help.categories.publication.title': 'Publication & distribution',
  'help.categories.qualite.description': 'French quality frameworks: traceability, objectives ve evidence için audits.',
  'help.categories.qualite.title': 'Quality, Qualiopi & pedagogical uyumluluk',
  'help.categories.support.description': 'Ne zaman facing bir technical veya functional sorun, bil nerede to look ve kim to contact.',
  'help.categories.support.title': 'Troubleshooting & destek',
  'help.configHint': 'Editorial içerik: connect sizin URLs, articles veya knowledge base ne zaman you are ready.',
  'help.description': 'Dokümantasyon ve destek',
  'help.hubIntro': 'Topics covering Lyrra usage: you will soon be able to bağlantı her article to sizin dokümantasyon, tutorials veya destek tickets.',
  'help.modal.expectedAnswer': 'Expected cevap:',
  'help.modal.fallbackHighlight1': 'Makale',
  'help.modal.fallbackHighlight2': 'Eğitim platform',
  'help.modal.fallbackHighlight3': 'To be tamamlandı',
  'help.modal.fallbackSectionHeading': 'Key takeaways',
  'help.modal.fallbackSectionParagraph': 'The detailed içerik of bu article will be enriched veya linked to sizin internal dokümantasyon.',
  'help.modal.fallbackStep1Desc': 'Kullan the kenar çubuğu veya the gösterge paneli to erişim the relevant modül.',
  'help.modal.fallbackStep1Title': 'birç the özellik',
  'help.modal.fallbackStep2Desc': 'The screens guide you: kaydet sık sık ve test in önizleme mode ne zaman mevcut.',
  'help.modal.fallbackStep2Title': 'Takip et the business flow',
  'help.modal.fallbackStep3Desc': 'Değil sizin kurum\\\'s specifics (HR processes, naming, brand guidelines) için sizin ekip.',
  'help.modal.fallbackStep3Title': 'Belge internally',
  'help.modal.fallbackTip': 'Eğer in doubt, kontrol et sizin rol (eğitmen, admin, HR): the displayed menus depend on it.',
  'help.modal.quiz': 'Doğrulama sınav',
  'help.modal.related': 'See ayrıca',
  'help.modal.resources': 'Kaynaklar',
  'help.modal.steps': 'In practice',
  'help.modal.tips': 'Tips',
  'help.noResults': 'Hayır sonuçlar için bu ara.',
  'help.onboarding.ai-designer': 'Eğitim — LyrraOne AI designer assistant (onboarding)',
  'help.onboarding.blocks': 'Eğitim — EduFlow blok types (onboarding)',
  'help.onboarding.branches': 'Eğitim — EduFlow branches & conditions (onboarding)',
  'help.onboarding.catalog-visibility': 'Eğitim — LyrraOne catalog & visibility (onboarding)',
  'help.onboarding.certificates': 'Eğitim — LyrraOne issued sertifikalar (onboarding)',
  'help.onboarding.dashboard': 'Eğitim — Lyrra gösterge paneli (onboarding)',
  'help.onboarding.designer-overview': 'Eğitim — EduFlow designer genel bakış (onboarding)',
  'help.onboarding.enrollments': 'Eğitim — LyrraOne enrollments & katılımcılar (onboarding)',
  'help.onboarding.groups-cohorts': 'Eğitim — LyrraOne gruplar & cohorts (onboarding)',
  'help.onboarding.media-library': 'Eğitim — LyrraOne medya library (onboarding)',
  'help.onboarding.navigation': 'Eğitim — Lyrra navigation & kenar çubuğu (onboarding)',
  'help.onboarding.objectives': 'Eğitim — EduFlow öğrenme objectives (onboarding)',
  'help.onboarding.profile': 'Eğitim — Lyrra profil & preferences (onboarding)',
  'help.onboarding.progress': 'Eğitim — LyrraOne ilerleme & time spent (onboarding)',
  'help.onboarding.publication-links': 'Eğitim — LyrraOne erişim bağlantılar & paylaşılıyor (onboarding)',
  'help.onboarding.publication-status': 'Eğitim — LyrraOne taslak, publication ve updates (onboarding)',
  'help.onboarding.roles': 'Eğitim — Lyrra roller ve erişim rights (onboarding)',
  'help.onboarding.validation': 'Eğitim — EduFlow yol doğrulama (onboarding)',
  'help.onboardingFlowMissing': 'Eğitim değil bulundu',
  'help.onboardingFlowMissingDesc': 'Çalıştır the db:seed:onboarding-eduflow ve db:seed:onboarding-navigation-eduflow scripts (backend), veya ayarla the VITE_ONBOARDING_*_FLOW_ID variables.',
  'help.openArticle': 'birç article',
  'help.searchPlaceholder': 'Ara bir konu…',
  'help.title': 'Yardım Orta',
  'help.topics.analytics-exports.description': 'Prepare extractions için internal veya regulatory reporting.',
  'help.topics.analytics-exports.title': 'Exports & HR reporting',
  'help.topics.analytics-indicateurs.description': 'Tamamlanma rate, engagement, distribution tarafından durum ve time on bloklar.',
  'help.topics.analytics-indicateurs.title': 'Key indicators',
  'help.topics.analytics-vue.description': 'Customize charts, periods ve filtrele tarafından eğitim to analyze veri.',
  'help.topics.analytics-vue.title': 'Analytics genel bakış',
  'help.topics.app-certificats.description': 'Kontrol et oluşturuldu sertifikalar ve associated tamamlanma conditions.',
  'help.topics.app-certificats.title': 'Issued sertifikalar',
  'help.topics.app-groupes.description': 'Kullan gruplar to segment audiences ve facilitate kampanyalar veya raporlar.',
  'help.topics.app-groupes.title': 'Gruplar & cohorts',
  'help.topics.app-inscriptions.description': 'Görüntüle the liste of öğrenciler on bir yol, onların statuses ve erişim history.',
  'help.topics.app-inscriptions.title': 'Enrollments & katılımcılar',
  'help.topics.app-progression.description': 'Interpret ilerleme, completions ve engagement time within bloklar.',
  'help.topics.app-progression.title': 'Ilerleme & time spent',
  'help.topics.boutique-offres.description': 'Bağlantı yollar to products veya erişim codes based on sizin business model.',
  'help.topics.boutique-offres.title': 'Offers & pricing',
  'help.topics.boutique-paiement.description': 'Understand the purchase flow on the öğrenci side ve confirmations on the kurum side.',
  'help.topics.boutique-paiement.title': 'Payments & billing',
  'help.topics.demarrage-navigation.description': 'Bul the Projeler, Eğitim, Medya, Analytics ve Ayarlar spaces based on sizin rol.',
  'help.topics.demarrage-navigation.title': 'Navigation & kenar çubuğu',
  'help.topics.demarrage-profil.description': 'Güncelle sizin bilgi, interface dil ve bildirimler.',
  'help.topics.demarrage-profil.title': 'Profil & preferences',
  'help.topics.demarrage-roles.description': 'Understand the differences arasında eğitmen, kurum admin, HR ve öğrenci.',
  'help.topics.demarrage-roles.title': 'Roller ve erişim rights',
  'help.topics.demarrage-tableau-bord.description': 'Oku key indicators, quickly erişim son yollar ve useful shortcuts.',
  'help.topics.demarrage-tableau-bord.title': 'Eğitim gösterge paneli',
  'help.topics.donnees-conservation.description': 'Arşivleniyor süre principles için ilerleme ve eğitim evidence.',
  'help.topics.donnees-conservation.title': 'Retention period',
  'help.topics.donnees-mots-de-passe.description': 'Şifre best practices, oturumlar ve erişim delegation.',
  'help.topics.donnees-mots-de-passe.title': 'Accounts & kimlik doğrulama',
  'help.topics.donnees-rgpd.description': 'Purposes of veri collected in Lyrra ve the eğitim yönetici\\\'s responsibility.',
  'help.topics.donnees-rgpd.title': 'GDPR & işleniyor registry',
  'help.topics.eduflow-blocs.description': 'Choose ve yapılandır the sağ bloklar: text, video, ses, değerlendirme, branching, etc.',
  'help.topics.eduflow-blocs.title': 'Blok types (içerik, sınav, medya…)',
  'help.topics.eduflow-branches.description': 'Yönet multiple outputs, yol convergence ve navigation rules.',
  'help.topics.eduflow-branches.title': 'Branches & conditions',
  'help.topics.eduflow-concept.description': 'Canvas, blok palette, seçim, yakınlaştırma ve visual kuruluş of the yol.',
  'help.topics.eduflow-concept.title': 'Designer genel bakış',
  'help.topics.eduflow-ia.description': 'Suggest veya düzenle bloklar ile the assistant, ile systematic human değerlendirme.',
  'help.topics.eduflow-ia.title': 'AI assistant in the designer',
  'help.topics.eduflow-objectifs.description': 'Bağlantı objectives to bloklar to structure the framework of sizin eğitim.',
  'help.topics.eduflow-objectifs.title': 'Öğrenme objectives',
  'help.topics.eduflow-validation.description': 'Kullan the Doğrulama panel to detect hatalar ve uyarılar önce publication.',
  'help.topics.eduflow-validation.title': 'Yol doğrulama',
  'help.topics.eval-auto-eval.description': 'Offer adaptive yollar based on sonuçlar.',
  'help.topics.eval-auto-eval.title': 'Self-değerlendirme & remediation',
  'help.topics.eval-ouverte.description': 'Organize the collection of ücretsiz-form cevaplar ve manuel veya semi-automated grading.',
  'help.topics.eval-ouverte.title': 'birç-ended sorular & grading',
  'help.topics.eval-quiz.description': 'Yapılandır scoring, geri bildirim ve denemeler için effective MCQs.',
  'help.topics.eval-quiz.title': 'Sınavlar & multiple-choice sorular',
  'help.topics.inst-collaborateurs.description': 'Ekle trainers, administrators veya HR staff ve yönet izinler.',
  'help.topics.inst-collaborateurs.title': 'Kullanıcılar & invitations',
  'help.topics.inst-structure.description': 'Define ne is paylaşıldı at kurum seviye versus personal projeler.',
  'help.topics.inst-structure.title': 'Structure & scope',
  'help.topics.inst-trash.description': 'Bul silindi eğitim veya podcastler ve geri yükle them eğer gerekli.',
  'help.topics.inst-trash.title': 'Trash & restoration',
  'help.topics.marque-accessibilite.description': 'Contrast, text alternatives ve keyboard navigation in içerik.',
  'help.topics.marque-accessibilite.title': 'Accessibility & readability',
  'help.topics.marque-charte.description': 'Nasıl branding is reflected in the player ve öğrenci spaces.',
  'help.topics.marque-charte.title': 'Brand & institutional colors',
  'help.topics.marque-landing.description': 'Showcase sizin eğitim offering to visitors ne zaman the modül is etkin.',
  'help.topics.marque-landing.title': 'Genel sayfalar & catalog',
  'help.topics.medias-bibliotheque.description': 'Içe aktar, organize ve reuse videolar, sesler, görseller ve belgeler in sizin bloklar.',
  'help.topics.medias-bibliotheque.title': 'Medya library',
  'help.topics.medias-documents.description': 'Attach downloadable kaynaklar ve bağlantı dokümantasyon to the yol.',
  'help.topics.medias-documents.title': 'Belgeler & PDFs',
  'help.topics.medias-studio-audio.description': 'Kaydet, mix veya kullan text-to-speech to enhance sizin içerik.',
  'help.topics.medias-studio-audio.title': 'Ses & voice studio',
  'help.topics.medias-video.description': 'Best practices için format, boyut ve accessibility için embedded players.',
  'help.topics.medias-video.title': 'Videolar & entegrasyonlar',
  'help.topics.podcasts-creation.description': 'Structure episodes, metadata ve covers için sizin ses offering.',
  'help.topics.podcasts-creation.title': 'Oluşturuluyor bir podcast',
  'help.topics.podcasts-diffusion.description': 'Dinleniyor ayarlar, paylaşılıyor ve usage tracking için the kurum.',
  'help.topics.podcasts-diffusion.title': 'Distribution & öğrenciler',
  'help.topics.pub-catalogue.description': 'Attach bir eğitim to the institutional catalog veya bir offer ne zaman etkin.',
  'help.topics.pub-catalogue.title': 'Catalog & visibility',
  'help.topics.pub-liens.description': 'Oluştur veya kopyala bağlantılar için öğrenciler, presenters veya önizleme.',
  'help.topics.pub-liens.title': 'Erişim bağlantılar & paylaşılıyor',
  'help.topics.pub-statuts.description': 'Eğitim lifecycle: kaydet, test, yayınla ve sürüm değişiklikler.',
  'help.topics.pub-statuts.title': 'Taslak, publication ve updates',
  'help.topics.qualite-qualiopi.description': 'Kullan dedicated spaces to prepare criteria ve the quality dossier.',
  'help.topics.qualite-qualiopi.title': 'Pre-audit & Qualiopi indicators',
  'help.topics.qualite-tracabilite.description': 'Bağlantı objectives, içerik ve assessments to belge the certified yol.',
  'help.topics.qualite-tracabilite.title': 'Pedagogical traceability',
  'help.topics.support-contact.description': 'Destek channel, ticket oluşturma ve bilgi to provide için bir quick diagnosis.',
  'help.topics.support-contact.title': 'Contact Lyrra destek',
  'help.topics.support-faq.description': 'Player değil yükleniyor, missing medya, publication hata: ilk adımlar.',
  'help.topics.support-faq.title': 'Common issues',
  'help.topics.support-navigateur.description': 'Recommended versions, cookies ve extensions o may interfere.',
  'help.topics.support-navigateur.title': 'Browser & compatibility',
  'help.topics.v2-campagnes.description': 'Plan the deployment of yollar to targeted audiences üzerinde time.',
  'help.topics.v2-campagnes.title': 'Kampanyalar & eğitim plans',
  'help.topics.v2-competences.description': 'Map bloklar veya yollar to expected beceriler için business reporting.',
  'help.topics.v2-competences.title': 'Beceriler frameworks',
  'help.topics.v2-integrations.description': 'Exchanges ile sizin HR IS, external LMS veya BI tools ne zaman connectors are mevcut.',
  'help.topics.v2-integrations.title': 'Entegrasyonlar & API',
  'pages.images.cancel': 'İptal',
  'pages.images.changeFile': 'Değiştir dosya',
  'pages.images.copyUrl': 'Kopyala URL',
  'pages.images.copyUrlSuccess': 'URL kopyalandı to clipboard.',
  'pages.images.copyUrlError': 'Could değil kopyala the URL.',
  'pages.images.urlLabel': 'Genel URL',
  'pages.images.download': 'İndir',
  'pages.images.downloadSuccess': 'Indir başladı.',
  'pages.images.downloadError': 'Indir başarısız.',
  'pages.images.count_one': '{{count}} görsel in sizin library',
  'pages.images.count_other': '{{count}} görseller in sizin library',
  'pages.images.delete': 'Sil',
  'pages.images.deleteAction': 'Sil',
  'pages.images.deleteConfirmHint': 'will be permanently silindi.',
  'pages.images.deleteTitle': 'Sil bu görsel?',
  'pages.images.descriptionLabel': 'birçıklama (isteğe bağlı)',
  'pages.images.descriptionPlaceholder': 'Short birçıklama…',
  'pages.images.dropzoneBrowse': 'göz at',
  'pages.images.dropzoneFormats': 'PNG, JPG, WEBP, GIF',
  'pages.images.dropzoneLabel': 'Sürükle bir görsel veya',
  'pages.images.fileSize.bytes': '{{boyut}} B',
  'pages.images.fileSize.kb': '{{boyut}} KB',
  'pages.images.fileSize.mb': '{{boyut}} MB',
  'pages.images.fileSizeKb': '{{boyut}} KB',
  'pages.images.importButton': 'İçe Aktar',
  'pages.images.importSubtitle': 'Ekle bir görsel to sizin library için sizin eğitim.',
  'pages.images.importTitle': 'Içe aktar bir görsel',
  'pages.images.noImages': 'Hayır görseller içe aktarıldı',
  'pages.images.noResults': 'Sonuç yok',
  'pages.images.searchPlaceholder': 'Ara için bir görsel…',
  'pages.images.submit': 'İçe Aktar',
  'pages.images.titleLabel': 'Başlık (isteğe bağlı)',
  'pages.images.titlePlaceholder': 'Görsel ad…',
  'pages.images.viewGrid': 'Izgara',
  'pages.images.viewList': 'Liste',
  'pages.images.editPanelTitle': 'Düzenle görsel',
  'pages.images.editPanelSubtitle': 'Başlık, birçıklama ve dosya ad. Replacing the dosya keeps the aynı URL (existing references tut çalışıyor).',
  'pages.images.replaceFileLabel': 'Yeni görsel dosya',
  'pages.images.replaceFileHint': 'The görsel is converted to match the mevcut dosya extension. The genel URL does değil değiştir.',
  'pages.images.fileOriginalNameLabel': 'Original dosya ad',
  'pages.images.saveChanges': 'Kaydet',
  'pages.images.saveSuccess': 'Görsel güncellendi.',
  'pages.images.saveError': 'Could değil kaydet.',
  'pages.images.editAction': 'Düzenle',
  'accessibility.simplifiedTextMode': 'Simplified text mode',
  'accessibility.simplifiedTextModeDesc': 'Simplifies sadece the kurs text to yap reading ve understanding easier.',
  'accessibility.imageHoverAudio': 'Düşük-vision mode: oynat görsel ses on hover',
  'accessibility.imageHoverAudioDesc': 'Ne zaman bir görsel is hovered in the player, the ses birçıklama starts automatically.',
  'auth.acceptTerms': 'I kabul et the',
  'auth.accessDenied': 'Erişim Denied',
  'auth.and': 've',
  'auth.backToLogin': 'Geri to login',
  'auth.checkInbox': 'Kontrol et sizin inbox için bir şifre sıfırla bağlantı. It may al bir birkaç dakika.',
  'auth.confirmPassword': 'Onayla şifre',
  'auth.confirmRequired': 'Lütfen onayla sizin şifre',
  'auth.createAccount': 'Oluştur sizin hesap',
  'auth.email': 'E-posta',
  'auth.emailInvalid': 'Geçersiz e-posta address',
  'auth.emailPassword': 'E-posta & Şifre',
  'auth.emailRequired': 'E-posta is zorunlu',
  'auth.emailSent': 'E-posta gönderildi!',
  'auth.firstName': 'Ilk ad',
  'auth.firstNameRequired': 'Zorunlu',
  'auth.forgotError': 'Başarısız to gönder sıfırla e-posta',
  'auth.forgotPassword': 'Şifremi Unuttum',
  'auth.forgotPasswordTitle': 'Forgot şifre?',
  'auth.goBack': 'Git geri',
  'auth.goToLogin': 'Git to login',
  'auth.hasAccount': 'Zaten have bir hesap?',
  'auth.hidePassword': 'Gizle şifre',
  'auth.institutionRegister': 'Inscription Kurum',
  'auth.invalidLink': 'Geçersiz sıfırla bağlantı',
  'auth.invalidLinkDesc': 'Bu şifre sıfırla bağlantı is geçersiz veya has süresi doldu.',
  'auth.invalidToken': 'Geçersiz veya süresi doldu sıfırla belirteç',
  'auth.lastName': 'Son ad',
  'auth.lastNameRequired': 'Zorunlu',
  'auth.loginError': 'Giriş başarısız. E-posta ve şifrenizi kontrol edin.',
  'auth.loginOTP': 'Login ile OTP',
  'auth.loginSubtitle': 'Sign in to sizin LyrraOne hesap',
  'auth.newPassword': 'Yeni şifre',
  'auth.otpSubtitle': 'We gönderildi bir 6-digit code to sizin e-posta',
  'auth.otpTitle': 'Gir doğrulama code',
  'auth.password': 'Şifre',
  'auth.passwordMin': 'Minimum 8 characters',
  'auth.passwordMismatch': 'Passwords do değil match',
  'auth.passwordRequired': 'Şifre is zorunlu',
  'auth.passwordReset': 'Şifre sıfırla!',
  'auth.passwordResetDesc': 'Sizin şifre has been başarıyla güncellendi.',
  'auth.privacy': 'Privacy Politika',
  'auth.registerError': 'Registration başarısız',
  'auth.registerSubtitle': 'Başlangıç oluşturuluyor ile LyrraOne',
  'auth.requestNewLink': 'Istek bir yeni bağlantı',
  'auth.resendCode': 'Resend code',
  'auth.resendIn': 'Resend code in',
  'auth.resetError': 'Başarısız to sıfırla şifre',
  'auth.resetPassword': 'Şifreyi Sıfırla',
  'auth.resetPasswordSubtitle': 'Choose bir strong şifre için sizin hesap',
  'auth.resetPasswordTitle': 'Ayarla yeni şifre',
  'auth.sendOTP': 'Gönder OTP code',
  'auth.sendResetLink': 'Gönder sıfırla bağlantı',
  'auth.showPassword': 'Göster şifre',
  'auth.terms': 'Terms of Service',
  'auth.termsRequired': 'You gerekir kabul et the terms',
  'auth.welcomeBack': 'Hoş geldiniz geri',
  'campaign.analytics.avgProgress': 'Progression moy.',
  'campaign.analytics.avgProgressChart': 'Progression moyenne',
  'campaign.analytics.completion': 'Taux de complétion',
  'campaign.analytics.completionPct': 'Complétion %',
  'campaign.analytics.completionRate': 'Taux de complétion',
  'campaign.analytics.now': 'Actuel',
  'campaign.analytics.totalParticipants': 'Katılımcılar',
  'campaign.budget.none': 'Aucun budget renseigné.',
  'campaign.budget.title': 'Budget prévu',
  'campaign.col.participant': 'Katılımcı',
  'campaign.col.progress': 'Progression',
  'campaign.col.status': 'Statut',
  'campaign.content.placeholderTitle': 'Contenus pédagogiques',
  'campaign.detail.actionError': 'Eylem impossible.',
  'campaign.detail.back': 'Retour aux campagnes',
  'campaign.detail.cancel': 'Annuler',
  'campaign.detail.complete': 'Clôturer',
  'campaign.detail.description': 'Açıklama',
  'campaign.detail.launch': 'Lancer',
  'campaign.detail.loadError': 'Impossible de charger la campagne.',
  'campaign.detail.missingId': 'Identifiant manquant.',
  'campaign.detail.noDescription': 'Aucune birçıklama.',
  'campaign.detail.timeline': 'Calendrier',
  'campaign.participants.empty': 'Aucun katılımcı ataé.',
  'campaign.participants.unknown': 'Inconnu',
  'campaign.stats.completed': 'Terminés',
  'campaign.stats.enrolled': 'Inscrits',
  'campaign.stats.inProgress': 'En cours',
  'campaign.stats.notStarted': 'Non démarrés',
  'campaign.tab.analytics': 'Analytique',
  'campaign.tab.budget': 'Bütçe',
  'campaign.tab.content': 'Contenu',
  'campaign.tab.overview': 'Vue d’ensemble',
  'campaign.tab.participants': 'Katılımcılar',
  'campaign.timeline.end': 'Fin prévue',
  'campaign.timeline.start': 'Déama de campagne',
  'campaigns.col.budget': 'Bütçe',
  'campaigns.col.completion': 'Tamamlanma',
  'campaigns.col.enrolled': 'Kaydedildi',
  'campaigns.col.name': 'Ad',
  'campaigns.col.period': 'Period',
  'campaigns.col.status': 'Durum',
  'campaigns.create.budget': 'Budget (€)',
  'campaigns.create.budgetPlaceholder': '25000',
  'campaigns.create.departments': 'Departments',
  'campaigns.create.description': 'Açıklama',
  'campaigns.create.endDate': 'Son tarih',
  'campaigns.create.error': 'Could değil oluştur kampanya.',
  'campaigns.create.individualSearchPlaceholder': 'Ara people...',
  'campaigns.create.individuals': 'Individuals',
  'campaigns.create.launch': 'Launch kampanya',
  'campaigns.create.launchNote': 'Launching notifies tümü katılımcılar ve starts the kampanya on the seçildi başlangıç tarih.',
  'campaigns.create.name': 'Kampanya ad',
  'campaigns.create.namePlaceholder': 'e.g. Leadership 2025',
  'campaigns.create.review': 'Değerlendirme',
  'campaigns.create.reviewFieldBudget': 'Bütçe',
  'campaigns.create.reviewFieldName': 'Ad',
  'campaigns.create.reviewFieldPeriod': 'Period',
  'campaigns.create.reviewContentItems': 'Eğitim içerik',
  'campaigns.create.contentSelected': '{{count}} seçildi',
  'campaigns.create.selectContent': 'Seç eğitim içerik',
  'campaigns.create.startDate': 'Başlangıç tarih',
  'campaigns.create.steps.audience': 'Hedef audience',
  'campaigns.create.steps.basic': 'Temel bilgi',
  'campaigns.create.steps.content': 'İçerik',
  'campaigns.create.steps.review': 'Değerlendirme & launch',
  'campaigns.create.title': 'Oluştur kampanya',
  'campaigns.dept.engineering': 'Engineering',
  'campaigns.dept.product': 'Product',
  'campaigns.dept.sales': 'Sales',
  'campaigns.dept.marketing': 'Marketing',
  'campaigns.dept.finance': 'Finance',
  'campaigns.dept.legal': 'Legal',
  'campaigns.dept.hr': 'Human kaynaklar',
  'campaigns.list.create': 'Yeni kampanya',
  'campaigns.list.empty': 'Hayır kampanyalar bulundu.',
  'campaigns.list.loadError': 'Unable to load kampanyalar.',
  'campaigns.list.results': 'kampanyalar',
  'campaigns.list.search': 'Ara kampanyalar...',
  'campaigns.list.title': 'Kampanyalar',
  'campaigns.page.documentTitle': 'Kampanyalar - LyrraOne',
  'campaigns.sort.completion': 'Tamamlanma',
  'campaigns.sort.enrolled': 'Kaydedildi',
  'campaigns.sort.name': 'Ad',
  'campaigns.sort.startDate': 'Başlangıç tarih',
  'campaigns.status.active': 'Aktif',
  'campaigns.status.all': 'Tümü',
  'campaigns.status.cancelled': 'Iptal edildi',
  'campaigns.status.completed': 'Tamamlandı',
  'campaigns.status.draft': 'Taslak',
  'campaigns.status.paused': 'Duraklatıldı',
  'campaigns.status.scheduled': 'Zamanlanmış',
  'campaigns.validation.budgetRequired': 'Budget is zorunlu.',
  'campaigns.validation.endDateRequired': 'Son tarih is zorunlu.',
  'campaigns.validation.nameRequired': 'Kampanya ad is zorunlu.',
  'campaigns.validation.startDateRequired': 'Başlangıç tarih is zorunlu.',
  'catalog.backToCatalog': 'Retour au catalogue',
  'catalog.categories': 'Catégories',
  'catalog.category': 'Catégorie',
  'catalog.detailLoadError': 'Impossible de charger la formation.',
  'catalog.enrollError': 'Inscription impossible.',
  'catalog.enrollOk': 'Inscription enregistrée.',
  'catalog.enrollments': 'insc.',
  'catalog.flowFromTeacher': 'Parcours formateur',
  'catalog.format': 'Format',
  'catalog.language': 'Langue',
  'catalog.loadError': 'Impossible de charger le catalogue.',
  'catalog.missingId': 'Identifiant manquant.',
  'catalog.noObjectives': 'Aucune compétence liée.',
  'catalog.noResults': 'Aucune formation ne correspond à vos critères.',
  'catalog.objectives': 'Objectifs / compétences',
  'catalog.prerequisites': 'Prérequis',
  'catalog.prerequisitesPlaceholder': 'Les prérequis détaillés seront affichés lorsque renseignés sur la fiche.',
  'catalog.related': 'Formations populaires',
  'catalog.results': 'formation(s)',
  'catalog.search': 'Rechercher une formation…',
  'catalog.sortDuration': 'Durée',
  'catalog.sortName': 'Nom',
  'catalog.sortPopular': 'Popularité',
  'catalog.sortRating': 'Değil',
  'certificate.completed': 'has başarıyla tamamlandı',
  'certificate.date': 'Tarih',
  'certificate.download': 'Indir PDF',
  'certificate.title': 'Sertifika of Tamamlanma',
  'certificate.verification': 'Doğrulama',
  'certification.completeToUnlock': 'Complétez toutes les étapes pour débloquer votre certificat.',
  'certification.download': 'Télécharger',
  'certification.earned': 'Certification obtenue',
  'certification.locked': 'Verrouillé',
  'certification.milestones': 'étapes',
  'certification.preview': 'Certificat',
  'certification.requirements': 'Prérequis à valider :',
  'certification.subtitle': 'Suivez votre progression vers vos certifications professionnelles.',
  'certification.title': 'Parcours de certification',
  'codir.card.budgetAllocated': 'Budget alloué (année)',
  'codir.card.campaigns': 'Campagnes actives',
  'codir.card.completionYtd': 'Taux complétion (année)',
  'codir.card.costPerUser': 'Coût / utilisateur (estim.)',
  'codir.card.used': 'utilisé',
  'codir.dashboard.budgetOverview': 'Budget (année en cours)',
  'codir.dashboard.competencyGaps': 'Écarts compétences critiques',
  'codir.dashboard.completionTrends': 'Achèvements par mois',
  'codir.dashboard.completionsPerMonth': 'Achèvements / mois',
  'codir.dashboard.deptPerformance': 'Budget par direction',
  'codir.dashboard.loadError': 'Impossible de charger le tableau de bord.',
  'codir.dashboard.noBudget': 'Non renseigné',
  'codir.dashboard.noDeptData': 'Aucune ligne budgétaire',
  'codir.dashboard.noGaps': 'Aucun écart critique recensé.',
  'codir.dashboard.remaining': 'Restant',
  'codir.dashboard.spent': 'Consommé',
  'codir.dashboard.strategicKPIs': 'Indicateurs clés',
  'codir.dashboard.subtitle': 'Indicateurs formation et budget',
  'codir.dashboard.title': 'Tableau de bord CODIR',
  'codir.dashboard.totalBudget': 'Budget toplam',
  'codir.dashboard.utilization': 'Utilisation %',
  'codir.kpi.budget': 'Budget consommé',
  'codir.kpi.completion': 'Complétion',
  'codir.kpi.recentCompletions': 'Achèvements 30 j.',
  'codir.kpi.satisfaction': 'Satisfaction',
  'collab.certificates.active': 'actif(s)',
  'collab.certificates.empty': 'Aucun certificat pour ce filtre.',
  'collab.certificates.expires': 'Expire le',
  'collab.certificates.issued': 'Délivré le',
  'collab.certificates.title': 'Mes certificats',
  'collab.certificates.verify': 'Vérifier',
  'collab.dashboard.activeTrainings': 'Formations en cours',
  'collab.dashboard.certificates': 'Certificats',
  'collab.dashboard.completed': 'Terminées',
  'collab.dashboard.level': 'Niveau',
  'collab.dashboard.noActiveTrainings': 'Aucune formation en cours.',
  'collab.dashboard.noCompleted': 'Aucune formation terminée.',
  'collab.dashboard.noUpcoming': 'Aucune formation à venir.',
  'collab.dashboard.title': 'Mes formations',
  'collab.dashboard.totalXp': 'XP Toplam',
  'collab.dashboard.upcoming': 'À venir',
  'collab.request.history': 'Historique de mes demandes',
  'collab.request.justification': 'Justification',
  'collab.request.justificationPlaceholder': 'Expliquez pourquoi cette formation est nécessaire (min. 10 caractères)…',
  'collab.request.newRequest': 'Nouvelle demande',
  'collab.request.noHistory': 'Aucune demande pour le moment.',
  'collab.request.preferredDate': 'Tarih souhaitée',
  'collab.request.searchCatalog': 'Rechercher dans le catalogue…',
  'collab.request.submit': 'Envoyer la demande',
  'collab.request.title': 'Demander une formation',
  'collab.request.training': 'Formation',
  'collab.skills.current': 'Niveau actuel',
  'collab.skills.empty': 'Aucune compétence renseignée.',
  'collab.skills.emptyHint': 'Vos compétences apparaîtront ici une fois ajoutées.',
  'collab.skills.radar': 'Radar de compétences',
  'collab.skills.selfAssess': 'Auto-évaluation',
  'collab.skills.target': 'Objectif',
  'collab.skills.title': 'Mes compétences',
  'common.back': 'Geri',
  'common.cancel': 'İptal',
  'common.close': 'Kapat',
  'common.collaborator': 'Collaborateur',
  'common.comingSoon': 'En construction',
  'common.comment': 'Commentaire',
  'common.comments': 'Yorumlar',
  'common.complete': 'Tamamla',
  'common.confirm': 'Onayla',
  'common.cost': 'Coût',
  'common.current': 'Mevcut',
  'common.date': 'Tarih souhaitée',
  'common.delete': 'Sil',
  'common.description': 'Açıklama',
  'common.download': 'Télécharger',
  'common.invalidEmail': 'Geçersiz e-posta',
  'common.justification': 'Justification',
  'common.managerComment': 'Commentaire yönetici',
  'common.moveDown': 'Descendre',
  'common.moveUp': 'Monter',
  'common.next': 'İleri',
  'common.noExpiry': 'Sans expiration',
  'common.noResults': 'Sonuç bulunamadı',
  'common.overall': 'Global',
  'common.preview': 'Önizleme',
  'common.previous': 'Önceki',
  'common.publish': 'Yayınla',
  'common.read': 'okundu',
  'common.remove': 'Supprimer',
  'common.required': 'Zorunlu',
  'common.restore': 'Geri Yükle',
  'common.retry': 'Tekrar dene',
  'common.save': 'Kaydet',
  'common.search': 'Ara',
  'common.select': 'Seç...',
  'common.sending': 'Gönderiliyor…',
  'common.share': 'Partager',
  'common.status': 'Statut',
  'common.submit': 'Gönder',
  'common.submittedAt': 'Soumis le',
  'common.title': 'Başlık',
  'common.training': 'Formation',
  'common.view': 'Consulter',
  'common.words': 'words',
  'compliance.download': 'Télécharger',
  'compliance.generate': 'Générer',
  'compliance.generating': 'Génération…',
  'compliance.lastGenerated': 'Généré le',
  'compliance.subtitle': 'Générez et gérez vos belgeler réglementaires et pédagogiques.',
  'compliance.title': 'Belgeler de conformité',
  'compliance.uploadEvidence': 'Importer un justificatif',
  'confirmDialog.cancel': 'İptal',
  'confirmDialog.confirm': 'Onayla',
  'dashboard.collaborators': 'Collaborateurs',
  'dysModule.font': 'OpenDyslexic',
  'dysModule.letter': 'Aa',
  'dysModule.ruler': 'Ruler',
  'dysModule.settings': 'Dyslexia ayarlar',
  'dysModule.word': 'W',
  'eduflow.adaptiveReplacement.assist': 'Assisté',
  'eduflow.adaptiveReplacement.auto': 'Auto',
  'eduflow.adaptiveReplacement.force': 'Forcer la sürüm jeu simplifiée pour ce bloc',
  'eduflow.adaptiveReplacement.manual': 'Manuel',
  'eduflow.adaptiveReplacement.mode': 'Mode',
  'eduflow.adaptiveReplacement.title': 'Remplacement adaptatif',
  'eduflow.answerSubmitted': '✓ Cevap gönderildi başarıyla',
  'eduflow.blocks': 'Bloklar',
  'eduflow.collaborativeBadge': 'Collaboratif',
  'eduflow.contents': 'Içerikler',
  'eduflow.correct': '✓ Doğru!',
  'eduflow.designer.autoLayoutDone': 'Disposition automatique appliquée',
  'eduflow.designer.autoLayoutFailed': 'Impossible de calculer la disposition.',
  'eduflow.designer.autoLayoutNoBlocks': 'Ajoutez au moins un bloc pour lancer la disposition.',
  'eduflow.designer.paletteCategory.institution': 'Blocs kurum',
  'eduflow.duration': 'Süre (saniye)',
  'eduflow.evaluation': 'Değerlendirme',
  'eduflow.evaluationSubmitted': 'Evaluation gönderildi',
  'eduflow.exportFlow': 'Dışbir aktar Flow',
  'eduflow.flowSettings': 'Flow Ayarlar',
  'eduflow.form': 'Form',
  'eduflow.formSubmitted': 'Form gönderildi',
  'eduflow.incorrect': '✗ Yanlış. Dene tekrar.',
  'eduflow.list.coverLabel': 'Görsel de couverture',
  'eduflow.list.coverRemove': 'Retirer la couverture',
  'eduflow.list.coverUpload': 'Choisir une görsel',
  'eduflow.list.flowProperties': 'Başlık, birçıklama & cover',
  'eduflow.list.propertiesPanelTitle': 'Eğitim properties',
  'eduflow.list.duplicatePanelTitle': 'Çoğalt eğitim',
  'eduflow.list.duplicatePanelSubtitle': 'Original eğitim: {{ad}}',
  'eduflow.list.duplicateTitleSuffix': 'kopyala',
  'eduflow.list.duplicateSuccess': 'Eğitim çoğaltıldı.',
  'eduflow.list.duplicateCoverHint': 'Cover görsel ve öğrenme içerik from the original eğitim will be kopyalandı.',
  'eduflow.list.propertiesSaveError': 'Could değil kaydet properties.',
  'eduflow.list.propertiesSaved': 'Properties kaydedildi.',
  'eduflow.list.propertiesUploadError': 'Görsel yükle başarısız.',
  'eduflow.mindmap': 'Mindmap',
  'eduflow.next': 'Suivant',
  'eduflow.noExtraConfig': 'Hayır additional yapılandırma için bu blok tür.',
  'eduflow.openQuestion': 'birç Soru',
  'eduflow.phraseReveal.addPhrase': 'Ajouter une phrase',
  'eduflow.phraseReveal.autoScroll': 'Défilement automatique',
  'eduflow.phraseReveal.displayDuration': 'Durée par phrase (s)',
  'eduflow.phraseReveal.emptyPhrase': 'Phrase vide',
  'eduflow.phraseReveal.noPhrases': 'Aucune phrase pour l’instant.',
  'eduflow.phraseReveal.phraseContent': 'Contenu de la phrase',
  'eduflow.phraseReveal.phrasePlaceholder': 'Saisissez le texte de cette étape…',
  'eduflow.phraseReveal.showHistory': 'Afficher l’historique des phrases',
  'eduflow.quiz': 'Sınav',
  'eduflow.readComplete': 'Oku tamamla',
  'eduflow.summary.addItem': 'Ajouter un puan',
  'eduflow.summary.emptyList': 'Aucun puan pour l’instant. Ajoutez-en un.',
  'eduflow.summary.itemPlaceholder': 'Ex. : Les risques incendie en entreprise',
  'eduflow.takeNotes': 'Al notlar...',
  'eduflow.timeline.addEvent': 'Événement',
  'eduflow.timeline.alternatingSides': 'Côtés alternés',
  'eduflow.timeline.animatedReveal': 'Révélation animée',
  'eduflow.timeline.colorHint': 'Couleur du puan (optionnel)',
  'eduflow.timeline.colorLabel': 'Couleur',
  'eduflow.timeline.datePlaceholder': 'Tarih ou période (ex. 1789, janv. 2024)',
  'eduflow.timeline.descPlaceholder': 'birçıklama (affichée au développement)',
  'eduflow.timeline.events': 'Événements',
  'eduflow.timeline.horizontal': 'Horizontale',
  'eduflow.timeline.orientation': 'Orientation',
  'eduflow.timeline.settings': 'Paramètres',
  'eduflow.timeline.showConnectors': 'Lignes de connexion',
  'eduflow.timeline.untitled': 'Sans titre',
  'eduflow.timeline.vertical': 'Verticale',
  'eduflow.typeAnswer': 'Tür sizin cevap...',
  'eduflow.typeConfig': 'Tür Yapılandırma',
  'eduflow.unsaved': 'Unsaved değişiklikler',
  'eduflow.versionHistory.activateSuccess': 'Sürüm {{etiket}} activated (genel)',
  'eduflow.versionHistory.activateTitle': 'Activate {{etiket}}?',
  'eduflow.versionHistory.confirmActivate': 'Activate',
  'eduflow.versionHistory.copyFailed': 'Kopyala başarısız',
  'eduflow.versionHistory.copyHtml': 'Kopyala HTML',
  'eduflow.versionHistory.copyPlain': 'Kopyala plain text',
  'eduflow.versionHistory.createMajor': 'Major sürüm',
  'eduflow.versionHistory.createMajorSuccess': 'Major sürüm oluşturuldu',
  'eduflow.versionHistory.createMinor': 'Minor sürüm',
  'eduflow.versionHistory.createMinorSuccess': 'Minor sürüm oluşturuldu',
  'eduflow.versionHistory.deleteError': 'Hata siliniyor sürüm',
  'eduflow.versionHistory.deleteSuccess': 'Sürüm silindi',
  'eduflow.versionHistory.deleteTitle': 'Sil {{etiket}}?',
  'eduflow.versionHistory.deleteWarning': 'Bu eylem is irreversible.',
  'eduflow.versionHistory.duplicateConfirm': 'Çoğalt',
  'eduflow.versionHistory.duplicateError': 'Hata duplicating sürüm',
  'eduflow.versionHistory.duplicateMinor': 'Çoğalt (minor)',
  'eduflow.versionHistory.duplicateSuccess': 'Sürüm dupliquée — contenu restauré dans l’éditeur',
  'eduflow.versionHistory.duplicateTitle': 'Çoğalt {{etiket}}?',
  'eduflow.versionHistory.newFromCurrent': 'Yeni sürüm from mevcut içerik',
  'eduflow.versionHistory.preview': 'Önizleme',
  'eduflow.versionHistory.previewBlocks': '{{count}} bloklar',
  'eduflow.versionHistory.previewEdges': '{{count}} connections',
  'eduflow.versionHistory.previewError': 'Impossible de charger l’aperçu',
  'eduflow.versionHistory.previewTitle': 'Önizleme {{etiket}}',
  'eduflow.versionHistory.setPublic': 'Activate',
  'eduflow.versionHistory.startDescModalTitle': 'birçıklama — Başlangıç blok ({{sürüm}})',
  'eduflow.videoCompleted': 'Video watched',
  'gamification.active': 'actives',
  'gamification.badges': 'Badges',
  'gamification.bestStreak': 'Meilleur streak',
  'gamification.claim': 'Récupérer',
  'gamification.completed': 'Terminées',
  'gamification.days': 'jours',
  'gamification.leaderboard': 'Classement',
  'gamification.level': 'Niv.',
  'gamification.maxLevel': '✨ Niveau max atteint !',
  'gamification.missions': 'Missions',
  'gamification.name': 'Nom',
  'gamification.streakActive': 'Streak en cours 🔥',
  'gamification.streakInactive': 'Pas de streak actif',
  'gamification.xpRemaining': '${formatXp(xpForNextLevel - currentXp)} XP restants',
  'header.language': 'Dil',
  'institution.categories.color': 'Couleur',
  'institution.categories.coverLabel': 'Görsel de couverture',
  'institution.categories.coverUploadError': 'Échec du téléversement de la couverture.',
  'institution.categories.removeCover': 'Retirer l’görsel',
  'institution.categories.descShortPh': 'Décrivez l’usage de la catégorie',
  'institution.categories.edit': 'Modifier la catégorie',
  'institution.categories.episodes': 'épisode(s)',
  'institution.categories.learners': 'apprenant(s)',
  'institution.categories.namePlaceholder': 'Nom de la catégorie',
  'institution.categories.new': 'Nouvelle catégorie',
  'institution.categories.preview': 'Aperçu',
  'institution.categories.previewApiModeOff': 'Prévisualisation indisponible (mode local).',
  'institution.categories.previewDesc': 'Podcastler et parcours reliés à cette catégorie.',
  'institution.categories.previewError': 'Erreur lors du chargement de l’aperçu.',
  'institution.categories.previewFormations': 'Parcours / formations',
  'institution.categories.previewLoading': 'Chargement de l’aperçu…',
  'institution.categories.previewNoFlows': 'Aucune formation rattachée à cette catégorie.',
  'institution.categories.previewNoPodcasts': 'Aucun podcast rattaché à cette catégorie.',
  'institution.categories.previewPodcasts': 'Podcastler',
  'institution.categories.saveError': 'Erreur lors de la sauvegarde.',
  'institution.categories.subscribers': 'abonné(s)',
  'institution.categories.usageItems': 'élément(s)',
  'institution.common.add': 'Ajouter',
  'institution.common.cancel': 'Annuler',
  'institution.common.close': 'Fermer',
  'institution.common.delete': 'Supprimer',
  'institution.common.description': 'Açıklama',
  'institution.common.email': 'E-posta',
  'institution.common.loading': 'Chargement…',
  'institution.common.name': 'Nom',
  'institution.common.refresh': 'Actualiser',
  'institution.common.required': 'Requis',
  'institution.common.retry': 'Réessayer',
  'institution.common.save': 'Enregistré',
  'institution.contentPipeline.confirmDeletePath': 'Supprimer ce parcours ?',
  'institution.contentPipeline.createPath': 'Créer le parcours',
  'institution.contentPipeline.createPodcast': 'Créer le podcast',
  'institution.contentPipeline.createShell': 'Créer la fiche',
  'institution.contentPipeline.descPh': 'birçıklama / objectifs',
  'institution.contentPipeline.newPath': 'Nouveau parcours',
  'institution.contentPipeline.newPodcastShell': 'Pré-créer un podcast',
  'institution.contentPipeline.newShell': 'Nouvelle fiche formation',
  'institution.contentPipeline.openDesigner': 'Ouvrir dans le designer',
  'institution.contentPipeline.openStudio': 'Épisodes',
  'institution.contentPipeline.pathDescLabel': 'Açıklama',
  'institution.contentPipeline.pathPlannedLaunch': 'Tarih cible de lancement',
  'institution.contentPipeline.pathTitlePh': 'Titre du parcours',
  'institution.contentPipeline.pickProducer': 'Assigner producteur…',
  'institution.contentPipeline.pickTeacher': 'Assigner…',
  'institution.contentPipeline.plannedDeadline': 'Échéance',
  'institution.contentPipeline.plannedStart': 'Déama prévu',
  'institution.contentPipeline.planningColumn': 'Planning création',
  'institution.contentPipeline.planningOptional': 'Planning de création (optionnel)',
  'institution.contentPipeline.podDescPh': 'Brief / birçıklama pour le formateur',
  'institution.contentPipeline.savePlanning': 'Enregistrer le planning',
  'institution.contentPipeline.statFormations': 'Fiches catalogue',
  'institution.contentPipeline.statPaths': 'Parcours certifiants',
  'institution.contentPipeline.statPodcasts': 'Podcastler',
  'institution.contentPipeline.tabFormations': 'Fiches formations',
  'institution.contentPipeline.tabPaths': 'Parcours',
  'institution.contentPipeline.tabPodcasts': 'Podcastler',
  'institution.contentPipeline.title': 'Préparation du contenu',
  'institution.contentPipeline.titlePh': 'Titre',
  'institution.learnerAnalytics.chartActivity': 'Activité et complétions (8 dernières semaines)',
  'institution.learnerAnalytics.chartProgress': 'Progression globale (par apprenant)',
  'institution.learnerAnalytics.chartStatus': 'Répartition par statut',
  'institution.learnerAnalytics.chartTopFlows': 'Formations les plus suivies',
  'institution.learnerAnalytics.colDone': 'Terminé',
  'institution.learnerAnalytics.colFlow': 'Formation',
  'institution.learnerAnalytics.colLastAccess': 'Dernier accès',
  'institution.learnerAnalytics.colName': 'Apprenant',
  'institution.learnerAnalytics.colTime': 'Temps',
  'institution.learnerAnalytics.count': 'Effectif',
  'institution.learnerAnalytics.done': 'Terminés',
  'institution.learnerAnalytics.enrolled': 'Inscrits',
  'institution.learnerAnalytics.kpiEnrollments': 'Inscriptions',
  'institution.learnerAnalytics.kpiLearners': 'Apprenants',
  'institution.learnerAnalytics.kpiLearnersSub': 'Katılımcılar enregistrés',
  'institution.learnerAnalytics.kpiRate': 'Taux de complétion',
  'institution.learnerAnalytics.kpiRateSub': 'Sur l’ensemble des inscriptions',
  'institution.learnerAnalytics.kpiTime': 'Temps cumulé',
  'institution.learnerAnalytics.kpiTimeSub': 'Temps geçé sur les parcours',
  'institution.learnerAnalytics.loadError': 'Impossible de charger les analyses.',
  'institution.learnerAnalytics.noData': 'Pas encore de données.',
  'institution.learnerAnalytics.seriesActivity': 'Accès (inscriptions)',
  'institution.learnerAnalytics.seriesCompletions': 'Complétions',
  'institution.learnerAnalytics.tableEmpty': 'Aucune ligne à afficher.',
  'institution.learnerAnalytics.tableSearch': 'Rechercher nom, e-posta, formation…',
  'institution.learnerAnalytics.tableTitle': 'Détail des inscriptions',
  'institution.learnerAnalytics.tableTruncated': 'Affichage limité à 500 lignes — utilisez l’dışbir aktar pour la liste complète.',
  'institution.learnerAnalytics.title': 'Analyse & suivi des apprenants',
  'institution.learnerAnalytics.xapiDataSourceTitle': 'Source des données & xAPI',
  'institution.learners.flowDone': 'Terminé',
  'institution.learners.inProgress': 'En cours',
  'institution.menuBlocked.title': 'Fonctionnalité non disponible',
  'institution.rhModule.pickFromMenu': 'Choisissez un outil dans le menü Formation & RH.',
  'institution.sirh.apiKey': 'Clé API',
  'institution.sirh.apiKeyStored': 'déjà enregistrée — laissez vide pour ne pas changer',
  'institution.sirh.apiSecret': 'Secret / saniye jeton (optionnel)',
  'institution.sirh.apiSecretHint': 'Envoyé en en-tête X-API-Secret si renseigné.',
  'institution.sirh.baseUrl': 'URL de base de l’API',
  'institution.sirh.baseUrlHint': 'Lyrra appellera Al {URL}/employees avec Authorization: Bearer &lt;clé API&gt;.',
  'institution.sirh.enabled': 'Synchronisation activée',
  'institution.sirh.formatTitle': 'Format attendu pour Al /employees',
  'institution.sirh.loadError': 'Impossible de charger la yapılandırma SIRH.',
  'institution.sirh.mappingJob': 'Poste / fonction (jobTitle ou ex. position)',
  'institution.sirh.mappingTitle': 'Correspondance des champs (JSON SIRH)',
  'institution.sirh.name': 'Libellé interne',
  'institution.sirh.saveError': 'Enregistrement impossible.',
  'institution.sirh.saved': 'Yapılandırma enregistrée.',
  'institution.sirh.secretStored': 'déjà enregistré',
  'institution.sirh.syncDone': 'Synchronisation : ${s.oluşturuldu} créés, ${s.güncellendi} mis à jour, ${s.hatalar} erreurs, ${s.atlandı} ignorés (autre établissement).',
  'institution.sirh.syncError': 'Synchronisation impossible.',
  'institution.sirh.syncNow': 'Synchroniser les collaborateurs',
  'institution.sirh.syncOk': 'Synchronisation terminée.',
  'institution.sirh.test': 'Tester la connexion',
  'institution.sirh.testError': 'Test impossible.',
  'institution.sirh.title': 'SIRH — connexion API',
  'institution.sirh.type': 'Tür / famille',
  'institution.sirh.typeCustom': 'API HTTP personnalisée',
  'institution.ssoOidc.autoProvision': 'Créer automatiquement les comptes à la première connexion (si pris en charge)',
  'institution.ssoOidc.clientId': 'Client ID',
  'institution.ssoOidc.clientSecret': 'Client secret',
  'institution.ssoOidc.copied': 'Copié',
  'institution.ssoOidc.copy': 'Copier',
  'institution.ssoOidc.copyError': 'Copie impossible.',
  'institution.ssoOidc.defaultRole': 'Rôle par défaut (provisionnement)',
  'institution.ssoOidc.enableSsoGeneric': 'Activer le SSO pour cet établissement',
  'institution.ssoOidc.flagsError': 'Mise à jour des seçenekler impossible.',
  'institution.ssoOidc.flagsSuccess': 'Seçenekler SSO mises à jour.',
  'institution.ssoOidc.formTitle': 'Identifiants OpenID Connect',
  'institution.ssoOidc.issuer': 'Issuer (URL)',
  'institution.ssoOidc.loadError': 'Impossible de charger la yapılandırma SSO.',
  'institution.ssoOidc.optionsTitle': 'Activation et provisionnement',
  'institution.ssoOidc.pageTitle': 'SSO — OpenID Connect & SAML 2.0',
  'institution.ssoOidc.redirectTitle': 'URL de redirection (callback)',
  'institution.ssoOidc.saveCredentials': 'Enregistrer les identifiants',
  'institution.ssoOidc.saveError': 'Enregistrement impossible.',
  'institution.ssoOidc.saveOptions': 'Enregistrer les seçenekler',
  'institution.ssoOidc.saveSuccess': 'Yapılandırma OpenID Connect enregistrée.',
  'institution.ssoOidc.scopes': 'Scopes (séparés par un espace)',
  'institution.ssoOidc.secretOptional': 'laisser vide pour conserver l’actuel',
  'institution.ssoOidc.secretRequired': 'Indiquez le secret client (première yapılandırma).',
  'institution.ssoOidc.tablistAria': 'Protocole SSO',
  'institution.ssoSaml.acsTitle': 'URL Assertion Consumer Service (ACS)',
  'institution.ssoSaml.certOptional': 'laisser vide pour conserver l’actuel',
  'institution.ssoSaml.certificate': 'Certificat de signature IdP (PEM)',
  'institution.ssoSaml.copied': 'Copié',
  'institution.ssoSaml.copy': 'Copier',
  'institution.ssoSaml.copyError': 'Copie impossible.',
  'institution.ssoSaml.downloadError': 'Téléchargement des métadonnées SP impossible.',
  'institution.ssoSaml.downloadSp': 'Métadonnées SP (XML)',
  'institution.ssoSaml.entityId': 'Entity ID (Issuer IdP)',
  'institution.ssoSaml.manualTitle': 'Paramètres IdP (manuel)',
  'institution.ssoSaml.metadataEmpty': 'Collez le XML des métadonnées IdP.',
  'institution.ssoSaml.metadataError': 'Içe aktar des métadonnées impossible.',
  'institution.ssoSaml.metadataFormTitle': 'Importer les métadonnées IdP (XML)',
  'institution.ssoSaml.metadataStored': 'Un fichier de métadonnées IdP est déjà stocké.',
  'institution.ssoSaml.metadataSuccess': 'Métadonnées SAML IdP enregistrées.',
  'institution.ssoSaml.metadataUrl': 'URL des métadonnées IdP (optionnel)',
  'institution.ssoSaml.saveError': 'Enregistrement SAML impossible.',
  'institution.ssoSaml.saveManual': 'Enregistrer la yapılandırma SAML',
  'institution.ssoSaml.saveSuccess': 'Yapılandırma SAML enregistrée.',
  'institution.ssoSaml.sloUrl': 'URL de déconnexion SLO (optionnel)',
  'institution.ssoSaml.ssoUrl': 'URL de connexion SSO (IdP)',
  'institution.ssoSaml.uploadMetadata': 'Enregistrer le XML IdP',
  'institution.templates.blockType': 'Tür de bloc',
  'institution.templates.create': 'Créer un modèle',
  'institution.templates.createDrawerTitle': 'Créer un modèle de bloc',
  'institution.templates.createNameRequired': 'Veuillez renseigner le titre du modèle.',
  'institution.templates.editDrawerTitle': 'Modifier le modèle',
  'institution.templates.modelDescPh': 'birçıklama du modèle',
  'institution.templates.modelNamePh': 'Titre du modèle',
  'institution.templates.previewDrawerTitle': 'Aperçu du modèle',
  'institution.templates.publish': 'Publier',
  'institution.templates.published': 'Publié',
  'institution.templates.typeConfig': 'Yapılandırma du bloc',
  'institution.templates.unpublish': 'Dépublier',
  'institution.xapi.accessToken': 'Jeton d’accès (Bearer)',
  'institution.xapi.actorField': 'Champ acteur (référence)',
  'institution.xapi.authBasic': 'HTTP Temel (utilisateur / mot de passe)',
  'institution.xapi.authBearer': 'Bearer / jeton OAuth',
  'institution.xapi.authType': 'Authentification LRS',
  'institution.xapi.enable': 'Activer l’envoi des statements vers le LRS',
  'institution.xapi.formTitle': 'Paramètres LRS',
  'institution.xapi.loadError': 'Impossible de charger la yapılandırma xAPI.',
  'institution.xapi.loadStatements': 'Afficher 15 statements (JSON)',
  'institution.xapi.lrsReadTitle': 'Lecture distante (diagnostic)',
  'institution.xapi.lrsUrl': 'URL de base du LRS',
  'institution.xapi.optionalKeep': 'optionnel pour conserver l’actuel',
  'institution.xapi.password': 'Mot de passe / secret',
  'institution.xapi.payloadOptions': 'Données incluses dans les statements (parcours)',
  'institution.xapi.profile': 'Profil / usage',
  'institution.xapi.save': 'Enregistrer',
  'institution.xapi.saveError': 'Enregistrement impossible.',
  'institution.xapi.saveSuccess': 'Yapılandırma xAPI enregistrée.',
  'institution.xapi.sendCompletion': 'Envoyer complétion',
  'institution.xapi.sendDuration': 'Envoyer durée',
  'institution.xapi.sendScore': 'Envoyer puan',
  'institution.xapi.statementsError': 'Impossible de charger les statements.',
  'institution.xapi.sync': 'Lire un lot (aperçu)',
  'institution.xapi.syncError': 'Lecture LRS impossible.',
  'institution.xapi.test': 'Tester le LRS',
  'institution.xapi.testError': 'Test impossible.',
  'institution.xapi.testFail': 'Test LRS échoué.',
  'institution.xapi.testOk': 'LRS joignable.',
  'institution.xapi.title': 'xAPI — Öğrenme Kaydet Store (LRS)',
  'institution.xapi.username': 'Utilisateur (Temel Auth)',
  'loading.label': 'Yükleniyor…',
  'manager.dashboard.loadError': 'Chargement impossible.',
  'manager.dashboard.noReports': 'Aucun collaborateur rattaché comme yönetici dans le SIRH.',
  'manager.dashboard.pendingCount': 'en attente',
  'manager.dashboard.pendingWorkflowHint': 'Les workflows visibles sont ceux dont vous êtes le demandeur.',
  'manager.dashboard.pendingWorkflowTitle': 'Demandes en circuit',
  'manager.dashboard.title': 'Tableau de bord Yönetici',
  'manager.dashboard.workflowBox': 'Doğrulama',
  'manager.kpi.activeTrainings': 'Formations actives',
  'manager.kpi.completionRate': 'Taux de complétion',
  'manager.kpi.pendingWorkflow': 'Workflows en attente',
  'manager.nav.requests': 'Demandes de formation',
  'manager.nav.reviews': 'Évaluations',
  'manager.requests.commentPlaceholder': 'Ajouter un commentaire…',
  'manager.requests.empty': 'Aucune demande pour ce filtre.',
  'manager.requests.title': 'Demandes de formation',
  'manager.reviews.commentPlaceholder': 'Commentaire sur cette compétence…',
  'manager.reviews.lastAssessment': 'Dernière éval.',
  'manager.reviews.selectMember': 'Sélectionnez un collaborateur pour évaluer',
  'manager.reviews.submitted': 'Évaluation soumise',
  'manager.reviews.target': 'Cible',
  'manager.reviews.title': 'Évaluations de compétences',
  'manager.team.loadError': 'Chargement impossible.',
  'notifications.empty': 'Hayır bildirimler yet',
  'notifications.label': 'Bildirimler',
  'notifications.markAllRead': 'Mark tümü oku',
  'notifications.markRead': 'Mark as oku',
  'notifications.title': 'Bildirimler',
  'notifications.viewAll': 'Görüntüle tümü bildirimler',
  'pages.branding.comingSoonDesc': 'Configurez les couleurs, logos et la charte graphique de votre espace de formation.',
  'pages.branding.title': 'Identité visuelle',
  'pages.budget.comingSoonDesc': 'Planifiez et suivez votre budget de formation, gérez les enveloppes et les dépenses par département.',
  'pages.budget.description': 'Gestion du budget de formation',
  'pages.budget.title': 'Bütçe',
  'pages.campaigns.description': 'Gestion des campagnes de formation',
  'pages.campaigns.title': 'Campagnes',
  'pages.catalog.comingSoonDesc': 'Parcourez le catalogue de formations disponibles, recherchez par compétence et inscrivez-vous aux oturumlar.',
  'pages.catalog.description': 'Catalogue des formations',
  'pages.catalog.title': 'Catalogue',
  'pages.certificates.comingSoonDesc': 'Consultez et téléchargez vos certificats de formation, attestations et badges obtenus.',
  'pages.certificates.description': 'Vos certifications et attestations',
  'pages.certificates.title': 'Certificats',
  'pages.competencies.comingSoonDesc': 'Gérez votre référentiel de compétences, cartographiez les savoir-faire et identifiez les besoins en formation.',
  'pages.competencies.description': 'Référentiel de compétences',
  'pages.competencies.title': 'Compétences',
  'pages.compliance.comingSoonDesc': 'Suivez les formations obligatoires, les certifications et la conformité réglementaire de votre organisation.',
  'pages.compliance.description': 'Suivi de la conformité réglementaire',
  'pages.compliance.title': 'Conformité',
  'pages.integrations.comingSoonDesc': 'Connectez votre plateforme à vos outils RH, SIRH, LMS et autres services pour synchroniser vos données.',
  'pages.integrations.description': 'Connexions aux services externes',
  'pages.integrations.title': 'Intégrations',
  'pages.learners.statsAdaptiveChoice': 'Choix assistes - acceptes: {{kabul edildi}} · refuses: {{reddedildi}}',
  'pages.learners.statsAdaptiveEvaluated': 'Adaptations evaluees: {{count}}',
  'pages.learners.statsAdaptiveReplaced': 'Versions simplifiees utilisees: {{count}}',
  'pages.reports.comingSoonDesc': 'Générez des rapports détaillés sur les activités de formation, les budgets et les indicateurs de performans.',
  'pages.reports.description': 'Rapports et bilans de formation',
  'pages.reports.title': 'Rapports',
  'pages.requests.description': 'Gestion des demandes de formation',
  'pages.requests.title': 'Demandes',
  'pages.reviews.comingSoonDesc': 'Gérez les entretiens annuels, les évaluations de compétences et le suivi de progression de votre équipe.',
  'pages.reviews.description': 'Entretiens et évaluations',
  'pages.reviews.title': 'Évaluations',
  'pages.settings.description': 'Yapılandırma de votre compte et préférences',
  'pages.settings.title': 'Paramètres',
  'pages.skills.description': 'Votre profil de compétences',
  'pages.skills.title': 'Mes compétences',
  'pages.team.comingSoonDesc': 'Visualisez votre équipe, suivez les compétences et les formations de chaque collaborateur.',
  'pages.team.description': 'Gestion de votre équipe',
  'pages.team.title': 'Mon équipe',
  'pages.training.comingSoonDesc': 'Accédez à vos formations en cours, suivez votre progression et reprenez là où vous vous êtes arrêté.',
  'pages.training.description': 'Vos parcours de formation en cours',
  'pages.training.title': 'Mes formations',
  'pages.webhooks.comingSoonDesc': 'Configurez des webhooks pour connecter votre plateforme à des services externes et automatiser vos flux.',
  'pages.webhooks.description': 'Yapılandırma des webhooks et intégrations',
  'pages.webhooks.title': 'Web Kancaları',
  'player.adaptiveGame.done': 'Objectif valide en mode simplifie',
  'player.adaptiveGame.next': 'Etape suivante',
  'player.adaptiveGame.step': 'Etape {{index}} / {{toplam}}',
  'player.adaptiveGame.subtitle': 'Une alternative plus erişilebilir pour valider cet objectif.',
  'player.adaptiveGame.title': 'Sürüm simplifiee interactive',
  'player.adaptiveGame.validate': 'Valider',
  'player.adaptivePrompt.keepOriginal': 'Garder le bloc standard',
  'player.adaptivePrompt.subtitle': 'Souhaitez-vous utiliser une sürüm interactive plus erişilebilir ?',
  'player.adaptivePrompt.title': 'Sürüm simplifiee disponible pour ce bloc',
  'player.adaptivePrompt.useSimplified': 'Utiliser la sürüm simplifiee',
  'player.descriptionTeleprompter': 'Mode téléprompteur',
  'player.descriptionTeleprompterOff': 'Afficher le bloc',
  'player.descriptionVoiceover': 'Voix off — birçıklama du bloc',
  'player.subflow.blockTitle': 'Sous-formation',
  'player.subflow.defaultTitle': 'Sous-formation',
  'player.subflow.loadError': 'La sous-formation n’bir pas pu être chargée.',
  'player.subflow.loading': 'Chargement…',
  'player.subflow.missingId': 'Aucune sous-formation n’est liée à ce bloc.',
  'player.subflow.noContext': 'Impossible de charger la sous-formation (contexte lecteur manquant).',
  'player.subflow.start': 'Commencer la sous-formation',
  'player.teleprompterNextParagraph': 'Paragraphe suivant',
  'player.teleprompterPrevParagraph': 'Paragraphe précédent',
  'podcast.episodes.chapters': 'Chapitres',
  'podcast.episodes.hideText': 'Masquer le texte',
  'podcast.episodes.noChapters': 'Aucun chapitre disponible.',
  'podcast.episodes.previewEpisodeTitle': 'Épisode',
  'podcast.episodes.showText': 'Afficher le texte',
  'qualiopi.actions': 'Eylemler',
  'qualiopi.completion': 'Conformité',
  'qualiopi.evidence': 'Belgeler justificatifs',
  'qualiopi.noDocuments': 'Aucun belge',
  'qualiopi.notes': 'Notlar',
  'qualiopi.notesPlaceholder': 'Ajouter une değil…',
  'quickActions.hint': 'Bas',
  'quickActions.hintToggle': 'to toggle',
  'quickActions.title': 'Quick Eylemler',
  'rh.achievements': 'Achievements',
  'rh.addComment': 'Ekle bir yorum...',
  'rh.addCompetency': 'Ekle Competency',
  'rh.afterApproval': 'Sonra Approval',
  'rh.alert.forecast': 'Prévision fin d’année',
  'rh.alert.workflow': 'Workflows',
  'rh.all': 'Tümü',
  'rh.allCompetencies': 'Tümü Competencies',
  'rh.allDepartments': 'Tümü Departments',
  'rh.allocated': 'Alloué',
  'rh.approvalHistory': 'Approval History',
  'rh.approve': 'Approve',
  'rh.approveConfirm': 'Are you sure you iste to approve bu eğitim istek?',
  'rh.approveRequest': 'Approve Istek',
  'rh.approveSelected': 'Approve',
  'rh.approved': 'Onaylandı',
  'rh.auditOverdue': 'Audit gecikmiş',
  'rh.avgGap': 'Avg Gap Boyut',
  'rh.avgLevel': 'Avg Seviye',
  'rh.avgOverall': 'Avg Overall',
  'rh.budget.subtitle': 'Suivi budgétaire et ROI',
  'rh.budget.title': 'Budget formation',
  'rh.budgetAlerts': 'Alertes',
  'rh.budgetDashboard': 'Budget formation',
  'rh.budgetLoadError': 'Impossible de charger le budget.',
  'rh.budgetRemaining': 'Budget Remaining',
  'rh.byDepartment': 'Budget par direction',
  'rh.competencies': 'competencies',
  'rh.competencyMap': 'Competency Heatmap',
  'rh.competencyRadar': 'Competency Radar',
  'rh.completion': 'Tamamlanma',
  'rh.complianceCritical': 'Critical: Several criteria are altında acceptable thresholds.',
  'rh.complianceGood': 'Sizin kuruluş meets Qualiopi standards. Tut up the good çalış.',
  'rh.complianceWarning': 'Bazı criteria gerek attention önce the sonraki audit.',
  'rh.compliant': 'compliant',
  'rh.confirm': 'Onayla Approval',
  'rh.confirmReject': 'Onayla Rejection',
  'rh.consumed': 'Consommé',
  'rh.costInfo': 'Cost Bilgi',
  'rh.critical': 'critical',
  'rh.criticalGaps': 'Critical (Yüksek)',
  'rh.current': 'Mevcut',
  'rh.currentLevel': 'Mevcut Seviye',
  'rh.date': 'Tarih',
  'rh.daysRemaining': 'gün remaining',
  'rh.department': 'Bölüm',
  'rh.departmentBreakdown': 'Détail par direction',
  'rh.departments': 'departments',
  'rh.description': 'Açıklama',
  'rh.edit': 'Düzenle',
  'rh.employee': 'Çalışan',
  'rh.employeeInfo': 'Employee Bilgi',
  'rh.evolution': 'Evolution',
  'rh.evolutionTimeline': 'Evolution Timeline',
  'rh.exportReport': 'Exporter',
  'rh.gapAnalysis': 'Gap Analysis',
  'rh.growth': 'Growth bu yıl',
  'rh.lastUpdated': 'Son güncellendi',
  'rh.level': 'Seviye',
  'rh.manager': 'Yönetici',
  'rh.needsWork': 'needs çalış',
  'rh.nextAudit': 'Sonraki Audit',
  'rh.noAlerts': 'Aucune alerte.',
  'rh.noAllocations': 'Aucune ligne budgétaire pour cette année.',
  'rh.noDeptData': 'Aucune donnée',
  'rh.noGaps': 'Hayır gaps bulundu için bu filtrele.',
  'rh.of': 'of',
  'rh.ofTotal': 'du toplam',
  'rh.overallCompliance': 'Overall Uyumluluk Puan',
  'rh.pending': 'Beklemede',
  'rh.provider': 'Provider',
  'rh.qualiopiCompliance': 'Qualiopi Uyumluluk',
  'rh.radar': 'Radar',
  'rh.reject': 'Reddet',
  'rh.rejectConfirm': 'Are you sure you iste to reddet bu eğitim istek?',
  'rh.rejectRequest': 'Reddet Istek',
  'rh.rejectSelected': 'Reddet',
  'rh.rejected': 'Reddedildi',
  'rh.remaining': 'Restant',
  'rh.requestInfo': 'Istek Bilgi',
  'rh.requests.subtitle': 'Workflows de demandes et validations',
  'rh.requests.title': 'Demandes de formation',
  'rh.required': 'Zorunlu',
  'rh.rh': 'RH',
  'rh.saveAssessment': 'Kaydet Değerlendirme',
  'rh.searchCompetencies': 'Ara competencies…',
  'rh.selfAssess': 'Self',
  'rh.showing': 'Showing',
  'rh.skillsSelfAssessment': 'Beceriler & Self-Değerlendirme',
  'rh.spending': 'Dépenses',
  'rh.spendingTimeline': 'Dépenses par année',
  'rh.status': 'Durum',
  'rh.targetLevel': 'Hedef Seviye',
  'rh.totalBudget': 'Budget toplam',
  'rh.totalGaps': 'Toplam Gaps',
  'rh.training': 'Eğitim',
  'rh.trainingCost': 'Eğitim Cost',
  'rh.trainingRequests': 'Eğitim Istekler',
  'search.close': 'to kapat',
  'search.input': 'Ara input',
  'search.navigate': 'to navigate',
  'search.placeholder': 'Ara sayfalar, projeler, flows...',
  'search.recent': 'Son',
  'search.select': 'to seç',
  'search.title': 'Ara',
  'status.completed': 'Terminé',
  'status.inProgress': 'En cours',
  'status.notStarted': 'Non commencé',
  'store.noResults': 'Aucun résultat trouvé',
  'store.search': 'Rechercher...',
  'store.subtitle': 'Découvrez des formations, şablonlar et ressources créés par la communauté',
  'store.title': 'Mağaza',
  'webinar.room.closeParticipantCamerasView': 'Fermer',
  'webinar.room.hideParticipantCameras': 'Fermer la vue caméras',
  'webinar.room.participantCamerasViewTitle': 'Caméras des katılımcılar',
  'webinar.room.showParticipantCameras': 'Voir les caméras des katılımcılar',
  'designer.ctx.addBlock': 'Ajouter un bloc',
  'designer.ctx.blockInfo': 'Bilgi du bloc',
  'designer.ctx.changeColor': 'Changer la couleur',
  'designer.ctx.copy': 'Copier',
  'designer.ctx.delete': 'Supprimer',
  'designer.ctx.duplicate': 'Dupliquer',
  'designer.ctx.edit': 'Modifier',
  'designer.ctx.fitView': 'Ajuster la vue',
  'designer.ctx.lock': 'Verrouiller',
  'designer.ctx.paste': 'Coller',
  'designer.ctx.toggleGrid': 'Grille ON/OFF',
  'designer.ctx.toggleMinimap': 'Minimap ON/OFF',
  'designer.ctx.unlock': 'Déverrouiller',
  'designer.edge.cancel': 'Annuler',
  'designer.edge.color': 'Couleur',
  'designer.edge.name': 'Nom',
  'designer.edge.namePlaceholder': 'ex. Réussi, Branche bir…',
  'designer.edge.save': 'Enregistrer',
  'designer.edge.title': 'Connexion',
  'designer.gamification.badgeName': 'Nom du rozet',
  'designer.gamification.badges': 'Badges',
  'designer.gamification.blocksGte': 'Blocs ≥',
  'designer.gamification.bonusPerfect': 'Bonus puan parfait (sınav)',
  'designer.gamification.condition': 'Koşul',
  'designer.gamification.conditionPlaceholder': 'ex: quiz_completed >= 3',
  'designer.gamification.description': 'Açıklama',
  'designer.gamification.enable': 'Activer la gamification',
  'designer.gamification.enableLeaderboard': 'Activer le classement',
  'designer.gamification.icon': 'Icône',
  'designer.gamification.leaderboard': 'Classement',
  'designer.gamification.missionDesc': 'birçıklama (ex: Terminer 3 sınav)',
  'designer.gamification.missionTitle': 'Titre de la görev',
  'designer.gamification.missions': 'Missions',
  'designer.gamification.noBadges': 'Aucun rozet défini',
  'designer.gamification.noMissions': 'Aucune görev définie',
  'designer.gamification.points': 'Puanlar',
  'designer.gamification.pointsPerBlock': 'Puanlar par bloc complété',
  'designer.gamification.pointsPerSecond': 'Puanlar par seconde gagnée',
  'designer.gamification.publicLeaderboard': 'Classement genel',
  'designer.gamification.reward': 'Récompense',
  'designer.gamification.scoreGte': 'Puan ≥',
  'designer.gamification.timeBonus': 'Bonus de rapidité',
  'designer.gamification.title': 'Gamification',
  'designer.gamification.topN': 'Afficher le üst N',
  'designer.objectives.add': 'Ajouter',
  'designer.objectives.addTitle': 'Ajouter un objectif',
  'designer.objectives.cancel': 'Annuler',
  'designer.objectives.category': 'Catégorie',
  'designer.objectives.completed': 'Complété',
  'designer.objectives.empty': 'Aucun objectif défini.',
  'designer.objectives.emptyHint': 'Ajoutez vos premiers objectifs pédagogiques.',
  'designer.objectives.errorToast': 'Erreur lors de la sauvegarde',
  'designer.objectives.level': 'Niveau (Bloom)',
  'designer.objectives.linkedBlocks': 'Blocs liés',
  'designer.objectives.noContentBlocks': 'Aucun bloc de contenu disponible.',
  'designer.objectives.required': 'Obligatoire',
  'designer.objectives.save': 'Sauvegarder',
  'designer.objectives.savedToast': 'Objectifs sauvegardés',
  'designer.objectives.scoreGte': 'Puan ≥',
  'designer.objectives.title': 'Objectifs pédagogiques',
  'designer.objectives.update': 'Mettre à jour',
  'designer.validation.circularPath': 'Döngüsel yol algılandı',
  'designer.validation.duplicateStart': 'Bloc Départ en doublon',
  'designer.validation.invalid': 'Invalide',
  'designer.validation.noEnd': 'Aucun bloc Fin trouvé. Il doit y en avoir au moins 1.',
  'designer.validation.noIssues': 'Aucun problème détecté',
  'designer.validation.noStart': 'Il doit y avoir exactement un bloc Départ (aucun trouvé).',
  'designer.validation.title': 'Doğrulama',
  'designer.validation.untitled': 'Sans titre',
  'designer.validation.valid': 'Valide',
  'designer.validation.errorCount': '{{count}} hata(s)',
  'designer.validation.warningCount': '{{count}} uyarı(s)',
  'designer.validation.titleRequired': 'The « {{tür}} » blok gerekir have bir başlık.',
  'designer.validation.summary': 'Flow: {{bloklar}} blok(s), {{edges}} connection(s).',
  'designer.validation.multipleStart': 'Multiple Başlangıç bloklar ({{count}}): sadece one is allowed.',
  'designer.validation.noOutgoing': 'The « {{tür}} » blok has hayır outgoing connection to bir sonraki blok.',
  'designer.validation.tooManyOutputs': '« {{etiket}} »: çok birçok outgoing connections ({{count}}, maximum {{max}}).',
  'designer.validation.deadEndBranch': 'Branch ile hayır yol to bir Son blok (from « {{etiket}} »).',
  'designer.validation.moreDeadEnds': '… ve {{count}} daha fazla branch(es) ile hayır yol to the son.',
  'designer.validation.noConvergence': 'Branches from « {{etiket}} » do değil converge to bir common blok.',
  'designer.validation.orphanBlock': 'Blok isolated from the main graph: « {{başlık}} ».',
  'designer.validation.endHasOutgoing': 'The Son blok « {{başlık}} » hâlâ has bir outgoing connection.',
  'designer.validation.noScoring': 'Scoring ayarlar değil defined için « {{başlık}} ».',
  'designer.validation.emptyText': 'The text blok « {{başlık}} » is boş.',
  'designer.validation.textTooLong':
    'Metin bloğu « {{title}} » yaklaşık {{lines}} satır. Önerilen: {{min}} ile {{max}} satır.',
  'designer.validation.splitTextBlock': 'Böl',
  'designer.validation.textSplitNotNeeded':
    'Bu blok önerilen okuma eşiğini aşmıyor.',
  'designer.validation.textSplitUnable':
    'Bu blok için güvenilir otomatik bölme önerilemedi.',
  'designer.validation.textSplitComplexFlow':
    'Bu blok için otomatik bölme kullanılamıyor (çoklu/koşullu dallar).',
  'designer.validation.textSplitDone': '{{count}} metin bloğu oluşturuldu',
  'designer.validation.textSplitConfirmTitle':
    'Bu metin bloğu otomatik bölünsün mü?',
  'designer.validation.textSplitConfirmMessage':
    '« {{title}} » bloğu yaklaşık {{lines}} satır. Noktalama işaretlerine göre {{parts}} bloğa bölünecek ve hemen aşağıya doğru sırayla yerleştirilecektir.',
  'designer.validation.textSplitConfirmAction': 'Bloğu böl',
  'designer.validation.formFieldRefsMissing': '« {{başlık}} »: reference(s) to missing form field(s): {{refs}}.',
  'designer.validation.formFieldRefsOrder': '« {{başlık}} »: geçersiz form field variable(s) {{refs}} — the form blok gerekir be reached önce bu blok in the flow.',
  'designer.confirmDeleteForm.title': 'Sil bu form blok?',
  'designer.confirmDeleteForm.message': 'Diğer bloklar may reference its fields as /fieldId/. Those references will break. You can undo ile ⌘Z veya Ctrl+Z.',
  'designer.confirmDeleteForm.batchTitle': 'Sil seçim?',
  'designer.confirmDeleteForm.batchMessage': 'The seçim includes at least one form blok. Slash references elsewhere may break. You can undo ile ⌘Z veya Ctrl+Z.',
  'designer.variables.camelCaseError': 'Le nom doit être en camelCase (ex: maVariable)',
  'designer.variables.copy': 'Copier',
  'designer.variables.custom': 'Variables personnalisées',
  'designer.variables.defaultValue': 'Valeur par défaut',
  'designer.variables.howToTitle': 'Yorum utiliser les variables :',
  'designer.variables.noCustom': 'Aucune variable personnalisée',
  'designer.variables.system': 'Variables système',
  'designer.variables.systemHint': 'Lecture seule — disponibles dans tous les blocs',
  'designer.variables.title': 'Variables',
  'designer.variables.type': 'Tür',
  'voicePanel.title': 'Varsayılan voice',
  'voicePanel.provider': 'Provider: Mistral AI',
  'voicePanel.hint': 'Seç the voice kullanıldı için blok narration.',
  'voicePanel.multiLangHint': 'Için one Mistral voice per UI dil (tümü 10), birç the Translation panel (diller simge in the designer toolbar).',
  'voicePanel.translationFrenchFallback': 'Translated ses: ile hayır voice kaydedildi için bir dil, the engine uses “Marie - sad” (Mistral) için French, Italian ve Spanish, ve “Paul - sad” için diğer diller.',
  'voicePanel.search': 'Ara…',
  'voicePanel.allLanguages': 'Tümü diller',
  'voicePanel.loading': 'Yükleniyor voices…',
  'voicePanel.loadError': 'Unable to load voices',
  'voicePanel.empty': 'Hayır voices mevcut.',
  'voicePanel.emptyHint': 'Kontrol et the Mistral API key in Administration → Entegrasyonlar.',
  'voicePanel.noResults': 'Hayır voices match sizin ara.',
  'voicePanel.saved': 'Varsayılan voice kaydedildi',
  'voicePanel.saveError': 'Hata kaydediliyor voice',
  'voicePanel.default': 'Varsayılan',
  'voicePanel.female': 'Female',
  'voicePanel.male': 'Male',
  'voicePanel.playPreview': 'Önizleme voice',
  'voicePanel.stopPreview': 'Durdur',
  'voicePanel.noPreview': 'Önizleme değil mevcut',
  'voicePanel.previewLoading': 'Oluşturuluyor…',
  'voicePanel.previewGenerateError': 'Could değil oluştur the ses önizleme.',
  'voicePanel.previewPlayError': 'Ses playback başarısız.',
  'voicePanel.filterNoVoicesForLang': 'Hayır catalog voice matches bu dil — dene “Tümü diller”.',
  'episodeEditor.voicePicker.blockVoice': 'Voice için bu blok',
  'episodeEditor.voicePicker.defaultVoice': 'Varsayılan voice',
  'episodeEditor.voicePicker.voices': 'voices',
  'episodeEditor.voicePicker.searchPlaceholder': 'Ara bir voice…',
  'episodeEditor.voicePicker.noVoiceFound': 'Hayır voice bulundu',
  'episodeEditor.voicePicker.female': 'Female',
  'episodeEditor.voicePicker.male': 'Male',
  'episodeEditor.voicePicker.stop': 'Durdur',
  'episodeEditor.voicePicker.preview': 'Önizleme voice',
  'episodeEditor.voicePicker.stopPlayback': 'Durdur playback',
  'episodeEditor.errors.notFound': 'Bölüm değil bulundu',
  'episodeEditor.errors.titleRequired': 'Başlık is zorunlu.',
  'episodeEditor.errors.saveFailed': 'Hata kaydediliyor.',
  'episodeEditor.errors.noVoicesAvailable': 'Hayır voices mevcut. Gir the API key in Administration → Platform entegrasyonlar, sonra reload the sayfa.',
  'episodeEditor.errors.selectVoiceFirst': 'Seç bir voice in the "Voice" sekme önce oluşturuluyor voiceover.',
  'episodeEditor.errors.invalidBlockVoice': 'One veya daha fazla bloklar have bir geçersiz voice. birç the per-blok voice selector veya reload the voice liste.',
  'episodeEditor.errors.addTextFirst': 'Ekle text önce oluşturuluyor ses.',
  'episodeEditor.errors.audioGenerationFailedApi': 'Ses generation başarısız. {{mesaj}} (displayed süre = estimate.)',
  'episodeEditor.errors.audioGenerationFailed': 'Hata sırasında ses generation. Displayed süre = estimate.',
  'episodeEditor.success.published': 'Bölüm yayınlandı!',
  'episodeEditor.success.draftSaved': 'Taslak kaydedildi',
  'episodeEditor.success.audioGenerated': 'Ses oluşturuldu ile {{count}} blok(s)',
  'episodeEditor.tabs.edit': 'Düzenle',
  'episodeEditor.tabs.chapters': 'Chapters',
  'episodeEditor.tabs.voice': 'Voice',
  'episodeEditor.tabs.podcasts': 'Podcastler',
  'episodeEditor.toolbar.undo': 'Undo (Ctrl+Z)',
  'episodeEditor.toolbar.redo': 'Redo (Ctrl+Y)',
  'episodeEditor.toolbar.generating': 'Oluşturuluyor…',
  'episodeEditor.toolbar.generateAudio': 'Oluştur ses',
  'episodeEditor.toolbar.save': 'Kaydet',
  'episodeEditor.toolbar.publish': 'Yayınla',
  'episodeEditor.titlePlaceholder': 'Bölüm başlık…',
  'episodeEditor.status.published': 'Yayınlandı',
  'episodeEditor.status.draft': 'Taslak',
  'episodeEditor.warnings.mistralNotConfigured': 'Bölüm voiceover uses Mistral Voxtral TTS. Ekle the Mistral key in Administration → Platform entegrasyonlar, sonra reload bu sayfa.',
  'episodeEditor.warnings.mistralNoVoices': 'The Mistral key is recognized ama the API returned hayır voices. Kontrol et backend logs.',
  'episodeEditor.warnings.voiceLoadFailed': 'Unable to load voice liste. Kontrol et Mistral yapılandırma in Administration → Platform entegrasyonlar.',
  'episodeEditor.warnings.voiceOffDisabled': 'Olmadan bir real voice, voiceover generation remains devre dışı.',
  'episodeEditor.edit.voiceOff': 'Voiceover',
  'episodeEditor.edit.voiceDescription': 'Synthesis via Mistral Voxtral TTS. Choose the voice in the "Voice" sekme veya per blok.',
  'episodeEditor.edit.coverImage': 'Cover görsel',
  'episodeEditor.edit.coverAlt': 'Bölüm cover',
  'episodeEditor.edit.deleteCover': 'Sil',
  'episodeEditor.edit.dropOrClickImage': 'Tıkla veya bırak bir görsel',
  'episodeEditor.edit.selectedVoice': 'Seçildi voice',
  'episodeEditor.edit.selectVoice': 'Seç bir voice',
  'episodeEditor.edit.defaultVoiceByLang': 'Varsayılan voice (podcast dil)',
  'episodeEditor.edit.lastAudioGenerated': 'Son oluşturuldu ses',
  'episodeEditor.edit.audioNotFound': 'Ses dosya değil bulundu — regenerate the voiceover.',
  'episodeEditor.edit.generatingInProgress': 'Oluşturuluyor…',
  'episodeEditor.edit.generateVoiceOff': 'Oluştur voiceover',
  'episodeEditor.chapters.title': 'Chapters',
  'episodeEditor.chapters.add': 'Ekle',
  'episodeEditor.chapters.defaultChapterTitle': 'Introduction',
  'episodeEditor.chapters.newChapterTitle': 'Bölüm {{n}}',
  'episodeEditor.chapters.blockCount': '{{count}} blok(s)',
  'episodeEditor.voiceTab.availableVoices': 'Mevcut voices',
  'episodeEditor.podcasts.linked': 'Linked podcastler',
  'episodeEditor.podcasts.assign': 'Ata',
  'episodeEditor.podcasts.noneAvailable': 'Hayır podcast mevcut',
  'episodeEditor.podcasts.close': 'Kapat',
  'episodeEditor.podcasts.noneLinked': 'Hayır linked podcast',
  'episodeEditor.podcasts.assignHint': 'Ata bu bölüm to one veya daha fazla podcastler',
  'episodeEditor.podcasts.remove': 'Kaldır',
  'episodeEditor.editor.addTextBlock': 'Ekle bir text blok',
  'episodeEditor.editor.scriptPlaceholder': 'Başlangıç yazılıyor sizin script…',
  'episodeEditor.editor.addBlock': 'Ekle bir blok',
  'episodeEditor.player.loop': 'Loop',
  'episodeEditor.player.playbackSpeed': 'Playback speed',
  'episodeEditor.player.collapse': 'Daralt',
  'episodeEditor.player.expand': 'Genişlet',
  'episodeEditor.player.waveformHidden': 'Waveform gizli',
  'podcast.episodes.listen': 'Dinle',
  'podcast.episodes.noAudioShort': 'Hayır ses mevcut',
  'podcast.episodes.edit': 'Düzenle',
  'podcast.episodes.delete': 'Sil',
  'podcast.episodes.unmute': 'Unmute',
  'podcast.episodes.mute': 'Mute',
  'podcast.episodes.totalEpisodes': '{{count}} bölüm(s) toplam',
  'eduflow.designer.toast.blockCopied': 'Blok kopyalandı',
  'eduflow.designer.toast.blockPasted': 'Blok pasted',
  'eduflow.designer.toast.blockDuplicated': 'Blok çoğaltıldı',
  'eduflow.designer.toast.connectionUpdated': 'Connection güncellendi',
  'eduflow.designer.toast.flowExported': 'Kurs dışbir aktarıldı',
  'eduflow.designer.toast.flowImported': 'Kurs içe aktarıldı',
  'eduflow.designer.toast.flowPastedFromClipboard': 'Kurs oluşturuldu from clipboard',
  'eduflow.designer.toast.invalidFile': 'Geçersiz dosya',
  'eduflow.designer.toast.exportFailed': 'Dışbir aktar başarısız.',
  'eduflow.designer.toast.importPackageFailed': 'Could değil içe aktar the .lyrra package.',
  'eduflow.designer.untitled': 'Untitled',
  'eduflow.designer.importedFlow': 'Içe aktarıldı kurs',
  'eduflow.designer.collaborator.online': 'Çevrimiçi',
  'eduflow.designer.collaborator.offline': 'Çevrimdışı',
  'eduflow.designer.collaborator.defaultName': 'Kullanıcı',
  'eduflow.designer.collaborator.editor': 'Editör',
  'eduflow.designer.collaborator.viewer': 'İzleyici',
  'eduflow.designer.resizePanel': 'Resize panel',
  'eduflow.designer.published': 'Yayınlandı',
  'eduflow.designer.draft': 'Taslak',
  'eduflow.designer.quizOutput.success': 'Passed',
  'eduflow.designer.quizOutput.failure': 'Başarısız',
  'eduflow.designer.loopHandle.loop': 'Loop',
  'eduflow.designer.loopHandle.end': 'Son',
  'eduflow.designer.handle.default': 'Varsayılan',
  'eduflow.designer.genError': 'Hata sırasında generation. Lütfen dene tekrar.',
  'trainerTour.welcome.title': 'Hoş geldiniz to sizin eğitmen workspace',
  'trainerTour.welcome.description': 'Bu short tour introduces the gösterge paneli ve menü. Sonra, the ilk time you birç her sayfa, bir tip explains the essentials. You can kapat bir adım ile the X — the tour will değil başlangıç tekrar.',
  'trainerTour.dashboard.header.title': 'Sizin gösterge paneli',
  'trainerTour.dashboard.header.description': 'Genel bakış of sizin aktivite: key numbers ve shortcuts to oluştur içerik quickly.',
  'trainerTour.dashboard.actions.title': 'Oluştur içerik',
  'trainerTour.dashboard.actions.description': 'Shortcuts to bir yeni EduFlow kurs, bir podcast, veya bir öğrenme yol. Kullan them to başlangıç bir proje olmadan gidiyor aracılığıyla the menü.',
  'trainerTour.dashboard.stats.title': 'Metrics',
  'trainerTour.dashboard.stats.description': 'Kurslar, yayınlandı yollar, öğrenciler reached, ve podcastler: see the scope of sizin catalog at bir glance.',
  'trainerTour.dashboard.activity.title': 'Son aktivite',
  'trainerTour.dashboard.activity.description': 'En son güncellendi içerik. Tıkla bir satır to reopen the matching kurs, podcast, veya yol.',
  'trainerTour.sidebar.title': 'Side menü',
  'trainerTour.sidebar.description': 'Genel bakış (ana sayfa, öğrenciler, analytics, missions), oluşturma (kurslar, podcastler, yollar, web seminerleri eğer etkin), medya library, ve yardım. birç her bölüm — bir contextual tip appears the ilk time on her sayfa.',
  'trainerTour.routes.learners.title': 'Öğrenciler',
  'trainerTour.routes.learners.description': 'People kaydedildi in sizin içerik, ilerleme, exports — sizin hub için teaching takip et-up.',
  'trainerTour.routes.analytics.title': 'Analitik',
  'trainerTour.routes.analytics.description': 'Charts on engagement ve tamamlanma. Customize the layout to track ne matters to you.',
  'trainerTour.routes.eduflow.title': 'Kurslar (EduFlow)',
  'trainerTour.routes.eduflow.description': 'Oluştur ve yönet interactive kurslar, versions, yayınlanıyor, ve paylaşılıyor — the core of instructional design.',
  'trainerTour.routes.podcasts.title': 'Podcastler',
  'trainerTour.routes.podcasts.description': 'Shows, episodes, visibility, ve paylaşılıyor ile sizin kuruluş’s gruplar veya öğrenciler.',
  'trainerTour.routes.parcours.title': 'Öğrenme Yolları',
  'trainerTour.routes.parcours.description': 'Sequences of kurslar ve kaynaklar: structure long journeys ve ata them to sizin audiences.',
  'trainerTour.routes.videos.title': 'Videolar',
  'trainerTour.routes.videos.description': 'Reusable video library için sizin kurslar ve belgeler.',
  'trainerTour.routes.sounds.title': 'Ses',
  'trainerTour.routes.sounds.description': 'Ses dosyalar ve etiketler için podcastler ve ses bloklar in kurslar.',
  'trainerTour.routes.images.title': 'Görseller',
  'trainerTour.routes.images.description': 'Centralized visuals: içe aktar, folders, ve reuse across içerik.',
  'trainerTour.routes.documents.title': 'Belgeler',
  'trainerTour.routes.documents.description': 'PDFs ve attachments, ile isteğe bağlı targeted paylaşılıyor to öğrenciler.',
  'trainerTour.routes.help.title': 'Yardım',
  'trainerTour.routes.help.description': 'Articles, tutorials, ve walkthroughs hakkında LyrraOne. Gel geri ne zaman you are stuck on bir özellik.',
  'trainerTour.routes.producerAssignments.title': 'Üretim görevleri',
  'trainerTour.routes.producerAssignments.description': 'Ne zaman HR assigns catalog öğeler için you to produce, they göster up burada ile ilerleme.',
  'trainerTour.routes.webinars.title': 'Web Seminerleri',
  'trainerTour.routes.webinars.description': 'Program live oturumlar, invitations, ve broadcast bağlantılar için sizin gruplar.',
  'trainerTour.driver.progress': '{{mevcut}} of {{toplam}}',
  'trainerTour.driver.next': 'İleri',
  'trainerTour.driver.prev': 'Önceki',
  'trainerTour.driver.done': 'Tamamlandı',
  'trainerTour.driver.gotIt': 'Alındı it',
  'player.lightMode': 'birçık mode',
  'player.darkMode': 'Koyu mode',
  'a11y.skipToContent': 'Atla to main içerik',
  'a11y.skipToNav': 'Atla to navigation',
  'a11y.skipToPlayerMain': 'Atla to kurs içerik',
  'a11y.playerMainLandmark': 'Kurs içerik',
  'a11y.dialog': 'İletişim Kutusu',
  'a11y.closeDialog': 'Kapat dialog',
  'a11y.dismissNotification': 'Dismiss bildirim',
  'a11y.notificationsRegion': 'Bildirimler',
  'a11y.skipLinksLandmark': 'Quick erişim bağlantılar',
  'role.institution_admin': 'Kuruluş yönetici',
  'role.resp_formation': 'Eğitim yönetici',
  'dashboard.recent_projects': 'Son projeler',
  'dashboard.recent_activity': 'Son aktivite',
  'dashboard.quick_actions': 'Quick eylemler',
  'dashboard.stats': 'İstatistikler',
  'dashboard.total_projects': 'Toplam projeler',
  'dashboard.total_learners': 'Toplam öğrenciler',
  'dashboard.total_eduflows': 'Toplam kurslar',
  'dashboard.completion_rate': 'Tamamlanma rate',
  'dashboard.active_users': 'Aktif kullanıcılar',
  'dashboard.new_registrations': 'Yeni registrations',
  'dashboard.xp_earned': 'XP earned',
  'dashboard.streak': 'Mevcut streak',
  'dashboard.level': 'Seviye {{seviye}}',
  'dashboard.badges_earned': 'Badges earned',
  'dashboard.next_level': 'Sonraki seviye',
  'dashboard.no_projects': 'Hayır projeler yet',
  'dashboard.create_first': 'Oluştur sizin ilk proje',
  'dashboard.pending_reviews': 'Beklemede değerlendirmeler',
  'dashboard.upcoming_deadlines': 'Yaklaşbir deadlines',
  'eduflow.summary.editorHint': 'Liste the concepts veya adımlar covered in the kurs. Her line appears as bir numbered kart in the player.',
  'project.title': 'Projeler',
  'project.new': 'Yeni proje',
  'project.name': 'Proje ad',
  'project.description': 'Proje birçıklama',
  'project.status.in_review': 'In değerlendirme',
  'project.visibility.public': 'Genel',
  'project.visibility.private': 'Özel',
  'project.visibility.institution': 'Kuruluş',
  'project.no_projects': 'Hayır projeler bulundu',
  'project.delete_confirm': 'Are you sure you iste to sil bu proje?',
  'store.categories': 'Kategoriler',
  'store.price': 'Price',
  'store.free': 'Ücretsiz',
  'store.buy': 'Buy',
  'store.add_to_cart': 'Ekle to cart',
  'store.cart': 'Cart',
  'store.checkout': 'Checkout',
  'store.reviews': 'Değerlendirmeler',
  'store.rating': 'Puan',
  'store.my_purchases': 'Benim purchases',
  'store.no_items': 'Hayır öğeler bulundu',
  'audio.title': 'Ses Stüdyosu',
  'audio.audiobooks': 'Sesli Kitaplar',
  'audio.new_audiobook': 'Yeni audiobook',
  'audio.record': 'Kaydet',
  'audio.stop': 'Durdur',
  'audio.play': 'Oynat',
  'audio.pause': 'Duraklat',
  'audio.volume': 'Volume',
  'audio.tracks': 'Tracks',
  'audio.add_track': 'Ekle track',
  'audio.remove_track': 'Kaldır track',
  'audio.effects': 'Efektler',
  'audio.export': 'Dışa Aktar',
  'audio.export_format': 'Dışbir aktar format',
  'audio.duration': 'Süre',
  'audio.narrator': 'Narrator',
  'audio.chapter': 'Bölüm',
  'notification.title': 'Bildirimler',
  'notification.mark_all_read': 'Mark tümü as oku',
  'notification.no_notifications': 'Hayır bildirimler',
  'notification.new': 'Yeni bildirim',
  'notification.type.info': 'Bilgi',
  'notification.type.success': 'Başarılı',
  'notification.type.warning': 'Uyarı',
  'notification.type.error': 'Hata',
  'settings.title': 'Ayarlar',
  'settings.general': 'Genel',
  'settings.account': 'Hesap',
  'settings.security': 'Güvenlik',
  'settings.appearance': 'Görünüm',
  'settings.notifications': 'Bildirimler',
  'settings.language': 'Dil',
  'settings.theme': 'Tema',
  'settings.theme.light': 'Açık',
  'settings.theme.dark': 'Koyu',
  'settings.theme.system': 'Sistem',
  'settings.accessibility': 'Erişilebilirlik',
  'settings.font_size': 'Yazı tipi boyut',
  'settings.high_contrast': 'Yüksek contrast',
  'settings.reduced_motion': 'Reduced motion',
  'settings.dyslexia_mode': 'Dyslexia mode',
  'analytics.title': 'Analitik',
  'analytics.overview': 'Genel Bakış',
  'analytics.learner_progress': 'Öğrenci ilerleme',
  'analytics.engagement': 'Engagement',
  'analytics.completion': 'Tamamlanma',
  'analytics.time_spent': 'Time spent',
  'analytics.average_score': 'Average puan',
  'analytics.export_report': 'Dışbir aktar rapor',
  'gamification.xp': 'XP',
  'gamification.streak': 'Streak',
  'gamification.achievements': 'Achievements',
  'gamification.daily_goal': 'Günlük amaç',
  'gamification.congratulations': 'Congratulations!',
  'gamification.new_badge': 'Yeni rozet kilitsiz!',
  'gamification.level_up': 'Seviye up!',
  'qualiopi.title': 'Qualiopi uyumluluk',
  'qualiopi.dashboard': 'Qualiopi gösterge paneli',
  'qualiopi.criteria': 'Criterion {{number}}',
  'qualiopi.indicator': 'Indicator {{number}}',
  'qualiopi.compliant': 'Compliant',
  'qualiopi.non_compliant': 'Non-compliant',
  'qualiopi.partial': 'Partially compliant',
  'qualiopi.not_applicable': 'Değil applicable',
  'qualiopi.upload_evidence': 'Yükle evidence',
  'qualiopi.audit_date': 'Audit tarih',
  'qualiopi.next_audit': 'Sonraki audit',
  'qualiopi.compliance_score': 'Uyumluluk puan',
  'qualiopi.action_plan': 'Eylem plan',
  'training.plan': 'Eğitim plan',
  'training.request': 'Eğitim istek',
  'training.requests': 'Eğitim istekler',
  'training.catalog': 'Eğitim catalog',
  'training.budget': 'Eğitim budget',
  'training.campaign': 'Interview kampanya',
  'training.competency': 'Beceriler framework',
  'training.gap_analysis': 'Gap analysis',
  'training.roi': 'Return on investment',
  'eduflow.blockEditor.audio.estimatedSeconds': '~{{sec}}s estimated',
  'eduflow.blockEditor.audio.fileLabel': 'Ses dosya',
  'eduflow.blockEditor.audio.formatsHint': 'MP3, WAV, OGG',
  'eduflow.blockEditor.audio.generateButton': 'Oluştur ses',
  'eduflow.blockEditor.audio.generateTts': 'Oluştur TTS',
  'eduflow.blockEditor.audio.import': 'İçe Aktar',
  'eduflow.blockEditor.audio.langDe': 'German',
  'eduflow.blockEditor.audio.langEn': 'English',
  'eduflow.blockEditor.audio.langEs': 'Spanish',
  'eduflow.blockEditor.audio.langFr': 'French',
  'eduflow.blockEditor.audio.langIt': 'Italian',
  'eduflow.blockEditor.audio.language': 'Dil',
  'eduflow.blockEditor.audio.mistralVoice': 'Voice (Mistral TTS)',
  'eduflow.blockEditor.audio.mistralVoicePlaceholder': 'Mistral voice ID (Mistral console / API)',
  'eduflow.blockEditor.audio.voicesLoading': 'Yükleniyor voices…',
  'eduflow.blockEditor.audio.voicesLoadError': 'Could değil load Mistral voices.',
  'eduflow.blockEditor.audio.voiceFallbackOption': '{{id}} (varsayılan)',
  'eduflow.blockEditor.audio.generating': 'Oluşturuluyor…',
  'eduflow.blockEditor.audio.generateNeedText': 'Gir text to synthesize ilk.',
  'eduflow.blockEditor.audio.generateBadResponse': 'Geçersiz TTS yanıt.',
  'eduflow.blockEditor.audio.generateSuccess': 'Ses oluşturuldu.',
  'eduflow.blockEditor.audio.generateError': 'Synthesis başarısız (Mistral TTS / entegrasyonlar).',
  'eduflow.blockEditor.audio.preview': 'Önizleme',
  'eduflow.blockEditor.audio.source': 'Ses source',
  'eduflow.blockEditor.audio.speedLabel': 'Speed: {{speed}}x',
  'eduflow.blockEditor.audio.syncWithText': 'Sync ile text (subtitles)',
  'eduflow.blockEditor.audio.ttsPlaceholder': 'Gir the text to be oku tarafından the synthetic voice…',
  'eduflow.blockEditor.audio.ttsText': 'Text to synthesize',
  'eduflow.blockEditor.audio.urlLabel': 'Veya ses dosya URL',
  'eduflow.blockEditor.audio.urlPlaceholder': 'https://example.com/ses.mp3',
  'eduflow.blockEditor.browser.allowExternalAria': 'Allow diğer websites',
  'eduflow.blockEditor.browser.allowExternalHelp': '{{off}}: protected iframe (sandbox) — limits pop-ups ve outgoing behavior. {{on}}: better compatibility ile rich sayfalar (videolar, widgets); navigation possible inside the frame.',
  'eduflow.blockEditor.browser.allowExternalOff': 'Off',
  'eduflow.blockEditor.browser.allowExternalOn': 'On',
  'eduflow.blockEditor.browser.allowExternalTitle': 'Allow diğer websites',
  'eduflow.blockEditor.browser.frameTitleFallback': 'Embedded web sayfa',
  'eduflow.blockEditor.browser.fullscreen': 'Tam ekran',
  'eduflow.blockEditor.browser.fullscreenTitle': 'Önizleme — Embedded web sayfa',
  'eduflow.blockEditor.browser.openTab': 'birç in bir sekme',
  'eduflow.blockEditor.browser.preview': 'Önizleme',
  'eduflow.blockEditor.browser.urlHelp': 'Gir the dolu address (https). Önizleme is framed like bir window — bu is değil bir browser: öğrenciler cannot değiştir the URL burada.',
  'eduflow.blockEditor.browser.urlLabel': 'Sayfa URL',
  'eduflow.blockEditor.browser.urlPlaceholder': 'https://…',
  'eduflow.blockEditor.chart.addLabel': 'Etiket',
  'eduflow.blockEditor.chart.addSeries': 'Series',
  'eduflow.blockEditor.chart.animation': 'Animasyon',
  'eduflow.blockEditor.chart.chartTitle': 'Grafik başlık',
  'eduflow.blockEditor.chart.chartType': 'Grafik tür',
  'eduflow.blockEditor.chart.colorTitle': 'Renk',
  'eduflow.blockEditor.chart.datasets': 'Veri series ({{count}})',
  'eduflow.blockEditor.chart.defaultLabel': 'Etiket {{n}}',
  'eduflow.blockEditor.chart.defaultSeries': 'Series {{n}}',
  'eduflow.blockEditor.chart.interactive': 'Interactive (tooltips)',
  'eduflow.blockEditor.chart.labelsX': 'Labels (X axis)',
  'eduflow.blockEditor.chart.noSeries': 'Hayır series. Tıkla “Series” to ekle one.',
  'eduflow.blockEditor.chart.readerPreviewHint': 'Önizleme mevcut in player mode',
  'eduflow.blockEditor.chart.seriesNamePlaceholder': 'Series ad',
  'eduflow.blockEditor.chart.settings': 'Ayarlar',
  'eduflow.blockEditor.chart.showGrid': 'Göster grid',
  'eduflow.blockEditor.chart.showLegend': 'Göster legend',
  'eduflow.blockEditor.chart.titlePlaceholder': 'Isteğe bağlı başlık',
  'eduflow.blockEditor.chart.typeArea': 'Alan',
  'eduflow.blockEditor.chart.typeBar': 'Bars',
  'eduflow.blockEditor.chart.typeDoughnut': 'Doughnut',
  'eduflow.blockEditor.chart.typeLine': 'Line',
  'eduflow.blockEditor.chart.typePie': 'Pie',
  'eduflow.blockEditor.chart.typeRadar': 'Radar',
  'eduflow.blockEditor.timer.sectionTitle': 'Zamanlayıcı',
  'eduflow.blockEditor.timer.enable': 'Etkinleştir timer (player)',
  'eduflow.blockEditor.timer.modeLabel': 'Mode',
  'eduflow.blockEditor.timer.modeCountup': 'Stopwatch (0 → limit)',
  'eduflow.blockEditor.timer.countupHint': 'The son 10 saniye önce the limit çevir red.',
  'eduflow.blockEditor.timer.modeCountdown': 'Countdown (limit → 0)',
  'eduflow.blockEditor.timer.countdownHint': 'The son 5 saniye çevir red.',
  'eduflow.blockEditor.timer.maxSecondsLabel': 'Maximum time (saniye)',
  'eduflow.blockEditor.evaluation.aiQuestions': 'Oluştur sorular ile AI',
  'eduflow.blockEditor.evaluation.editFullscreen': 'Düzenle form (fullscreen)',
  'eduflow.blockEditor.evaluation.hint': 'birç the fullscreen editor to build the form: sürükle field types from the kalan sütun ve reorder sorular ile the handle.',
  'eduflow.blockEditor.evaluation.metaLine': '{{qPart}} · {{pPart}} toplam',
  'eduflow.blockEditor.evaluation.pointPlural': 'puanlar',
  'eduflow.blockEditor.evaluation.pointSingular': 'puan',
  'eduflow.blockEditor.evaluation.questionPlural': 'sorular',
  'eduflow.blockEditor.evaluation.questionSingular': 'soru',
  'eduflow.blockEditor.evaluation.title': 'Değerlendirme form',
  'eduflow.blockEditor.evaluationForm.addFreeText': 'Ekle ücretsiz text',
  'eduflow.blockEditor.evaluationForm.addOption': 'Seçenek',
  'eduflow.blockEditor.evaluationForm.close': 'Kapat',
  'eduflow.blockEditor.evaluationForm.delete': 'Sil',
  'eduflow.blockEditor.evaluationForm.dropEmptyHint': 'Bırak bir soru tür from the kalan panel burada, veya kullan the “Ekle” düğme.',
  'eduflow.blockEditor.evaluationForm.escapeHint': 'Esc to kapat',
  'eduflow.blockEditor.evaluationForm.expectedValue': 'Expected value',
  'eduflow.blockEditor.evaluationForm.footerStats': '{{n}} soru(s) · {{pts}} pts toplam',
  'eduflow.blockEditor.evaluationForm.headerSubtitle': 'Sürükle bir soru tür from the kalan içine the orta. Reorder ile the ⋮⋮ handle.',
  'eduflow.blockEditor.evaluationForm.headerTitle': 'Değerlendirme form editor',
  'eduflow.blockEditor.evaluationForm.maxAttempts': 'Max denemeler',
  'eduflow.blockEditor.evaluationForm.moveQuestion': 'Taşı soru',
  'eduflow.blockEditor.evaluationForm.optionPlaceholder': 'Seçenek…',
  'eduflow.blockEditor.evaluationForm.optionsHint': 'Tıkla the simge to mark the doğru cevap(s).',
  'eduflow.blockEditor.evaluationForm.overlayUntitled': '(untitled)',
  'eduflow.blockEditor.evaluationForm.paletteSubtitle': 'Bırak on the canvas to ekle bir soru.',
  'eduflow.blockEditor.evaluationForm.paletteTitle': 'Fields',
  'eduflow.blockEditor.evaluationForm.passThreshold': 'Geç threshold: {{pct}}%',
  'eduflow.blockEditor.evaluationForm.pointsShort': 'pts',
  'eduflow.blockEditor.evaluationForm.qTypeDropdown': 'Dropdown',
  'eduflow.blockEditor.evaluationForm.qTypeFile': 'Dosya',
  'eduflow.blockEditor.evaluationForm.qTypeMultiple': 'Multiple choice',
  'eduflow.blockEditor.evaluationForm.qTypeNumeric': 'Numeric',
  'eduflow.blockEditor.evaluationForm.qTypeSingle': 'Single choice',
  'eduflow.blockEditor.evaluationForm.qTypeText': 'Ücretsiz text',
  'eduflow.blockEditor.evaluationForm.questionTitlePlaceholder': 'Soru başlık…',
  'eduflow.blockEditor.evaluationForm.refAnswerLabel': 'Reference cevap (isteğe bağlı)',
  'eduflow.blockEditor.evaluationForm.refAnswerPlaceholder': 'Expected cevap…',
  'eduflow.blockEditor.evaluationForm.refEmptyHint': 'Olmadan reference: herhangi non-boş cevap is kabul edildi.',
  'eduflow.blockEditor.evaluationForm.required': 'Req.',
  'eduflow.blockEditor.evaluationForm.semanticGrading': 'AI grading (semantic similarity)',
  'eduflow.blockEditor.evaluationForm.semanticThreshold': 'Semantic threshold: {{pct}}%',
  'eduflow.blockEditor.evaluationForm.showCorrect': 'Göster doğru cevaplar',
  'eduflow.blockEditor.evaluationForm.showResults': 'Göster sonuçlar',
  'eduflow.blockEditor.evaluationForm.timeLimit': 'Time limit',
  'eduflow.blockEditor.evaluationForm.tolerance': 'Tolerance ±',
  'eduflow.blockEditor.glossary.add': 'Ekle',
  'eduflow.blockEditor.glossary.categories': 'Kategoriler',
  'eduflow.blockEditor.glossary.definitionPlaceholder': 'Definition',
  'eduflow.blockEditor.glossary.description': 'Açıklama',
  'eduflow.blockEditor.glossary.descriptionPlaceholder': 'Yardım text için vocabulary…',
  'eduflow.blockEditor.glossary.enableQuiz': 'Etkinleştir built-in sınav',
  'eduflow.blockEditor.glossary.includeInQuiz': 'Include in sınav',
  'eduflow.blockEditor.glossary.newCategoryPlaceholder': 'Yeni kategori',
  'eduflow.blockEditor.glossary.noCategory': 'Hayır kategori',
  'eduflow.blockEditor.glossary.panelHint': 'Define sizin terms ve etkinleştir sınav mode için değerlendirme.',
  'eduflow.blockEditor.glossary.panelTitle': 'Glossary + built-in sınav',
  'eduflow.blockEditor.glossary.termPlaceholder': 'Term',
  'eduflow.blockEditor.glossary.termSingular': 'Term',
  'eduflow.blockEditor.glossary.termsCount': 'Terms ({{count}})',
  'eduflow.blockEditor.glossary.titleLabel': 'Glossary başlık',
  'eduflow.blockEditor.glossary.titlePlaceholder': 'Glossary',
  'eduflow.blockEditor.htmlSource.formatButton': 'Format',
  'eduflow.blockEditor.htmlSource.formatTitle': 'Re-indent ve structure HTML (aynı logic as ne zaman entering code mode)',
  'eduflow.blockEditor.htmlSource.findVerb': 'bul',
  'eduflow.blockEditor.htmlSource.indentVerb': 'indents',
  'eduflow.blockEditor.htmlSource.modeLabel': 'HTML code mode',
  'eduflow.blockEditor.mindmap.addChild': 'Child node',
  'eduflow.blockEditor.mindmap.addMainBranch': 'Ekle bir main branch',
  'eduflow.blockEditor.mindmap.branchTitle': 'Branch · {{başlık}}',
  'eduflow.blockEditor.mindmap.centralTheme': 'Central tema',
  'eduflow.blockEditor.mindmap.close': 'Kapat',
  'eduflow.blockEditor.mindmap.configureFullscreen': 'Yapılandır fullscreen',
  'eduflow.blockEditor.mindmap.descriptionLabel': 'Açıklama',
  'eduflow.blockEditor.mindmap.descriptionPlaceholder': 'Supporting text',
  'eduflow.blockEditor.mindmap.dialogTitle': 'Zihin Haritası',
  'eduflow.blockEditor.mindmap.optional': 'İsteğe bağlı',
  'eduflow.blockEditor.mindmap.playerHint': 'Player: yatay map (text on colored curve, pills). Yakınlaştırma in the blok başlık. URL: ↗ opens bir yeni sekme.',
  'eduflow.blockEditor.mindmap.remove': 'Kaldır',
  'eduflow.blockEditor.mindmap.structure': 'Structure',
  'eduflow.blockEditor.mindmap.subtitleLabel': 'Altyazı',
  'eduflow.blockEditor.mindmap.titleLabel': 'Başlık',
  'eduflow.blockEditor.mindmap.titlePlaceholder': 'Node başlık',
  'eduflow.blockEditor.mindmap.untitled': 'Untitled',
  'eduflow.blockEditor.mindmap.urlLabel': 'URL bağlantı',
  'eduflow.blockEditor.mindmap.urlPlaceholder': 'https://…',
  'eduflow.blockEditor.pdf.allowDownload': 'Allow indir',
  'eduflow.blockEditor.pdf.badgePdf': 'PDF',
  'eduflow.blockEditor.pdf.completionLabel': 'Tamamlanma etiket',
  'eduflow.blockEditor.pdf.completionPlaceholder': 'Belge görüntülendi',
  'eduflow.blockEditor.pdf.documentFallback': 'PDF belge',
  'eduflow.blockEditor.pdf.emptyLibrary': 'Hayır belgeler in sizin library.',
  'eduflow.blockEditor.pdf.focusMode': 'Belge focus',
  'eduflow.blockEditor.pdf.focusModeDesc': 'Minimal chrome, centered reading',
  'eduflow.blockEditor.pdf.importFailed': 'Içe aktar başarısız',
  'eduflow.blockEditor.pdf.importFailedGeneric': 'Içe aktar başarısız.',
  'eduflow.blockEditor.pdf.importSubtitle': 'The belge will be eklendi to sizin belge library.',
  'eduflow.blockEditor.pdf.importTitle': 'Içe aktar bir PDF',
  'eduflow.blockEditor.pdf.librarySubtitle': 'Yükle bir PDF to sizin library veya seç bir existing one.',
  'eduflow.blockEditor.pdf.libraryTitle': 'Belge library',
  'eduflow.blockEditor.pdf.loadingDocs': 'Yükleniyor belgeler…',
  'eduflow.blockEditor.pdf.myDocuments': 'Benim belgeler',
  'eduflow.blockEditor.pdf.pagesAuto': 'The player will detect the number of sayfalar automatically.',
  'eduflow.blockEditor.pdf.pagesDetected': '{{count}} sayfalar detected',
  'eduflow.blockEditor.pdf.pickFromLibrary': 'Seç bir PDF zaten in sizin library.',
  'eduflow.blockEditor.pdf.previewTitle': 'Belge önizleme',
  'eduflow.blockEditor.pdf.readerMode': 'Modern reader',
  'eduflow.blockEditor.pdf.readerModeDesc': 'Sayfa tarafından sayfa, yakınlaştırma, fullscreen',
  'eduflow.blockEditor.pdf.readingExperience': 'Reading experience',
  'eduflow.blockEditor.pdf.showProgress': 'Göster reading ilerleme',
  'eduflow.blockEditor.pdf.smartExtractSoon': 'Smart extraction geliyor soon',
  'eduflow.blockEditor.pdf.startPage': 'Başlangıç sayfa',
  'eduflow.blockEditor.pdf.uploadedDesc': '{{ad}} is şimdi mevcut in sizin belge library.',
  'eduflow.blockEditor.pdf.uploadedToast': 'PDF içe aktarıldı',
  'eduflow.blockEditor.pdf.uploading': 'Yükle in ilerleme',
  'eduflow.blockEditor.phraseReveal.addPhrase': 'Ekle bir phrase',
  'eduflow.blockEditor.phraseReveal.aiSummaryTitle': 'Oluştur bir AI recap from upstream bloklar',
  'eduflow.blockEditor.phraseReveal.autoScroll': 'Auto-scroll',
  'eduflow.blockEditor.phraseReveal.displayDuration': 'Süre per phrase (s)',
  'eduflow.blockEditor.phraseReveal.editorHint': 'Ekle one veya daha fazla phrases ile the rich text editor. The player shows one phrase at bir time; tıkla veya Space için the sonraki.',
  'eduflow.blockEditor.phraseReveal.emptyPhrase': 'Boş phrase',
  'eduflow.blockEditor.phraseReveal.importLegacy': 'Içe aktar the legacy “text to reveal” field as phrases (recommended).',
  'eduflow.blockEditor.phraseReveal.noPhrases': 'Hayır phrases yet.',
  'eduflow.blockEditor.phraseReveal.phraseContent': 'Phrase içerik',
  'eduflow.blockEditor.phraseReveal.phrasePlaceholder': 'Gir bu adım\\\'s text…',
  'eduflow.blockEditor.phraseReveal.showHistory': 'Göster phrase history',
  'eduflow.blockEditor.phraseReveal.showHistoryHelp': 'Previously seen phrases appear in bir kart arasında the mevcut phrase ve the blok birçıklama.',
  'eduflow.blockEditor.presentation.addSlide': 'Slide',
  'eduflow.blockEditor.presentation.autoAdvance': 'Auto-advance',
  'eduflow.blockEditor.presentation.delayLabel': 'Delay: {{sec}}s',
  'eduflow.blockEditor.presentation.duplicateTitleSuffix': ' (kopyala)',
  'eduflow.blockEditor.presentation.globalSettings': 'Global ayarlar',
  'eduflow.blockEditor.presentation.layoutImageText': 'Görsel + text',
  'eduflow.blockEditor.presentation.layoutTitleContent': 'Başlık + içerik',
  'eduflow.blockEditor.presentation.layoutTitleOnly': 'Başlık sadece',
  'eduflow.blockEditor.presentation.layoutTwoCol': 'Two columns',
  'eduflow.blockEditor.presentation.layoutVideoOnly': 'Video sadece',
  'eduflow.blockEditor.presentation.layoutVideoText': 'Text + video',
  'eduflow.blockEditor.presentation.loop': 'Loop',
  'eduflow.blockEditor.presentation.noSlides': 'Hayır slides. Tıkla to ekle one.',
  'eduflow.blockEditor.presentation.slideCount_one': '{{count}} slide',
  'eduflow.blockEditor.presentation.slideCount_other': '{{count}} slides',
  'eduflow.blockEditor.presentation.slideNumbers': 'Slide numbers',
  'eduflow.blockEditor.presentation.slidesHeading': 'Slides',
  'eduflow.blockEditor.presentation.transition': 'Geçiş',
  'eduflow.blockEditor.presentation.transitionFade': 'Fade',
  'eduflow.blockEditor.presentation.transitionNone': 'Hiçbiri',
  'eduflow.blockEditor.presentation.transitionSlide': 'Slide',
  'eduflow.blockEditor.presentation.transitionZoom': 'Yakınlaştırma',
  'eduflow.blockEditor.quiz.addAnswer': 'Ekle bir cevap',
  'eduflow.blockEditor.quiz.addOrderingItem': 'Ekle bir öğe',
  'eduflow.blockEditor.quiz.aiMcqTitle': 'Oluştur bir MCQ ile AI from upstream bloklar',
  'eduflow.blockEditor.quiz.answerPlaceholder': 'Cevap {{n}}',
  'eduflow.blockEditor.quiz.answersCount': 'Cevaplar ({{count}}/10)',
  'eduflow.blockEditor.quiz.branching': 'Branching',
  'eduflow.blockEditor.quiz.correctAnswer': 'Doğru cevap',
  'eduflow.blockEditor.quiz.correctAnswerPlaceholder': 'Seç…',
  'eduflow.blockEditor.quiz.explanation': 'Explanation',
  'eduflow.blockEditor.quiz.explanationPlaceholder': 'Additional explanation...',
  'eduflow.blockEditor.quiz.false': 'Yanlış',
  'eduflow.blockEditor.quiz.feedback': 'Geri bildirim',
  'eduflow.blockEditor.quiz.ifCorrect': 'Eğer doğru →',
  'eduflow.blockEditor.quiz.ifIncorrect': 'Eğer yanlış →',
  'eduflow.blockEditor.quiz.markAsCorrect': 'Mark as doğru',
  'eduflow.blockEditor.quiz.markCorrect': 'Doğru cevap',
  'eduflow.blockEditor.quiz.msgCorrect': 'Mesaj eğer doğru',
  'eduflow.blockEditor.quiz.msgCorrectPlaceholder': 'Well tamamlandı! O\\\'s doğru.',
  'eduflow.blockEditor.quiz.msgIncorrect': 'Mesaj eğer yanlış',
  'eduflow.blockEditor.quiz.msgIncorrectPlaceholder': 'O\\\'s değil the sağ cevap.',
  'eduflow.blockEditor.quiz.nextBlockAuto': 'Sonraki blok (auto)',
  'eduflow.blockEditor.quiz.orderingHint': 'Öğeler to sipariş (mevcut sipariş = doğru sipariş)',
  'eduflow.blockEditor.quiz.orderingItemPlaceholder': 'Öğe {{n}}',
  'eduflow.blockEditor.quiz.partialScoring': 'Partial scoring (MCQ)',
  'eduflow.blockEditor.quiz.question': 'Soru',
  'eduflow.blockEditor.quiz.questionPlaceholder': 'Gir sizin soru...',
  'eduflow.blockEditor.quiz.quizType': 'Sınav tür',
  'eduflow.blockEditor.quiz.score': 'Puan',
  'eduflow.blockEditor.quiz.showCorrect': 'Göster doğru cevap',
  'eduflow.blockEditor.quiz.shuffle': 'Shuffle',
  'eduflow.blockEditor.quiz.true': 'Doğru',
  'eduflow.blockEditor.quiz.typeMcq': 'MCQ',
  'eduflow.blockEditor.quiz.typeFillBlank': 'Fill in the blanks',
  'eduflow.blockEditor.quiz.typeOrdering': 'Ordering',
  'eduflow.blockEditor.quiz.typeTrueFalse': 'True / False',
  'eduflow.blockEditor.quiz.branchingMode': 'Branching mode',
  'eduflow.blockEditor.quiz.branchingNone': 'Hiçbiri (linear)',
  'eduflow.blockEditor.quiz.branchingCorrectIncorrect': 'Doğru / Yanlış',
  'eduflow.blockEditor.quiz.branchingPerAnswer': 'Per individual cevap',
  'eduflow.blockEditor.loop.maxIterationsLabel': 'Maximum number of iterations (0 = infinite)',
  'eduflow.blockEditor.loop.infiniteHint': 'The loop will devam et indefinitely kadar the exit condition is met',
  'eduflow.blockEditor.loop.limitedHint': 'The loop will durdur sonra at en çok {{count}} iteration(s)',
  'eduflow.blockEditor.loop.howItWorksTitle': 'Nasıl it works:',
  'eduflow.blockEditor.selfAssessment.addBadge': 'Ekle',
  'eduflow.blockEditor.selfAssessment.addCriterion': 'Ekle',
  'eduflow.blockEditor.selfAssessment.badgeInputPlaceholder': 'e.g. Sık sık, Asla, Bazen…',
  'eduflow.blockEditor.selfAssessment.badgeOptionsHint': 'Short words veya phrases — öğrenciler seç them as chips. Eğer hiçbiri → ücretsiz text field.',
  'eduflow.blockEditor.selfAssessment.badgeOptionsLabel': 'Seçenekler (badges)',
  'eduflow.blockEditor.selfAssessment.criteriaSection': 'Kriterler',
  'eduflow.blockEditor.selfAssessment.criterionDescription': 'birçıklama (isteğe bağlı)',
  'eduflow.blockEditor.selfAssessment.criterionDescriptionPh': 'Clarify ne the öğrenci should notice veya nasıl to position themselves…',
  'eduflow.blockEditor.selfAssessment.criterionTitle': 'Başlık',
  'eduflow.blockEditor.selfAssessment.criterionTitlePh': 'e.g. Communication, Autonomy…',
  'eduflow.blockEditor.selfAssessment.emptyCriteria': 'Hayır criteria yet. Ekle at least one so öğrenciler can self-assess.',
  'eduflow.blockEditor.selfAssessment.moveDown': 'Taşı down',
  'eduflow.blockEditor.selfAssessment.moveUp': 'Taşı up',
  'eduflow.blockEditor.selfAssessment.panelHint': 'Define her dimension to rate: bir short başlık ve, eğer gerekli, bir birçıklama to guide the öğrenci.',
  'eduflow.blockEditor.selfAssessment.panelTitle': 'Self-değerlendirme',
  'eduflow.blockEditor.selfAssessment.removeBadge': 'Kaldır',
  'eduflow.blockEditor.selfAssessment.removeCriterion': 'Kaldır bu criterion',
  'eduflow.blockEditor.selfAssessment.responseTypeLabel': 'Yanıt tür',
  'eduflow.blockEditor.selfAssessment.scaleHint': 'From 1 to N (e.g. 5 = Likert)',
  'eduflow.blockEditor.selfAssessment.scaleLabel': 'Puan scale',
  'eduflow.blockEditor.selfAssessment.starCountHint': 'Sık sık 5',
  'eduflow.blockEditor.selfAssessment.starCountLabel': 'Number of stars',
  'eduflow.blockEditor.selfAssessment.textModeHint': 'Per criterion: ekle rozet seçenekler (seçim) veya ayrıl boş için bir yazıldı cevap. The global yorum stays altında criteria in the player.',
  'eduflow.blockEditor.selfAssessment.typeNumeric': 'Numbers',
  'eduflow.blockEditor.selfAssessment.typeNumericHint': 'Buttons 1 to N',
  'eduflow.blockEditor.selfAssessment.typeStars': 'Stars',
  'eduflow.blockEditor.selfAssessment.typeStarsHint': 'Visual puan',
  'eduflow.blockEditor.selfAssessment.typeText': 'Ücretsiz text',
  'eduflow.blockEditor.selfAssessment.typeTextHint': 'Yazıldı cevap per criterion',
  'eduflow.blockEditor.shared.alignCenter': 'Orta',
  'eduflow.blockEditor.shared.alignLeft': 'Align kalan',
  'eduflow.blockEditor.shared.alignRight': 'Align sağ',
  'eduflow.blockEditor.shared.annotationCount_one': '{{count}} annotation',
  'eduflow.blockEditor.shared.annotationCount_other': '{{count}} annotations',
  'eduflow.blockEditor.shared.blocksCount': '{{count}} bloklar',
  'eduflow.blockEditor.shared.bold': 'Kalın',
  'eduflow.blockEditor.shared.border': 'Kenarlık',
  'eduflow.blockEditor.shared.bulletList': 'Bullet liste',
  'eduflow.blockEditor.shared.cancel': 'İptal',
  'eduflow.blockEditor.shared.choose': 'Choose',
  'eduflow.blockEditor.shared.close': 'Kapat',
  'eduflow.blockEditor.shared.configure': 'Yapılandır',
  'eduflow.blockEditor.shared.delete': 'Sil',
  'eduflow.blockEditor.shared.duplicate': 'Çoğalt',
  'eduflow.blockEditor.shared.imageLabel': 'Görsel',
  'eduflow.blockEditor.shared.italic': 'İtalik',
  'eduflow.blockEditor.shared.layoutPrefix': 'Layout: ',
  'eduflow.blockEditor.shared.linked': 'Linked',
  'eduflow.blockEditor.shared.maxAttempts': 'Max denemeler',
  'eduflow.blockEditor.shared.mediaImage': ' Görsel',
  'eduflow.blockEditor.shared.mediaNone': ' Hayır medya',
  'eduflow.blockEditor.shared.mediaVideo': ' Video',
  'eduflow.blockEditor.shared.minutes': 'Dakika',
  'eduflow.blockEditor.shared.noImage': 'Hayır görsel',
  'eduflow.blockEditor.shared.numberedList': 'Numbered liste',
  'eduflow.blockEditor.shared.option': 'Seçenek',
  'eduflow.blockEditor.shared.pages': '{{count}} sayfalar',
  'eduflow.blockEditor.shared.points': 'Puanlar',
  'eduflow.blockEditor.shared.retry': 'Tekrar Dene',
  'eduflow.blockEditor.shared.rounded': 'Rounded corners',
  'eduflow.blockEditor.shared.save': 'Kaydet',
  'eduflow.blockEditor.shared.selected': 'Seçildi',
  'eduflow.blockEditor.shared.shadow': 'Shadow',
  'eduflow.blockEditor.shared.slideCounter': 'Slide {{index}}/{{toplam}}',
  'eduflow.blockEditor.shared.speedTicks': '{{v}}x',
  'eduflow.blockEditor.shared.strike': 'Strikethrough',
  'eduflow.blockEditor.shared.underline': 'Altı çizili',
  'eduflow.blockEditor.shared.untitledSlide': 'Untitled',
  'eduflow.blockEditor.shared.updatedOn': 'Güncellendi {{tarih}}',
  'eduflow.blockEditor.subflow.emptyPublished': 'Hayır yayınlandı eğitim mevcut',
  'eduflow.blockEditor.subflow.emptySearch': 'Hayır eğitim bulundu',
  'eduflow.blockEditor.subflow.linkedTraining': 'Linked sub-eğitim',
  'eduflow.blockEditor.subflow.loadError': 'Could değil load eğitimler',
  'eduflow.blockEditor.subflow.loading': 'Yükleniyor…',
  'eduflow.blockEditor.subflow.openInTab': 'birç sub-eğitim in bir yeni sekme',
  'eduflow.blockEditor.subflow.remove': 'Kaldır',
  'eduflow.blockEditor.subflow.searchPlaceholder': 'Ara bir yayınlandı eğitim…',
  'eduflow.blockEditor.summary.addItem': 'Ekle bir bullet',
  'eduflow.blockEditor.summary.aiRecapTitle': 'Oluştur bir AI recap from upstream bloklar',
  'eduflow.blockEditor.summary.editorHint': 'Liste concepts veya adımlar seen in the eğitim. Her line appears as bir bullet in the player.',
  'eduflow.blockEditor.summary.emptyList': 'Hayır bullets yet. Ekle one.',
  'eduflow.blockEditor.summary.itemPlaceholder': 'e.g. Workplace fire risks',
  'eduflow.blockEditor.text.audioTts': 'Ses (TTS)',
  'eduflow.blockEditor.text.charWordCount': '{{chars}} characters · {{words}} words',
  'eduflow.blockEditor.text.content': 'İçerik',
  'eduflow.blockEditor.text.contentPlaceholder': 'Gir the text blok içerik…',
  'eduflow.blockEditor.text.formatting': 'Formatting',
  'eduflow.blockEditor.text.headingH1': 'Heading 1',
  'eduflow.blockEditor.text.headingH2': 'Heading 2',
  'eduflow.blockEditor.text.headingH3': 'Heading 3',
  'eduflow.blockEditor.text.headingH4': 'Heading 4',
  'eduflow.blockEditor.text.headingH5': 'Heading 5',
  'eduflow.blockEditor.text.headingH6': 'Heading 6',
  'eduflow.blockEditor.text.headingLevel': 'Heading seviye',
  'eduflow.blockEditor.text.headingParagraph': 'Paragraph',
  'eduflow.blockEditor.text.previewSoon': 'Önizleme (geliyor soon)',
  'eduflow.blockEditor.text.readTime': '~{{min}} min oku',
  'eduflow.blockEditor.text.speedLabel': 'Speed: {{speed}}x',
  'eduflow.blockEditor.text.voice': 'Voice',
  'eduflow.blockEditor.text.voiceAdam': 'Adam (French male)',
  'eduflow.blockEditor.text.voiceBella': 'Bella (French female)',
  'eduflow.blockEditor.text.voiceHeart': 'Heart (French female)',
  'eduflow.blockEditor.text.voiceMichael': 'Michael (English male)',
  'eduflow.blockEditor.text.voiceNova': 'Nova (English female)',
  'eduflow.blockEditor.text.voiceSky': 'Sky (English female)',
  'eduflow.blockEditor.timeline.addEvent': 'Olay',
  'eduflow.blockEditor.timeline.alternatingSides': 'Alternating sides',
  'eduflow.blockEditor.timeline.animatedReveal': 'Animated reveal',
  'eduflow.blockEditor.timeline.colorHint': 'Dot renk (isteğe bağlı)',
  'eduflow.blockEditor.timeline.colorLabel': 'Renk',
  'eduflow.blockEditor.timeline.datePlaceholder': 'Tarih veya period (e.g. 1789, Jan 2024)',
  'eduflow.blockEditor.timeline.descPlaceholder': 'birçıklama (shown ne zaman expanded)',
  'eduflow.blockEditor.timeline.emptyEvents': 'Hayır olaylar yet. Ekle one to build the timeline.',
  'eduflow.blockEditor.timeline.events': 'Olaylar',
  'eduflow.blockEditor.timeline.horizontal': 'Yatay',
  'eduflow.blockEditor.timeline.iconAward': 'Award',
  'eduflow.blockEditor.timeline.iconCheck': 'Kontrol et',
  'eduflow.blockEditor.timeline.iconClock': 'Clock',
  'eduflow.blockEditor.timeline.iconFlag': 'Flag',
  'eduflow.blockEditor.timeline.iconStar': 'Yıldız',
  'eduflow.blockEditor.timeline.moveDown': 'Taşı down',
  'eduflow.blockEditor.timeline.moveUp': 'Taşı up',
  'eduflow.blockEditor.timeline.orientation': 'Orientation',
  'eduflow.blockEditor.timeline.settings': 'Ayarlar',
  'eduflow.blockEditor.timeline.showConnectors': 'Connector lines',
  'eduflow.blockEditor.timeline.titlePlaceholder': 'Olay başlık',
  'eduflow.blockEditor.timeline.untitled': 'Untitled',
  'eduflow.blockEditor.timeline.vertical': 'Dikey',
  'eduflow.blockEditor.videoSubtitles.cancel': 'İptal',
  'eduflow.blockEditor.videoSubtitles.invalidResponse': 'Geçersiz server yanıt.',
  'eduflow.blockEditor.videoSubtitles.invalidUrl': 'Geçersiz track URL.',
  'eduflow.blockEditor.videoSubtitles.loadError': 'Could değil load.',
  'eduflow.blockEditor.videoSubtitles.loadFailed': 'Could değil load track ({{durum}}).',
  'eduflow.blockEditor.videoSubtitles.loading': 'Yükleniyor segments…',
  'eduflow.blockEditor.videoSubtitles.modalSubtitle': 'One blok per screen görünüm. Timing is preserved; sadece text can be düzenlendi.',
  'eduflow.blockEditor.videoSubtitles.modalTitle': 'Düzenle subtitles',
  'eduflow.blockEditor.videoSubtitles.noSegments': 'Hayır readable segments in the subtitle dosya.',
  'eduflow.blockEditor.videoSubtitles.saveFailed': 'Could değil kaydet.',
  'eduflow.blockEditor.videoSubtitles.saveTrack': 'Kaydet track',
  'eduflow.blockEditor.videoSubtitles.savedToast': 'Subtitles kaydedildi',
  'eduflow.blockEditor.videoSubtitles.segmentN': 'Segment {{n}}',
  'eduflow.blockEditor.videoSubtitles.segmentRequiredToast': 'At least one segment ile text is zorunlu.',
  'eduflow.blockEditor.videoSubtitles.trackLang': 'Track dil: {{etiket}}',
  'eduflow.blockEditor.video.autoCaptionSection': 'Otomatik subtitles',
  'eduflow.blockEditor.video.autoCaptionsButton': 'Oluştur subtitles (ses + AI)',
  'eduflow.blockEditor.video.availableSubtitlesChip': 'Subtitles mevcut',
  'eduflow.blockEditor.video.completionThreshold': 'Tamamlanma threshold (%)',
  'eduflow.blockEditor.video.editCueButton': 'Düzenle subtitles (per segment)',
  'eduflow.blockEditor.video.endSeconds': 'Son (sec)',
  'eduflow.blockEditor.video.escHint': 'Esc to kapat',
  'eduflow.blockEditor.video.libraryEmpty': 'Hayır videolar mevcut in sizin library.',
  'eduflow.blockEditor.video.libraryTitle': 'Video library',
  'eduflow.blockEditor.video.libraryHint': 'Seç bir video zaten yüklendi in sizin designer gösterge paneli.',
  'eduflow.blockEditor.video.libraryLoading': 'Yükleniyor videolar…',
  'eduflow.blockEditor.video.optionalEnd': 'İsteğe bağlı',
  'eduflow.blockEditor.video.accent.primary': 'Primary',
  'eduflow.blockEditor.video.aspectFormat': 'Aspect ratio',
  'eduflow.blockEditor.video.aspect.ratio169': '16:9',
  'eduflow.blockEditor.video.aspect.ratio219': '21:9',
  'eduflow.blockEditor.video.aspect.ratio43': '4:3',
  'eduflow.blockEditor.video.aspect.ratio11': '1:1',
  'eduflow.blockEditor.video.pickFromLibrary': 'Seç',
  'eduflow.blockEditor.video.playerBadge': 'Video player',
  'eduflow.blockEditor.video.previewTitleFallback': 'Video player',
  'eduflow.blockEditor.video.reduced': 'Minimize',
  'eduflow.blockEditor.video.regenerateCaptions': 'Regenerate',
  'eduflow.blockEditor.video.previewHint': 'Yükle, YouTube, veya direct URL ile customisable styling.',
  'eduflow.blockEditor.video.previewIframeTitle': 'Video önizleme',
  'eduflow.blockEditor.video.subtitleBadge': 'Altyazılar',
  'eduflow.blockEditor.video.selected': 'Seçildi',
  'eduflow.blockEditor.video.designTab': 'Design',
  'eduflow.blockEditor.video.radius.soft': 'Soft',
  'eduflow.blockEditor.video.radius.rounded': 'Rounded',
  'eduflow.blockEditor.video.radius.square': 'Square',
  'eduflow.blockEditor.video.shadow.soft': 'Soft',
  'eduflow.blockEditor.video.shadow.glow': 'Glow',
  'eduflow.blockEditor.video.shadow.dramatic': 'Dramatic',
  'eduflow.blockEditor.video.shadowLabel': 'Shadow',
  'eduflow.blockEditor.video.radiusCornerLabel': 'Corners',
  'eduflow.blockEditor.video.themeEditorial.desc': 'birçık, clean, institutional',
  'eduflow.blockEditor.video.themeEditorial.label': 'Editorial',
  'eduflow.blockEditor.video.themeCinema.desc': 'Koyu, premium, immersive',
  'eduflow.blockEditor.video.themeCinema.label': 'Cinema',
  'eduflow.blockEditor.video.themeGlass.desc': 'Translucent, modern, bright',
  'eduflow.blockEditor.video.themeGlass.label': 'Glass',
  'eduflow.blockEditor.video.themeApp.desc': 'Varsayılan, aligned ile the mevcut tema',
  'eduflow.blockEditor.video.themeApp.label': 'Uygulama',
  'eduflow.blockEditor.video.themeAccent': 'Accent renk',
  'eduflow.blockEditor.video.themePlayer': 'Player tema',
  'eduflow.blockEditor.video.toast.autoCaptionsError': 'Otomatik subtitles mevcut değil',
  'eduflow.blockEditor.video.toast.autoCaptionsOk': 'Subtitles oluşturuldu',
  'eduflow.blockEditor.video.toast.uploadErrorDesc': 'Içe aktar başarısız.',
  'eduflow.blockEditor.video.toast.uploadErrorTitle': 'Could değil içe aktar',
  'eduflow.blockEditor.video.toast.uploadedDesc': '{{ad}} is ready in sizin video blok.',
  'eduflow.blockEditor.video.toast.uploadedTitle': 'Video içe aktarıldı',
  'eduflow.blockEditor.video.fullscreenExpandTitle': 'birç fullscreen',
  'eduflow.blockEditor.video.fullscreenHeading': 'Video blok',
  'eduflow.blockEditor.video.importDragTitle': 'Içe aktar bir video',
  'eduflow.blockEditor.video.importFormats': 'MP4, WebM, OGG, MOV · max {{maxMb}} MB in the UI',
  'eduflow.blockEditor.video.noneSelected': 'Hayır video seçildi',
  'eduflow.blockEditor.video.playbackTab': 'Playback',
  'eduflow.blockEditor.video.playbackSettingsTitle': 'Playback ayarlar',
  'eduflow.blockEditor.video.loop': 'Loop',
  'eduflow.blockEditor.video.autoplay': 'Autoplay',
  'eduflow.blockEditor.video.mutedStart': 'Muted on başlangıç',
  'eduflow.blockEditor.video.showControls': 'Göster controls',
  'eduflow.blockEditor.video.langTranscriptionTrack': 'Dil (transcription / source track)',
  'eduflow.blockEditor.video.placeholderUrlGeneric': 'https://example.com/video.mp4',
  'eduflow.blockEditor.video.placeholderVimeo': 'https://vimeo.com/…',
  'eduflow.blockEditor.video.placeholderYoutube': 'https://www.youtube.com/izle?v=…',
  'eduflow.blockEditor.video.invalidUrlSource': 'Geçersiz URL için bu source',
  'eduflow.blockEditor.video.urlHelpDirect': 'Works ile direct URLs to bir video dosya.',
  'eduflow.blockEditor.video.labelUrlGeneric': 'Video URL',
  'eduflow.blockEditor.video.labelUrlVimeo': 'Vimeo URL',
  'eduflow.blockEditor.video.labelUrlYoutube': 'YouTube URL',
  'eduflow.blockEditor.video.readyInBlock': 'Video ready in blok',
  'eduflow.blockEditor.video.uploadInProgress': 'Yükle in ilerleme',
  'eduflow.blockEditor.video.sectionSubtitlesDesign': 'Altyazılar',
  'eduflow.blockEditor.video.sourceLabel': 'Video source',
  'eduflow.blockEditor.video.sourceTab': 'Kaynak',
  'eduflow.blockEditor.video.sourceUrl': 'URL',
  'eduflow.blockEditor.video.sourceUpload': 'Dosya',
  'eduflow.blockEditor.video.startSeconds': 'Başlangıç (sec)',
  'eduflow.blockEditor.video.showPlayerHeader': 'Göster player başlık',
  'eduflow.blockEditor.video.accent.amber': 'Amber',
  'eduflow.blockEditor.video.accent.emerald': 'Emerald',
  'eduflow.blockEditor.richText.collapsedHintHtml': 'Minimize editor (HTML mode on)',
  'eduflow.blockEditor.richText.collapsedHintReopen': 'Tıkla to reopen the editor',
  'eduflow.blockEditor.richText.defaultPlaceholder': 'Yaz sizin içerik burada…',
  'eduflow.blockEditor.richText.fullscreenTitleFallback': 'Editör',
  'eduflow.blockEditor.richText.calloutBody': 'Sizin text burada…',
  'eduflow.blockEditor.richText.calloutTitle': 'Highlight başlık',
  'eduflow.blockEditor.richText.fullscreen': 'Tam ekran',
  'eduflow.blockEditor.richText.highlight': 'Highlight',
  'eduflow.blockEditor.richText.imageTab': 'Görsel',
  'eduflow.blockEditor.richText.importTab': 'İçe Aktar',
  'eduflow.blockEditor.richText.infoPanelBody': 'Ekle key bilgi için öğrenciler.',
  'eduflow.blockEditor.richText.infoPanelTitle': 'Good to bil',
  'eduflow.blockEditor.richText.inlineCode': 'Inline code',
  'eduflow.blockEditor.richText.insertBadge': 'Rozet',
  'eduflow.blockEditor.richText.insertCallout': 'Callout',
  'eduflow.blockEditor.richText.insertCalloutCompact': 'Insert callout',
  'eduflow.blockEditor.richText.insertImage': 'Insert görsel',
  'eduflow.blockEditor.richText.insertImageAction': 'Insert görsel',
  'eduflow.blockEditor.richText.insertInfoPanel': 'Bilgi panel',
  'eduflow.blockEditor.richText.insertVideo': 'Insert video',
  'eduflow.blockEditor.richText.insertVideoAction': 'Insert video',
  'eduflow.blockEditor.richText.libraryTab': 'Benim görseller',
  'eduflow.blockEditor.richText.link': 'Bağlantı',
  'eduflow.blockEditor.richText.linkOk': 'OK',
  'eduflow.blockEditor.richText.linkPlaceholderHttps': 'https://…',
  'eduflow.blockEditor.richText.linkPrompt': 'Bağlantı URL:',
  'eduflow.blockEditor.richText.mediaFormatsHint': 'PNG, JPG, GIF, WebP · max 10 MB',
  'eduflow.blockEditor.richText.minimizeToolbar': 'Minimize',
  'eduflow.blockEditor.richText.modalLibraryEmpty': 'Hayır görseller in sizin library',
  'eduflow.blockEditor.richText.modalUploading': 'Yükleniyor…',
  'eduflow.blockEditor.richText.openImportTab': 'Içe aktar bir görsel',
  'eduflow.blockEditor.richText.placeholderImageUrl': 'https://example.com/görsel.jpg',
  'eduflow.blockEditor.richText.placeholderYoutube': 'https://youtube.com/izle?v=…',
  'eduflow.blockEditor.richText.quote': 'Quote',
  'eduflow.blockEditor.richText.redo': 'Yinele',
  'eduflow.blockEditor.richText.separatorRule': 'Divider',
  'eduflow.blockEditor.richText.showHtmlSource': 'Göster / düzenle HTML',
  'eduflow.blockEditor.richText.returnToVisual': 'Return to visual editor',
  'eduflow.blockEditor.richText.tplBadgeLabel': 'Rozet',
  'eduflow.blockEditor.richText.uploadDropPrompt': 'Sürükle ve bırak veya',
  'eduflow.blockEditor.richText.uploadDropClick': 'tıkla to seç',
  'eduflow.blockEditor.richText.heading1': 'Heading 1',
  'eduflow.blockEditor.richText.heading2': 'Heading 2',
  'eduflow.blockEditor.richText.heading3': 'Heading 3',
  'eduflow.blockEditor.richText.justify': 'Justify',
  'eduflow.blockEditor.richText.undo': 'Geri al',
  'eduflow.blockEditor.richText.videoYoutubePaste': 'Paste the YouTube URL altında',
  'eduflow.blockEditor.richText.videoYoutubeToolbar': 'YouTube video',
  'eduflow.blockEditor.richText.urlTab': 'URL',
  'institution.mcp.title': 'MCP — Model Context Protocol',
  'institution.mcp.subtitle': 'Connect Claude, Cursor veya Copilot to sizin eğitim platform',
  'institution.mcp.stats.toolsAvailable': 'Tools mevcut',
  'institution.mcp.stats.activeKeys': 'Aktif keys',
  'institution.mcp.tab.overview': 'Genel Bakış',
  'institution.mcp.tab.keys': 'API keys',
  'institution.mcp.tab.docs': 'Dokümantasyon',
  'institution.mcp.error.openapiLoad': 'Could değil load OpenAPI. Kontrol et o the backend is reachable ve `npm çalıştır openapi:oluştur` has been çalıştır.',
  'institution.mcp.error.nameRequired': 'Ad is zorunlu',
  'institution.mcp.error.create': 'Hata iken oluşturuluyor',
  'institution.mcp.error.delete': 'Hata iken siliniyor',
  'institution.mcp.error.toggle': 'Hata iken toggling',
  'institution.mcp.error.update': 'Hata iken güncelleniyor',
  'institution.mcp.whatIs.title': 'Ne is MCP?',
  'institution.mcp.whatIs.body': 'The Model Context Protocol (MCP) is bir birç standard o lets AI assistants connect directly to sizin platform. Oluştur, düzenle ve yönet eğitim in natural dil from Claude, Cursor veya GitHub Copilot.',
  'institution.mcp.clients.claude.name': 'Claude (Anthropic)',
  'institution.mcp.clients.claude.desc': 'Claude Desktop & claude.ai — native MCP connection',
  'institution.mcp.clients.cursor.name': 'Cursor IDE',
  'institution.mcp.clients.cursor.desc': 'AI IDE ile built-in MCP destek',
  'institution.mcp.clients.copilot.name': 'GitHub Copilot',
  'institution.mcp.clients.copilot.desc': 'Coding assistant ile MCP extensions',
  'institution.mcp.quickStart.title': 'Quick başlangıç',
  'institution.mcp.quickStart.step1Title': 'Oluştur bir API key',
  'institution.mcp.quickStart.step1Desc': 'birç the API keys sekme ve oluştur bir yeni Client ID / Client Secret pair.',
  'institution.mcp.quickStart.step2Title': 'Yapılandır sizin MCP client',
  'institution.mcp.quickStart.step2Desc': 'Paste the yapılandırma altında içine sizin favourite AI client.',
  'institution.mcp.quickStart.step3Title': 'Başlangıç oluşturuluyor',
  'institution.mcp.quickStart.step3Desc': 'Sor sizin AI to oluştur eğitim, yönet katılımcılar, etc.',
  'institution.mcp.serverUrls.title': 'Server URLs',
  'institution.mcp.serverUrls.labelApi': 'API URL',
  'institution.mcp.serverUrls.labelMcp': 'MCP server URL',
  'institution.mcp.serverUrls.mcpHttpNote': 'n8n (MCP Client): kullan bu URL ile bir Başlık auth key ve the aynı başlık ad/value as ne zaman you oluşturuldu it (e.g. X-Lyrra-Api-Key). The URL is sadece served ne zaman the mcp-http Docker service ve repo Nginx proxy (location /mcp) are deployed.',
  'institution.mcp.serverUrls.docTab': 'Dokümantasyon sekme',
  'institution.mcp.serverUrls.swaggerUi': 'Swagger UI',
  'institution.mcp.serverUrls.swaggerSuffix': ' — V1/V2 prefixes, key API endpoints, OpenAPI catalog.',
  'institution.mcp.claudeDesktop.title': 'Claude Desktop yapılandırma',
  'institution.mcp.claudeDesktop.fileHint': 'Dosya: ~/Library/Application Destek/Claude/claude_desktop_config.json',
  'institution.mcp.claudeDesktop.npxIntro': 'Requires Node.js 20+ (npx comes ile npm). Claude Desktop runs the yayınlandı package via npx — hayır local clone veya dist/index.js yol.',
  'institution.mcp.claudeDesktop.footnote': 'Replace LYRRA_CLIENT_ID (prefix shown at key oluşturma) ve LYRRA_CLIENT_SECRET (dolu rak_… secret). Başlık auth: kullan LYRRA_MCP_HEADER_NAME + LYRRA_MCP_HEADER_VALUE bunun yerine (see Dokümantasyon sekme). Isteğe bağlı: LYRRA_ACCESS_TOKEN (JWT). Contributors: to çalıştır from the monorepo, kullan command node ile the absolute yol to apps/mcp-server/dist/index.js sonra npm çalıştır build.',
  'institution.mcp.copyConfig': 'Kopyala',
  'institution.mcp.config.clientIdPlaceholder': 'your_keyPrefix',
  'institution.mcp.config.clientSecretPlaceholder': 'rak_your_full_secret',
  'institution.mcp.claudeWeb.title': 'Claude.ai (Web) yapılandırma',
  'institution.mcp.claudeWeb.intro': 'Connect LyrraOne from the Claude.ai (Anthropic) web app:',
  'institution.mcp.claudeWeb.step1': 'In Claude.ai git to Ayarlar → Entegrasyonlar',
  'institution.mcp.claudeWeb.step2': 'Tıkla “Ekle entegrasyon” sonra “MCP Server”',
  'institution.mcp.claudeWeb.step3': 'Gir the MCP server URL:',
  'institution.mcp.claudeWeb.step4': 'Sign in ile sizin LyrraOne credentials',
  'institution.mcp.claudeWeb.step5': 'The entegrasyon is aktif; tools appear automatically',
  'institution.mcp.claudeWeb.step6': 'Sor Claude to oluştur eğitim, yönet katılımcılar, etc.',
  'institution.mcp.claudeWeb.mcpUrlLabel': 'MCP server URL',
  'institution.mcp.claudeWeb.oauthNote': 'OAuth runs in the browser automatically — hayır API key zorunlu için Claude.ai Web.',
  'institution.mcp.keys.title': 'API keys',
  'institution.mcp.keys.subtitle': 'Client ID + Secret (JWT exchange) veya HTTP Başlık Auth (n8n, automations)',
  'institution.mcp.keys.newKey': 'Yeni key',
  'institution.mcp.keys.empty': 'Hayır API keys yet',
  'institution.mcp.keys.createFirst': 'Oluştur sizin ilk key',
  'institution.mcp.keys.status.active': 'Aktif',
  'institution.mcp.keys.status.inactive': 'Pasif',
  'institution.mcp.keys.status.expired': 'Süresi doldu',
  'institution.mcp.keys.status.expiringSoon': 'Expiring soon',
  'institution.mcp.keys.clientId': 'Client ID:',
  'institution.mcp.keys.clientSecret': 'Client Secret:',
  'institution.mcp.keys.visibleOnce': 'Shown sadece at oluşturma',
  'institution.mcp.keys.designer': 'Designer:',
  'institution.mcp.keys.created': 'Oluşturuldu:',
  'institution.mcp.keys.used': 'Son kullanıldı:',
  'institution.mcp.keys.expires': 'Expires:',
  'institution.mcp.keys.disable': 'Deactivate',
  'institution.mcp.keys.enable': 'Activate',
  'institution.mcp.keys.delete': 'Sil',
  'institution.mcp.keys.modal.createTitle': 'Yeni API key',
  'institution.mcp.keys.modal.authTypeLabel': 'Kimlik doğrulama tür',
  'institution.mcp.keys.modal.authClient': 'Client ID + Secret — Claude Desktop, belirteç exchange (POST /api/auth/api-key/belirteç)',
  'institution.mcp.keys.modal.authHeader': 'HTTP Başlık — aynı secret in bir özel başlık (n8n MCP « Başlık Auth », HTTP nodes)',
  'institution.mcp.keys.modal.headerNameLabel': 'HTTP başlık ad',
  'institution.mcp.keys.modal.headerNamePlaceholder': 'X-Lyrra-Api-Key',
  'institution.mcp.keys.modal.headerNameHint': 'Kullan bu exact ad in sizin client (e.g. n8n credential « Ad »). Letters, digits, hyphen; varsayılan X-Lyrra-Api-Key.',
  'institution.mcp.keys.badge.client': 'Client credentials',
  'institution.mcp.keys.badge.header': 'Başlık auth',
  'institution.mcp.keys.headerNameList': 'Başlık ad:',
  'institution.mcp.keys.modal.createdTitleHeader': 'Başlık API key oluşturuldu',
  'institution.mcp.keys.modal.secretWarningHeader': 'Kopyala the secret value şimdi — it will değil be shown tekrar. In n8n, kullan Başlık Auth ile the başlık ad altında ve bu value.',
  'institution.mcp.keys.modal.fieldHeaderName': 'Başlık ad (n8n « Ad »)',
  'institution.mcp.keys.modal.fieldHeaderValue': 'Secret value (n8n « Value »)',
  'institution.mcp.keys.modal.nameLabel': 'Ad *',
  'institution.mcp.keys.modal.namePlaceholder': 'e.g. MCP Claude Desktop',
  'institution.mcp.keys.modal.expiryLabel': 'Expiry (gün)',
  'institution.mcp.keys.modal.expiryPlaceholder': 'Boş = hayır expiry',
  'institution.mcp.keys.modal.designerLabel': 'Linked designer',
  'institution.mcp.keys.modal.selectDesigner': '— Seç bir designer —',
  'institution.mcp.keys.modal.designerHint': 'The key is attached to bu designer ve accesses onların eğitim.',
  'institution.mcp.keys.modal.createdTitle': 'API key oluşturuldu',
  'institution.mcp.keys.modal.secretWarning': 'Kopyala the Client Secret şimdi — it will değil be shown tekrar.',
  'institution.mcp.keys.modal.fieldClientId': 'Client ID',
  'institution.mcp.keys.modal.fieldClientSecret': 'Client Secret',
  'institution.mcp.keys.modal.doneButton': 'I have kopyalandı benim credentials',
  'institution.mcp.keys.modal.confirmDeleteTitle': 'Onayla silme',
  'institution.mcp.keys.modal.confirmDeleteBody': 'Sil bu API key permanently?',
  'institution.mcp.keys.editOk': 'OK',
  'institution.mcp.docs.apiRestTitle': 'REST API — reference',
  'institution.mcp.docs.apiRestDesc': 'The dolu liste of operations (method + yol) is oluşturuldu from the backend. Kullan Swagger to explore ve dene istekler.',
  'institution.mcp.docs.openSwagger': 'birç Swagger UI',
  'institution.mcp.docs.openapiJson': 'OpenAPI JSON',
  'institution.mcp.docs.healthLink': 'Al /api/health',
  'institution.mcp.docs.v1Title': 'V1 prefixes',
  'institution.mcp.docs.tablePrefix': 'Prefix',
  'institution.mcp.docs.tableRole': 'Rol',
  'institution.mcp.docs.captionV1': 'V1 API prefixes',
  'institution.mcp.docs.v2Title': 'API V2 (kurum)',
  'institution.mcp.docs.captionV2': 'V2 API prefixes',
  'institution.mcp.docs.extraRoutesTitle': 'Useful routes (outside routers)',
  'institution.mcp.docs.keyEndpointsTitle': 'Key API endpoints (HTTP)',
  'institution.mcp.docs.sectionInstitutionKeys': 'Kurum (bu space — API keys sekme)',
  'institution.mcp.docs.sectionUserKeys': 'Designer hesap (Ayarlar → personal keys)',
  'institution.mcp.docs.toolsTitle': 'MCP tools dokümantasyon',
  'institution.mcp.docs.toolsP1': 'Her satır is one backend HTTP operation: the recommended MCP tool ad is the OpenAPI operationId (“Tool” sütun). Descriptions are oluşturuldu on the backend from the router dosya ve auth hints.',
  'institution.mcp.docs.toolsCallout': 'The repo MCP server (apps/mcp-server) registers one tool per OpenAPI operationId at startup. Interactive reference:',
  'institution.mcp.docs.badgeOpenapiOps': '{{count}} OpenAPI operations',
  'institution.mcp.docs.badgeResources': '{{count}} kaynaklar',
  'institution.mcp.docs.badgeModules': '{{count}} modules (etiketler)',
  'institution.mcp.docs.filterLabel': 'Filtrele tools (ad, route, birçıklama)',
  'institution.mcp.docs.filterPlaceholder': 'e.g. eduflows, POST, kurum, operationId…',
  'institution.mcp.docs.loadingCatalog': 'Yükleniyor OpenAPI catalog…',
  'institution.mcp.docs.noFilterMatch': 'Hayır operations match the filtrele.',
  'institution.mcp.docs.envTitle': 'Environment variables (MCP client)',
  'institution.mcp.docs.envCaption': 'MCP variables',
  'institution.mcp.docs.tableVariable': 'Variable',
  'institution.mcp.docs.tableExample': 'Example',
  'institution.mcp.docs.tableNote': 'Değil',
  'institution.mcp.docs.resourcesTitle': 'MCP kaynaklar (URI)',
  'institution.mcp.docs.operationsCount': '{{count}} operations',
  'institution.mcp.docs.tableTool': 'Tool (operationId)',
  'institution.mcp.docs.tableDescription': 'Açıklama',
  'institution.mcp.docs.tableHttp': 'HTTP',
  'institution.mcp.docs.captionTools': 'MCP tools derived from OpenAPI',
  'institution.mcp.never': 'Asla',
  'institution.mcp.resources.blockTypes': 'Returns bir entry puan; per blok-tür docs are in the MCP tools from the local apps/mcp-server (eğitim blok family).',
  'institution.mcp.resources.flowGuide': 'Flow structuring guide — MCP kaynak.',
  'institution.mcp.routes.v1.auth': 'Login, OTP, profil, oturumlar, personal API keys (/me/api-keys)',
  'institution.mcp.routes.v1.projects': 'Creator projeler',
  'institution.mcp.routes.v1.admin': 'Platform administration',
  'institution.mcp.routes.v1.ai': 'AI özellikler',
  'institution.mcp.routes.v1.audio': 'Ses & TTS studio',
  'institution.mcp.routes.v1.video': 'Video',
  'institution.mcp.routes.v1.pdf': 'PDF',
  'institution.mcp.routes.v1.pptx': 'PowerPoint',
  'institution.mcp.routes.v1.eduflows': 'Eğitim yollar (bloklar, yayınlanıyor, paylaşılıyor, versions…)',
  'institution.mcp.routes.v1.eduflowProgress': 'Eğitim ilerleme',
  'institution.mcp.routes.v1.participants': 'Katılımcılar / öğrenciler (designer side)',
  'institution.mcp.routes.v1.store': 'Store & audiobooks',
  'institution.mcp.routes.v1.stripe': 'Stripe payments',
  'institution.mcp.routes.v1.institutions': 'Institutions (main router)',
  'institution.mcp.routes.v1.institutionContent': 'Kurum içerik',
  'institution.mcp.routes.v1.institutionRhDashboard': 'HR gösterge paneli',
  'institution.mcp.routes.v1.institutionTrainingSessions': 'Eğitim oturumlar',
  'institution.mcp.routes.v1.institutionAnalyticsBi': 'Analytics / BI',
  'institution.mcp.routes.v1.institutionDashboard': 'Kurum gösterge paneli (incl. MCP API keys: /api-keys)',
  'institution.mcp.routes.v1.webhooks': 'Web Kancaları',
  'institution.mcp.routes.v1.support': 'Destek',
  'institution.mcp.routes.v1.analytics': 'Analitik',
  'institution.mcp.routes.v1.dashboard': 'Creator gösterge paneli',
  'institution.mcp.routes.v1.public': 'Genel sayfalar',
  'institution.mcp.routes.v1.podcasts': 'Podcastler (+ öğrenci paylaş /öğrenci/paylaş)',
  'institution.mcp.routes.v1.webinars': 'Web Seminerleri',
  'institution.mcp.routes.v1.images': 'Görseller',
  'institution.mcp.routes.v1.userSounds': 'Kullanıcı sesler',
  'institution.mcp.routes.v1.learningPaths': 'Öğrenme Yolları',
  'institution.mcp.routes.v1.tts': 'Text-to-speech',
  'institution.mcp.routes.v1.aiGeneration': 'Eğitim designer AI generation',
  'institution.mcp.routes.v1.pdfExtractor': 'PDF extraction',
  'institution.mcp.routes.v2.campaigns': 'Kampanyalar',
  'institution.mcp.routes.v2.competencies': 'Yetkinlikler',
  'institution.mcp.routes.v2.compliance': 'Uyumluluk',
  'institution.mcp.routes.v2.reporting': 'Reporting',
  'institution.mcp.routes.v2.workflows': 'Workflows',
  'institution.mcp.routes.v2.catalog': 'Katalog',
  'institution.mcp.routes.v2.integrations': 'Entegrasyonlar',
  'institution.mcp.routes.v2.gdpr': 'GDPR',
  'institution.mcp.routes.v2.manager': 'Yönetici area',
  'institution.mcp.extra.eduflowAiChat': 'Designer AI assistant (sohbet)',
  'institution.mcp.extra.eduflowAiDocument': 'Belge context (yükle)',
  'institution.mcp.extra.meGroups': 'Gruplar için the mevcut kurum',
  'institution.mcp.extra.stripeWebhook': 'Stripe webhook (raw JSON body — defined in app.ts)',
  'institution.mcp.extra.podcastLearnerShare': 'Paylaşıldı öğrenci dinle (podcast)',
  'institution.mcp.extra.health': 'Service health',
  'institution.mcp.env.LYRRA_API_URL.example': 'https://sizin-domain/api',
  'institution.mcp.env.LYRRA_API_URL.note': 'Sadece base URL the MCP uses (`…/api`); her tool is bir dolu OpenAPI yol altında it. Ara the aynı `/api` from sizin app için direct REST — hayır separate product URL.',
  'institution.mcp.env.LYRRA_CLIENT_ID.example': 'rak_abc1 (keyPrefix)',
  'institution.mcp.env.LYRRA_CLIENT_ID.note': 'Ile LYRRA_CLIENT_SECRET → exchange POST /api/auth/api-key/belirteç → JWT.',
  'institution.mcp.env.LYRRA_CLIENT_SECRET.example': 'rak_…',
  'institution.mcp.env.LYRRA_CLIENT_SECRET.note': 'Dolu secret shown sadece bir kez ne zaman the key is oluşturuldu.',
  'institution.mcp.env.LYRRA_MCP_HEADER_NAME.example': 'X-Lyrra-Api-Key',
  'institution.mcp.env.LYRRA_MCP_HEADER_NAME.note': 'Ile LYRRA_MCP_HEADER_VALUE — gönder bu başlık on her API ara (header_auth keys sadece). Aliases: LYRRA_HEADER_AUTH_NAME.',
  'institution.mcp.env.LYRRA_MCP_HEADER_VALUE.example': 'rak_… (dolu secret)',
  'institution.mcp.env.LYRRA_MCP_HEADER_VALUE.note': 'Aynı value as shown bir kez ne zaman oluşturuluyor bir Başlık Auth key. Alias: LYRRA_MCP_HEADER_SECRET veya LYRRA_HEADER_AUTH_VALUE.',
  'institution.mcp.env.LYRRA_ACCESS_TOKEN.example': '(JWT)',
  'institution.mcp.env.LYRRA_ACCESS_TOKEN.note': 'Isteğe bağlı — eğer ayarla, kullanıldı directly as Authorization Bearer (hayır key exchange).',
  'institution.mcp.env.LYRRA_OPENAPI_URL.example': 'https://sizin-domain/api/openapi.json',
  'institution.mcp.env.LYRRA_OPENAPI_URL.note': 'Isteğe bağlı — dolu OpenAPI JSON URL eğer farklı from the varsayılan.',
  'institution.mcp.env.LYRRA_MCP_MAX_TOOLS.example': '200',
  'institution.mcp.env.LYRRA_MCP_MAX_TOOLS.note': 'Isteğe bağlı — caps nasıl birçok tools are registered (tests / sınırlı clients).',

  // Training request panel
  'trainingRequest.panelTitle': 'Eğitim talebi — eğitim içerikleri',
  'trainingRequest.intro': 'İhtiyacı açıklayın. İK ekipleri talebi onaylar veya reddeder; onaylanırsa içerik hazırlığına geçer.',
  'trainingRequest.fieldTitle': 'Eğitim başlığı',
  'trainingRequest.fieldDescription': 'İhtiyacın açıklaması',
  'trainingRequest.fieldJustification': 'Gerekçe / hedefler',
  'trainingRequest.fieldDate': 'Tercih edilen tarih',
  'trainingRequest.datePlaceholder': 'ör. Ç2 2026',
  'trainingRequest.fieldFormateur': 'Kurum eğitmeni',
  'trainingRequest.formateurPlaceholder': 'Eğitmen seçin…',
  'trainingRequest.formateursEmpty': 'Kurumunuz için kayıtlı eğitmen hesabı yok.',
  'trainingRequest.titleRequired': 'Bir başlık girin (en az 2 karakter).',
  'trainingRequest.sent': 'Talep kaydedildi. Karar hakkında e-posta ile bilgilendirileceksiniz.',
  'trainingRequest.sendError': 'Talep kaydedilemedi. Bağlantınızı veya izinlerinizi kontrol edin.',
  'trainingRequest.submit': 'Talebi gönder',
};
